import { DateTime } from 'luxon';
import { Big } from 'big.js';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** String representation of an amount of United States dollars. */
  CurrencyUsd: { input: Big; output: Big; }
  /** The ID of a cursor in a page. */
  Cursor: { input: any; output: any; }
  /** String representation of an arbitrary-precision number. */
  Decimal: { input: Big; output: Big; }
  /** A base-64 encoded file sent as input. */
  EncodedFileInput: { input: string; output: string; }
  /** A base-64 encoded file sent as output. */
  EncodedFileOutput: { input: any; output: any; }
  /** An ISO string representation of a IsoDate. */
  IsoDate: { input: DateTime; output: DateTime; }
  /** An object in JSON format. */
  Object: { input: any; output: any; }
  /** An ISO string representation of a timestamp. */
  Timestamp: { input: DateTime; output: DateTime; }
};

export type AccessControlPolicy = {
  __typename?: 'AccessControlPolicy';
  create: Scalars['Boolean']['output'];
  delete: Scalars['Boolean']['output'];
  update: Scalars['Boolean']['output'];
  view: Scalars['Boolean']['output'];
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  formattedFullAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  postalCode: Scalars['String']['output'];
  state: UsState;
  street1: Scalars['String']['output'];
  street2: Scalars['String']['output'];
};

export type Address_Input = {
  city?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  stateId?: InputMaybe<Scalars['ID']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
};

export type Annotation = {
  __typename?: 'Annotation';
  /** Hex code only */
  color: Scalars['String']['output'];
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  page: PageDetail;
  plan: Plan;
  points: Array<AnnotationPoint>;
  /** used in combination with type */
  relatedId?: Maybe<Scalars['ID']['output']>;
  type: AnnotationType;
  updatedAt: Scalars['Timestamp']['output'];
  width: Scalars['Int']['output'];
};

export type AnnotationPoint = {
  __typename?: 'AnnotationPoint';
  id: Scalars['ID']['output'];
  x: Scalars['Decimal']['output'];
  y: Scalars['Decimal']['output'];
};

export type AnnotationType = {
  __typename?: 'AnnotationType';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: AnnotationTypeName;
};

export type AnnotationTypeName =
  | 'arrow'
  | 'box'
  | 'circle'
  | 'file'
  | 'line'
  | 'pencil'
  | 'task';

export type Answer = {
  __typename?: 'Answer';
  createdAt: Scalars['Timestamp']['output'];
  discussion: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  question: Question;
  response: Scalars['String']['output'];
  updatedAt: Scalars['Timestamp']['output'];
};

export type ApiFile = {
  __typename?: 'ApiFile';
  createdTimestamp: Scalars['Timestamp']['output'];
  fileName: Scalars['String']['output'];
  formattedFileSize: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  sizeBytes: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  urlExpiry: Scalars['Timestamp']['output'];
};

export type ApproveDenyDecision_Input = {
  /**
   * if approved is false => person rejected
   * if approved is true => person approved
   */
  approved: Scalars['Boolean']['input'];
  decisionId: Scalars['ID']['input'];
};

export type Area = {
  __typename?: 'Area';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: AreaName;
  standardInstallations: Array<StandardAreaInstallation>;
  subArea: Array<SubArea>;
};

export type AreaName =
  | 'bar'
  | 'bedroom'
  | 'closet'
  | 'clubRoom'
  | 'coveredLoggia'
  | 'diningRoom'
  | 'driveway'
  | 'dropOff'
  | 'elevator'
  | 'firePlace'
  | 'foyerRoom'
  | 'fullBathroom'
  | 'garage'
  | 'gym'
  | 'halfBathroom'
  | 'hallway'
  | 'kitchen'
  | 'landScape'
  | 'laundryRoom'
  | 'livingRoom'
  | 'millwork'
  | 'officeStudy'
  | 'outDoorMillWork'
  | 'outdoorKitchen'
  | 'pantry'
  | 'pathway'
  | 'pool'
  | 'staircase'
  | 'storage'
  | 'tileWallCladding'
  | 'walkway'
  | 'wholeHouse'
  | 'wineRoom'
  | 'woodWallCladding';

export type AuditLogEvent = {
  __typename?: 'AuditLogEvent';
  createdBy?: Maybe<Person>;
  createdTimestamp: Scalars['Timestamp']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type AuthDir_Input = {
  allowedRoles: Array<RoleName>;
};

export type AuthenticationStatus =
  | 'confirmSignUp'
  | 'confirmationCodeRequired'
  | 'registrationRequired'
  | 'signedIn'
  | 'signedOut';

export type ClaimInvite_Input = {
  inviteCode: Scalars['ID']['input'];
};

export type ClientAuthorizationStatus = {
  __typename?: 'ClientAuthorizationStatus';
  accessToken: Scalars['String']['output'];
  authError?: Maybe<Scalars['String']['output']>;
  authStatus: AuthenticationStatus;
  isSuperAdmin: Scalars['Boolean']['output'];
  loggedInUserId: Scalars['String']['output'];
};

export type ClientReport = {
  __typename?: 'ClientReport';
  approvedAt?: Maybe<Scalars['Timestamp']['output']>;
  approvedBy?: Maybe<Person>;
  attachments: Array<ReportAttachment>;
  createdAt: Scalars['Timestamp']['output'];
  deliveries: Array<MetaDelivery>;
  description: Scalars['String']['output'];
  endDate: Scalars['IsoDate']['output'];
  id: Scalars['ID']['output'];
  inspections: Array<MetaInspection>;
  links: Array<ClientReportLink>;
  milestones: Array<MetaMilestone>;
  photos: Array<MetaPhoto>;
  project: Project;
  startDate: Scalars['IsoDate']['output'];
  updatedAt: Scalars['Timestamp']['output'];
};

export type ClientReportLink = {
  __typename?: 'ClientReportLink';
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  notesForClient: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Comment = {
  __typename?: 'Comment';
  createdAt: Scalars['Timestamp']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  person: Person;
};

export type CreateDocuments_Input = {
  apiFileIds: Array<Scalars['ID']['input']>;
  folderId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
};

export type CreateFileReservationInput = {
  fileName: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  sizeBytes: Scalars['Int']['input'];
};

export type CreateMultiPartFileReservationInput = {
  fileName: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  sizeBytes: Scalars['Int']['input'];
  totalParts: Scalars['Int']['input'];
};

export type CreateProjectTemplateMilestones_Input = {
  projectId: Scalars['ID']['input'];
};

export type CreateRooms_Input = {
  areasToCreate?: InputMaybe<Array<ProjectArea_Input>>;
  projectId: Scalars['ID']['input'];
};

export type DailyReport = {
  __typename?: 'DailyReport';
  approvedAt?: Maybe<Scalars['Timestamp']['output']>;
  approvedBy?: Maybe<Person>;
  deliveries: Array<MaterialDelivery>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  incidents: Array<Incident>;
  inspections: Array<Inspection>;
  numberOfDeliveries: Scalars['Int']['output'];
  numberOfIncidents: Scalars['Int']['output'];
  numberOfInspections?: Maybe<Scalars['Int']['output']>;
  numberOfWorkEvents: Scalars['Int']['output'];
  photos: Array<DailyReportPhoto>;
  project: Project;
  reportDate: Scalars['IsoDate']['output'];
  weather: Weather;
  workLog: Array<OnSiteWorkEvent>;
};

export type DailyReportPhoto = {
  __typename?: 'DailyReportPhoto';
  DailyReport: DailyReport;
  apiFile: ApiFile;
  id: Scalars['ID']['output'];
};

export type Decision = {
  __typename?: 'Decision';
  /**
   * if approved is NULL => person has not made decision
   * if approved is false => person rejected
   * if approved is true => person approved
   */
  approved?: Maybe<Scalars['Boolean']['output']>;
  assignee?: Maybe<Person>;
  createdTimestamp: Scalars['Timestamp']['output'];
  /** if approved is not null then decidedBY will not be null */
  decidedBy?: Maybe<Person>;
  /** if approved not null this will show */
  decidedTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  description: Scalars['String']['output'];
  /** date decision should be made on */
  dueDate?: Maybe<Scalars['IsoDate']['output']>;
  id: Scalars['ID']['output'];
  isComplete: Scalars['Boolean']['output'];
  isDueSoon: Scalars['Boolean']['output'];
  isOverdue: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: DecisionType;
};

export type DecisionType = {
  __typename?: 'DecisionType';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: DecisionTypeName;
};

export type DecisionTypeName =
  | 'clientApproveCostEstimate'
  | 'clientSelectionApproval'
  | 'other';

export type Document = {
  __typename?: 'Document';
  apiFile: ApiFile;
  createdTimestamp: Scalars['Timestamp']['output'];
  /** Null indicates stored in root */
  folder?: Maybe<Folder>;
  id: Scalars['ID']['output'];
  project: Project;
  title: Scalars['String']['output'];
  updatedTimestamp: Scalars['Timestamp']['output'];
  /** left as nullable in case they want auto generated files */
  uploadedBy: Person;
};

export type FieldType =
  | 'calendar'
  | 'currency'
  | 'email'
  | 'phone'
  | 'select'
  | 'text'
  | 'upload';

export type FileReservation = {
  __typename?: 'FileReservation';
  apiFile?: Maybe<ApiFile>;
  id: Scalars['ID']['output'];
  signedUploadUrl: Scalars['String']['output'];
};

export type FinalizeMultiPartFileReservationInput = {
  id: Scalars['ID']['input'];
  partList: Array<UploadPartInput>;
  uploadId: Scalars['ID']['input'];
};

export type Folder = Node & {
  __typename?: 'Folder';
  createdTimestamp: Scalars['Timestamp']['output'];
  documents: Array<Document>;
  fileCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<Folder>;
  project: Project;
  updatedTimestamp: Scalars['Timestamp']['output'];
};

export type Incident = {
  __typename?: 'Incident';
  createdOn: Scalars['Timestamp']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issueDate: Scalars['IsoDate']['output'];
  personsInvolved: Array<Person>;
  project: Project;
};

export type Inspection = {
  __typename?: 'Inspection';
  createdAt: Scalars['Timestamp']['output'];
  dateInspected: Scalars['IsoDate']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inspectedBy: Person;
  inspectedSystem: Scalars['String']['output'];
  inspectionResult?: Maybe<InspectionResult>;
  project: Project;
};

export type InspectionResult = {
  __typename?: 'InspectionResult';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: InspectionResultName;
};

export type InspectionResultName =
  | 'approved'
  | 'denied'
  | 'failed'
  | 'other'
  | 'partial'
  | 'passed';

export type Installation = {
  __typename?: 'Installation';
  area: Area;
  associatedDeliveries: Array<MaterialDelivery>;
  blockedBy: Array<Installation>;
  decisions: Array<Decision>;
  /** @deprecated Phasing out as not needed now. For now seems to be captured in Milestone */
  durationInDays: Scalars['Int']['output'];
  /** @deprecated Phasing out as not needed now. For now seems to be captured in Milestone. */
  endDate?: Maybe<Scalars['IsoDate']['output']>;
  /** @deprecated Phasing out as not needed now. */
  estimatedStartDate: Scalars['IsoDate']['output'];
  fullAreaName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inspections: Array<Inspection>;
  installationType: InstallationType;
  isComplete: Scalars['Boolean']['output'];
  isDueSoon: Scalars['Boolean']['output'];
  isOverDue: Scalars['Boolean']['output'];
  milestone?: Maybe<Milestone>;
  name: Scalars['String']['output'];
  plan?: Maybe<Plan>;
  product?: Maybe<Product>;
  purchaseDate?: Maybe<Scalars['IsoDate']['output']>;
  /**
   * This is a temporary patch until we know how deep the change needs to be.
   * Use sparingly will be deprecated within next few releases.
   */
  roomName: Scalars['String']['output'];
  /** @deprecated Phasing out as not needed now. For now seems to be captured in Milestone. */
  startDate?: Maybe<Scalars['IsoDate']['output']>;
  status: InstallationStatus;
  subArea: SubArea;
};

export type InstallationStatus = {
  __typename?: 'InstallationStatus';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: InstallationStatusName;
};

export type InstallationStatusName =
  | 'complete'
  | 'inProgress'
  | 'toDo';

export type InstallationType = {
  __typename?: 'InstallationType';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: InstallationTypeName;
};

export type InstallationTypeName =
  | 'appliance'
  | 'baseBoard'
  | 'bathroomAccessory'
  | 'bathroomTile'
  | 'cabinet'
  | 'cabinetHardware'
  | 'carLift'
  | 'casing'
  | 'coping'
  | 'countertop'
  | 'countertopBackSplash'
  | 'coveredLoggia'
  | 'design'
  | 'door'
  | 'doorHardware'
  | 'driveway'
  | 'equipment'
  | 'exterior'
  | 'firePlaceMedia'
  | 'fireplace'
  | 'floorInsert'
  | 'flooring'
  | 'garageDoor'
  | 'grout'
  | 'interiorShades'
  | 'lightFixture'
  | 'lighting'
  | 'lowVoltage'
  | 'millwork'
  | 'mirror'
  | 'niche'
  | 'other'
  | 'paint'
  | 'plaster'
  | 'plumbingFixture'
  | 'poolAccessory'
  | 'poolDeck'
  | 'shadesAndDrapes'
  | 'showerBench'
  | 'showerDoor'
  | 'staircase'
  | 'surroundSound'
  | 'tile'
  | 'trim'
  | 'vanityHardware'
  | 'walkway'
  | 'wall'
  | 'wallCladding';

export type Invite = {
  __typename?: 'Invite';
  claimantUserId?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  person: Person;
  recipientEmail: Scalars['String']['output'];
};

export type InviteNonUser_Input = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
};

export type Invite_InviteUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  /** IF NULL WILL BE DEFAULT ACCESS */
  roleId: Scalars['ID']['input'];
};

export type Invite_SuperAdminUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type MarkAllNotificationsAsRead_Input = {
  /** if ids is null will mark all notifications for that user as read. IE WILL MARK AS READ FOR ALL PROJECTS if ids are not passed. */
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MaterialDelivery = {
  __typename?: 'MaterialDelivery';
  attachments: Array<ApiFile>;
  createdTimestamp: Scalars['Timestamp']['output'];
  /** Need to add installation to the Delivery */
  damageDescription: Scalars['String']['output'];
  description: Scalars['String']['output'];
  estimatedDeliveryDate?: Maybe<Scalars['IsoDate']['output']>;
  id: Scalars['ID']['output'];
  issueDescription: Scalars['String']['output'];
  name: Scalars['String']['output'];
  otherDescription: Scalars['String']['output'];
  project: Project;
  quantity: Scalars['Int']['output'];
  receivedDate?: Maybe<Scalars['IsoDate']['output']>;
};

export type Membership = {
  __typename?: 'Membership';
  createdTimestamp: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  person: Person;
  project: Project;
  roles: Array<Role>;
};

export type MetaDelivery = {
  __typename?: 'MetaDelivery';
  attachments: Array<ApiFile>;
  createdAt: Scalars['Timestamp']['output'];
  deliveryName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  included: Scalars['Boolean']['output'];
  notesForClient: Scalars['String']['output'];
  receivedDate: Scalars['IsoDate']['output'];
};

export type MetaField = {
  __typename?: 'MetaField';
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options: Array<MetaFieldOptions>;
  type: FieldType;
};

export type MetaFieldOptions = {
  __typename?: 'MetaFieldOptions';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type MetaInspection = {
  __typename?: 'MetaInspection';
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  included: Scalars['Boolean']['output'];
  inspectionName: Scalars['String']['output'];
  inspectionResult: InspectionResult;
  inspectionUpdated: Scalars['IsoDate']['output'];
  inspector: Person;
  notesForClient: Scalars['String']['output'];
};

export type MetaMilestone = {
  __typename?: 'MetaMilestone';
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  included: Scalars['Boolean']['output'];
  milestoneName: Scalars['String']['output'];
  milestoneStatus: MilestoneStatus;
  milestoneUpdated: Scalars['IsoDate']['output'];
  notesForClient: Scalars['String']['output'];
};

export type MetaPhoto = {
  __typename?: 'MetaPhoto';
  attachment?: Maybe<ApiFile>;
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  included: Scalars['Boolean']['output'];
  notesForClient: Scalars['String']['output'];
};

export type Milestone = {
  __typename?: 'Milestone';
  auditLog: Array<AuditLogEvent>;
  /** @deprecated not used in mocks removing */
  decision: Array<Decision>;
  description: Scalars['String']['output'];
  durationInDays: Scalars['Int']['output'];
  endDate?: Maybe<Scalars['IsoDate']['output']>;
  /** @deprecated use startDate */
  estimatedStartDate: Scalars['IsoDate']['output'];
  id: Scalars['ID']['output'];
  /** we will move the inspection milestones to their own type */
  inspections: Array<Inspection>;
  /**
   * if this milestone is related to installations it have an installationType
   * @deprecated not needed
   */
  installationType?: Maybe<InstallationType>;
  installations: Array<Installation>;
  /** If the dates and times change on this milestone the difference will be reflected in all milestones in array below. */
  parentMilestones: Array<Milestone>;
  startDate: Scalars['IsoDate']['output'];
  status: MilestoneStatus;
  title: Scalars['String']['output'];
};

export type MilestoneStatus = {
  __typename?: 'MilestoneStatus';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: MilestoneStatusName;
};

export type MilestoneStatusName =
  | 'awaitingApproval'
  | 'complete'
  | 'inProgress'
  | 'open';

export type MultiPartFileReservation = {
  __typename?: 'MultiPartFileReservation';
  apiFile?: Maybe<ApiFile>;
  id: Scalars['ID']['output'];
  signedUploadUrls?: Maybe<Array<Scalars['String']['output']>>;
  uploadId?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  approveDailyReport?: Maybe<DailyReport>;
  approveDenyDecision?: Maybe<Decision>;
  claimInvite?: Maybe<Person>;
  /** only used for cretae */
  createDocuments?: Maybe<Array<Document>>;
  createFileReservation?: Maybe<FileReservation>;
  createMultipartFileReservation?: Maybe<MultiPartFileReservation>;
  createProjectTemplateMilestones?: Maybe<Array<Milestone>>;
  /**
   * creates group of installations
   * - system does not have Rooms...
   */
  createRooms?: Maybe<Project>;
  deleteDocument: Scalars['ID']['output'];
  deleteFolder?: Maybe<Folder>;
  deleteTask?: Maybe<Scalars['Boolean']['output']>;
  deleteWeeklyReport?: Maybe<Scalars['ID']['output']>;
  duplicateFolder?: Maybe<Folder>;
  finalizeFileReservation?: Maybe<FileReservation>;
  finalizeMultiPartFileReservation?: Maybe<MultiPartFileReservation>;
  inviteNonUser?: Maybe<Invite>;
  inviteSuperAdminUser?: Maybe<Invite>;
  inviteUser?: Maybe<Invite>;
  markAllNotificationsAsRead: Array<Notification>;
  notification_createTestForSelf?: Maybe<Notification>;
  registerSelfDeviceToken: Scalars['Boolean']['output'];
  removeClientReport?: Maybe<Scalars['ID']['output']>;
  removeClientReportAttachment?: Maybe<Scalars['ID']['output']>;
  removeClientReportLink?: Maybe<Scalars['ID']['output']>;
  removeDailyReportPhoto?: Maybe<DailyReportPhoto>;
  removeDecision?: Maybe<Decision>;
  removeDelivery?: Maybe<Scalars['ID']['output']>;
  removeImageFromDelivery?: Maybe<MaterialDelivery>;
  removeIncident?: Maybe<Scalars['ID']['output']>;
  removeInspection?: Maybe<Scalars['ID']['output']>;
  removeInstallation?: Maybe<Scalars['ID']['output']>;
  /** removes all installations of certain type for a project. */
  removeInstallationType: InstallationType;
  removeMembership?: Maybe<Scalars['Boolean']['output']>;
  removeMilestone?: Maybe<Scalars['ID']['output']>;
  removeOnSiteWorkEvent: Scalars['ID']['output'];
  removePlan?: Maybe<Scalars['Boolean']['output']>;
  removePlanSet?: Maybe<PlanSet>;
  removePlanVersion?: Maybe<Plan>;
  removeProject?: Maybe<Scalars['ID']['output']>;
  removeStandardAreaInstallation?: Maybe<StandardAreaInstallation>;
  resetProjectMilestones?: Maybe<Array<Milestone>>;
  saveAnswer?: Maybe<Answer>;
  saveClientReport?: Maybe<ClientReport>;
  saveClientReportAttachment?: Maybe<ReportAttachment>;
  saveClientReportLink?: Maybe<ClientReportLink>;
  saveComment?: Maybe<Comment>;
  saveDailyReport?: Maybe<DailyReport>;
  saveDailyReportPhoto?: Maybe<DailyReportPhoto>;
  saveDecision?: Maybe<Decision>;
  saveDelivery?: Maybe<MaterialDelivery>;
  saveDocument?: Maybe<Document>;
  saveFolder?: Maybe<Folder>;
  saveImageToDelivery?: Maybe<MaterialDelivery>;
  saveIncident?: Maybe<Incident>;
  saveInspection?: Maybe<Inspection>;
  saveInstallation?: Maybe<Installation>;
  /** Mutation will update any incomplete decision due dates that are associated with that decision. If the decisions are updated I will also */
  saveInstallations?: Maybe<Array<Installation>>;
  saveMembership?: Maybe<Membership>;
  saveMetaDelivery?: Maybe<MetaDelivery>;
  saveMetaInspection?: Maybe<MetaInspection>;
  saveMetaMilestone?: Maybe<MetaMilestone>;
  /**
   * This will not allow additional images.
   * will only allow for whether it is included.
   */
  saveMetaPhoto?: Maybe<MetaPhoto>;
  saveMilestone?: Maybe<Milestone>;
  saveNotification?: Maybe<Notification>;
  saveNotificationSetting?: Maybe<NotificationSetting>;
  saveOnSiteWorkEvent?: Maybe<OnSiteWorkEvent>;
  savePerson?: Maybe<Person>;
  savePlan?: Maybe<Plan>;
  savePlanSet?: Maybe<PlanSet>;
  savePlanVersion?: Maybe<PlanVersion>;
  saveProduct?: Maybe<Product>;
  saveProject?: Maybe<Project>;
  saveQuestion?: Maybe<Question>;
  saveStandardAreaInstallation?: Maybe<StandardAreaInstallation>;
  saveTask?: Maybe<Task>;
  saveWeather?: Maybe<Weather>;
  saveWeeklyReport?: Maybe<WeeklyReport>;
  sendDailyNotifications: Scalars['Boolean']['output'];
  siteUser_register?: Maybe<SiteUserFull>;
  siteUser_terminateAccount: Scalars['Boolean']['output'];
};


export type MutationApproveDailyReportArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApproveDenyDecisionArgs = {
  input: ApproveDenyDecision_Input;
};


export type MutationClaimInviteArgs = {
  input: ClaimInvite_Input;
};


export type MutationCreateDocumentsArgs = {
  input: CreateDocuments_Input;
};


export type MutationCreateFileReservationArgs = {
  input: CreateFileReservationInput;
};


export type MutationCreateMultipartFileReservationArgs = {
  input: CreateMultiPartFileReservationInput;
};


export type MutationCreateProjectTemplateMilestonesArgs = {
  input: CreateProjectTemplateMilestones_Input;
};


export type MutationCreateRoomsArgs = {
  input: CreateRooms_Input;
};


export type MutationDeleteDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFolderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaskArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWeeklyReportArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDuplicateFolderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFinalizeFileReservationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFinalizeMultiPartFileReservationArgs = {
  input: FinalizeMultiPartFileReservationInput;
};


export type MutationInviteNonUserArgs = {
  input: InviteNonUser_Input;
};


export type MutationInviteSuperAdminUserArgs = {
  input: Invite_SuperAdminUserInput;
};


export type MutationInviteUserArgs = {
  input: Invite_InviteUserInput;
};


export type MutationMarkAllNotificationsAsReadArgs = {
  input: MarkAllNotificationsAsRead_Input;
};


export type MutationRegisterSelfDeviceTokenArgs = {
  token: Scalars['ID']['input'];
};


export type MutationRemoveClientReportArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveClientReportAttachmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveClientReportLinkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveDailyReportPhotoArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveDecisionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveDeliveryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveImageFromDeliveryArgs = {
  input: RemoveImageFromDelivery_Input;
};


export type MutationRemoveIncidentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveInspectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveInstallationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveInstallationTypeArgs = {
  input: RemoveInstallationType_Input;
};


export type MutationRemoveMembershipArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveMilestoneArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveOnSiteWorkEventArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemovePlanArgs = {
  input: RemovePlan_Input;
};


export type MutationRemovePlanSetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemovePlanVersionArgs = {
  input: RemovePlanVersion_Input;
};


export type MutationRemoveProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveStandardAreaInstallationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResetProjectMilestonesArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSaveAnswerArgs = {
  input: SaveAnswer_Input;
};


export type MutationSaveClientReportArgs = {
  input: SaveClientReport_Input;
};


export type MutationSaveClientReportAttachmentArgs = {
  input: SaveReportAttachment_Input;
};


export type MutationSaveClientReportLinkArgs = {
  input: SaveClientReportLink_Input;
};


export type MutationSaveCommentArgs = {
  input: SaveComment_Input;
};


export type MutationSaveDailyReportArgs = {
  input: SaveDailyReport_Input;
};


export type MutationSaveDailyReportPhotoArgs = {
  input: SaveDailyReportPhoto_Input;
};


export type MutationSaveDecisionArgs = {
  input: SaveDecision_Input;
};


export type MutationSaveDeliveryArgs = {
  input: SaveDelivery_Input;
};


export type MutationSaveDocumentArgs = {
  input: SaveDocumentInput;
};


export type MutationSaveFolderArgs = {
  input: SaveFolderInput;
};


export type MutationSaveImageToDeliveryArgs = {
  input: SaveImageToDelivery_Input;
};


export type MutationSaveIncidentArgs = {
  input: SaveIncident_Input;
};


export type MutationSaveInspectionArgs = {
  input: SaveInspection_Input;
};


export type MutationSaveInstallationArgs = {
  input: SaveInstallation_Input;
};


export type MutationSaveInstallationsArgs = {
  input: SaveInstallations_Input;
};


export type MutationSaveMembershipArgs = {
  input: SaveMembershipInput;
};


export type MutationSaveMetaDeliveryArgs = {
  input: SaveMetaDelivery_Input;
};


export type MutationSaveMetaInspectionArgs = {
  input: SaveMetaInspection_Input;
};


export type MutationSaveMetaMilestoneArgs = {
  input: SaveMetaMilestone_Input;
};


export type MutationSaveMetaPhotoArgs = {
  input: SaveMetaPhoto_Input;
};


export type MutationSaveMilestoneArgs = {
  input: SaveMilestone_Input;
};


export type MutationSaveNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSaveNotificationSettingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSaveOnSiteWorkEventArgs = {
  input: SaveOnSiteWorkEvent_Input;
};


export type MutationSavePersonArgs = {
  input: SavePerson_Input;
};


export type MutationSavePlanArgs = {
  input: SavePlan_Input;
};


export type MutationSavePlanSetArgs = {
  input: SavePlanSet_Input;
};


export type MutationSavePlanVersionArgs = {
  input: SavePlanVersion_Input;
};


export type MutationSaveProductArgs = {
  input: SaveProduct_Input;
};


export type MutationSaveProjectArgs = {
  input: SaveProject_Input;
};


export type MutationSaveQuestionArgs = {
  input: SaveQuestion_Input;
};


export type MutationSaveStandardAreaInstallationArgs = {
  input: SaveStandardAreaInstallation_Input;
};


export type MutationSaveTaskArgs = {
  input: SaveTask_Input;
};


export type MutationSaveWeatherArgs = {
  input: SaveWeather_Input;
};


export type MutationSaveWeeklyReportArgs = {
  input: SaveWeeklyReport_Input;
};


export type MutationSendDailyNotificationsArgs = {
  input: SendDailyNotifications_Input;
};


export type MutationSiteUser_RegisterArgs = {
  input: SiteUser_RegisterInput;
};


export type MutationSiteUser_TerminateAccountArgs = {
  id: Scalars['ID']['input'];
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type Notification = {
  __typename?: 'Notification';
  content: Scalars['String']['output'];
  createdTimestamp: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  /** essentially associated object */
  isRead: Scalars['Boolean']['output'];
  /** leaving as nullable for now.  This */
  payload: NotificationPayload;
  /** Could technically be null if a person record is removed. */
  recipient?: Maybe<Person>;
  title: Scalars['String']['output'];
  triggeredBy?: Maybe<Person>;
  type: NotificationType;
};

export type NotificationPayload = {
  __typename?: 'NotificationPayload';
  /** ID of the gqlEntity that change occurred on. */
  relevantId?: Maybe<Scalars['ID']['output']>;
  /** Used to determine what the id is for. For example "project" or "dailyReport"... */
  typeName?: Maybe<Scalars['String']['output']>;
  /** Used to send link so that can direct to url if needed */
  url?: Maybe<Scalars['String']['output']>;
};

export type NotificationSetting = {
  __typename?: 'NotificationSetting';
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  type: NotificationType;
};

export type NotificationType = {
  __typename?: 'NotificationType';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: NotificationTypeName;
};

export type NotificationTypeName =
  | 'clientReportApproved'
  | 'dailyReportUpdate'
  | 'fileUploaded'
  | 'installationUpcoming'
  | 'planUpdate'
  | 'planUploaded'
  | 'planVersionUploaded'
  | 'taskAssigned'
  | 'taskCreated'
  | 'taskUpdated';

export type OnSiteWorkEvent = {
  __typename?: 'OnSiteWorkEvent';
  dateWorked: Scalars['IsoDate']['output'];
  description: Scalars['String']['output'];
  hoursWorked: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  onSiteSubContractors: Scalars['Int']['output'];
  person: Person;
  project: Project;
  /** nullable for now. */
  trade?: Maybe<WorkTrade>;
};

export type Page = {
  nodes: Array<Node>;
  pageInfo: PageInfo;
};

export type PageDetail = {
  __typename?: 'PageDetail';
  height: Scalars['Int']['output'];
  pageNumber: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  nextPage?: Maybe<Scalars['Cursor']['output']>;
  pages: Array<Scalars['Cursor']['output']>;
  previousPage?: Maybe<Scalars['Cursor']['output']>;
  totalRows: Scalars['Int']['output'];
};

export type PaginationInput = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type Person = {
  __typename?: 'Person';
  address: Address;
  createdTimestamp: Scalars['Timestamp']['output'];
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  memberships: Array<Membership>;
  notificationSettings: Array<NotificationSetting>;
  notifications: Array<Notification>;
  phoneNumber: Scalars['String']['output'];
  preferredEmail: Scalars['String']['output'];
  profilePicture?: Maybe<ApiFile>;
  siteUser?: Maybe<SiteUserFull>;
};

export type Plan = {
  __typename?: 'Plan';
  annotations: Array<Annotation>;
  createdDate: Scalars['IsoDate']['output'];
  documents: Array<Document>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  planSet: PlanSet;
  project: Project;
  tasks: Array<Task>;
  updatedDate: Scalars['IsoDate']['output'];
  versions: Array<PlanVersion>;
};

export type PlanSet = {
  __typename?: 'PlanSet';
  createdAt: Scalars['Timestamp']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  planCount: Scalars['Int']['output'];
  plans: Array<Plan>;
  updatedAt: Scalars['Timestamp']['output'];
};

export type PlanSetName =
  | 'approvedBuildingPlans'
  | 'other';

export type PlanVersion = {
  __typename?: 'PlanVersion';
  createdTimestamp: Scalars['Timestamp']['output'];
  file: ApiFile;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedTimestamp: Scalars['Timestamp']['output'];
  uploadedBy: Person;
};

export type PrecipitationType = {
  __typename?: 'PrecipitationType';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: PrecipitationTypeName;
};

export type PrecipitationTypeName =
  | 'clear'
  | 'hail'
  | 'mixed'
  | 'precipitation'
  | 'rain'
  | 'sleet'
  | 'snow';

export type Product = {
  __typename?: 'Product';
  finish: Scalars['String']['output'];
  hardware: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  manufacturer: Scalars['String']['output'];
  model: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  supplier: Scalars['String']['output'];
};

export type Project = {
  __typename?: 'Project';
  completedTasks: Array<Task>;
  desinger?: Maybe<Person>;
  documents: Array<Document>;
  dueTasks: Array<Task>;
  /** ignore endDate for now. Will adjust as needed when they complete project in order to best match workflow on job. Will most likely be some discrete button to complete project. */
  endDate?: Maybe<Scalars['IsoDate']['output']>;
  /** This will be the same as the date for the last milestone.  If the milestone date adjusts this will adjust as well. */
  estimatedCompletionDate: Scalars['IsoDate']['output'];
  estimatedStartDate: Scalars['IsoDate']['output'];
  folders: Array<Folder>;
  id: Scalars['ID']['output'];
  incidents: Array<Incident>;
  installations: Array<Installation>;
  installationsWithAllDecisionsComplete: Array<Installation>;
  installationsWithDecisionsRemaining: Array<Installation>;
  installationsWithOverDueDecisions: Array<Installation>;
  installationsWithUpcomingDecisions: Array<Installation>;
  locationAddress: Address;
  memberships: Array<Membership>;
  milestones: Array<Milestone>;
  name: Scalars['String']['output'];
  newTasks: Array<Task>;
  overdueTasks: Array<Task>;
  readableId: Scalars['String']['output'];
  rooms: Array<Room>;
  startDate?: Maybe<Scalars['IsoDate']['output']>;
  superIntendent?: Maybe<Person>;
  tasks: Array<Task>;
  totalDeliveries?: Maybe<Scalars['Int']['output']>;
  totalNumberOfIncidents?: Maybe<Scalars['Int']['output']>;
  totalNumberOfInspections?: Maybe<Scalars['Int']['output']>;
  unapprovedDailyReportCount?: Maybe<Scalars['Int']['output']>;
  weeklyReports: Array<WeeklyReport>;
};

export type ProjectArea_Input = {
  areaId: Scalars['ID']['input'];
  areaName: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  annotationTypes: Array<AnnotationType>;
  annotations: Array<Annotation>;
  apiFile?: Maybe<ApiFile>;
  area?: Maybe<Area>;
  areas: Array<Area>;
  authQuery: ClientAuthorizationStatus;
  authStatus?: Maybe<Scalars['String']['output']>;
  clientReport?: Maybe<ClientReport>;
  clientReportLink?: Maybe<ClientReportLink>;
  clientReports: Array<ClientReport>;
  comment?: Maybe<Comment>;
  dailyReport?: Maybe<DailyReport>;
  dailyReports: Array<DailyReport>;
  decision?: Maybe<Decision>;
  decisionTypes?: Maybe<Array<DecisionType>>;
  document?: Maybe<Document>;
  documents: Array<Document>;
  downloadCurrentDataJson?: Maybe<Scalars['String']['output']>;
  entityAccessPolicy: AccessControlPolicy;
  folder?: Maybe<Folder>;
  folders: Array<Folder>;
  incident?: Maybe<Incident>;
  inspection?: Maybe<Inspection>;
  inspectionResults: Array<InspectionResult>;
  installation?: Maybe<Installation>;
  installationStatuses?: Maybe<Array<InstallationStatus>>;
  installationTypes?: Maybe<Array<InstallationType>>;
  installations: Array<Installation>;
  isSuperAdmin: Scalars['Boolean']['output'];
  loggedInUser?: Maybe<SiteUserFull>;
  materialDelivery?: Maybe<MaterialDelivery>;
  membership?: Maybe<Membership>;
  metaDelivery?: Maybe<MetaDelivery>;
  metaInspection?: Maybe<MetaInspection>;
  metaMilestone?: Maybe<MetaMilestone>;
  milestone?: Maybe<Milestone>;
  milestoneStatuses: Array<MilestoneStatus>;
  milestones: Array<Milestone>;
  notifications: Array<Notification>;
  onSiteWorkEvent?: Maybe<OnSiteWorkEvent>;
  person?: Maybe<Person>;
  persons: Array<Person>;
  plan?: Maybe<Plan>;
  planSet?: Maybe<PlanSet>;
  planSets: Array<PlanSet>;
  plans: Array<Plan>;
  precipitationTypes?: Maybe<Array<PrecipitationType>>;
  product?: Maybe<Product>;
  project?: Maybe<Project>;
  projects?: Maybe<Array<Project>>;
  roles: Array<Role>;
  standardAreaInstallation?: Maybe<StandardAreaInstallation>;
  standardAreaInstallations?: Maybe<Array<StandardAreaInstallation>>;
  standardInitialMilestones: Array<StandardTemplateMilestone>;
  standardTemplateMilestones: Array<StandardTemplateMilestone>;
  subAreas?: Maybe<Array<SubArea>>;
  task?: Maybe<Task>;
  taskCategories?: Maybe<Array<TaskCategory>>;
  taskStatuses: Array<TaskStatus>;
  usStates?: Maybe<Array<Maybe<UsState>>>;
  weather?: Maybe<Weather>;
  weatherConditions?: Maybe<Array<WeatherCondition>>;
  weeklyReport?: Maybe<WeeklyReport>;
  workTrades?: Maybe<Array<WorkTrade>>;
};


export type QueryAnnotationsArgs = {
  options: Query_Annotations_OptionsInput;
};


export type QueryApiFileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAreaArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAuthQueryArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryClientReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClientReportLinkArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClientReportsArgs = {
  options: Query_ClientReports_OptionsInput;
};


export type QueryCommentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDailyReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDailyReportsArgs = {
  options: Query_DailyReports_OptionsInput;
};


export type QueryDecisionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentsArgs = {
  options: Query_Documents_OptionsInput;
};


export type QueryDownloadCurrentDataJsonArgs = {
  code: Scalars['String']['input'];
};


export type QueryEntityAccessPolicyArgs = {
  options: Query_EntityAccessPolicy_OptionsInput;
};


export type QueryFolderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFoldersArgs = {
  options: Query_Folders_OptionsInput;
};


export type QueryIncidentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInspectionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInstallationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInstallationsArgs = {
  options: Query_Installations_OptionsInput;
};


export type QueryMaterialDeliveryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMembershipArgs = {
  options: Query_Membership_OptionsInput;
};


export type QueryMetaDeliveryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMetaInspectionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMetaMilestoneArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMilestoneArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMilestonesArgs = {
  options: Query_Milestones_OptionsInput;
};


export type QueryNotificationsArgs = {
  options: Query_Notifications_OptionsInput;
};


export type QueryOnSiteWorkEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPersonArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPersonsArgs = {
  options: Query_Persons_OptionsInput;
};


export type QueryPlanArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlanSetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlanSetsArgs = {
  options: Query_PlanSets_OptionsInput;
};


export type QueryPlansArgs = {
  options: Query_Plans_OptionsInput;
};


export type QueryProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStandardAreaInstallationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStandardInitialMilestonesArgs = {
  area?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWeatherArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWeeklyReportArgs = {
  id: Scalars['ID']['input'];
};

export type Query_Annotations_FilterInput = {
  planId: Scalars['ID']['input'];
};

export type Query_Annotations_OptionsInput = {
  filter: Query_Annotations_FilterInput;
};

export type Query_ClientReports_FilterInput = {
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

export type Query_ClientReports_OptionsInput = {
  filter?: InputMaybe<Query_ClientReports_FilterInput>;
};

export type Query_DailyReports_FilterInput = {
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

export type Query_DailyReports_OptionsInput = {
  filter?: InputMaybe<Query_DailyReports_FilterInput>;
};

export type Query_Documents_FilterInput = {
  folderId?: InputMaybe<Scalars['ID']['input']>;
  omniFreeText?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
};

export type Query_Documents_OptionsInput = {
  filter?: InputMaybe<Query_Documents_FilterInput>;
  paginationInput?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Query_Documents_SortInput>;
};

export type Query_Documents_SortField =
  | 'title';

export type Query_Documents_SortInput = {
  direction: SortDirection;
  field: Query_Documents_SortField;
};

export type Query_EntityAccessPolicy_FilterInput = {
  controllingGroupId?: InputMaybe<Scalars['String']['input']>;
  entityType: Scalars['String']['input'];
};

export type Query_EntityAccessPolicy_OptionsInput = {
  filter?: InputMaybe<Query_EntityAccessPolicy_FilterInput>;
};

export type Query_Folders_FilterInput = {
  omniFreeText?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
};

export type Query_Folders_OptionsInput = {
  filter: Query_Folders_FilterInput;
  paginationInput?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Query_Folders_SortInput>;
};

export type Query_Folders_SortField =
  | 'name';

export type Query_Folders_SortInput = {
  direction: SortDirection;
  field: Query_Folders_SortField;
};

export type Query_Installations_FilterInput = {
  milestoneId?: InputMaybe<Scalars['ID']['input']>;
  omniFreeText?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

export type Query_Installations_OptionsInput = {
  filter?: InputMaybe<Query_Installations_FilterInput>;
  paginationInput?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Query_Installations_SortInput>;
};

export type Query_Installations_SortField =
  | 'name';

export type Query_Installations_SortInput = {
  direction: SortDirection;
  field: Query_Installations_SortField;
};

export type Query_Membership_FilterInput = {
  personId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};

export type Query_Membership_OptionsInput = {
  filter: Query_Membership_FilterInput;
};

export type Query_Milestones_FilterInput = {
  endDate?: InputMaybe<Scalars['IsoDate']['input']>;
  omniFreeText?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['IsoDate']['input']>;
};

/** if not super admin this is required */
export type Query_Milestones_OptionsInput = {
  filter?: InputMaybe<Query_Milestones_FilterInput>;
  paginationInput?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Query_Milestones_SortInput>;
};

export type Query_Milestones_SortField =
  | 'endDate'
  | 'startDate'
  | 'title';

export type Query_Milestones_SortInput = {
  direction: SortDirection;
  field: Query_Milestones_SortField;
};

export type Query_Notifications_FilterInput = {
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Query_Notifications_OptionsInput = {
  filter?: InputMaybe<Query_Notifications_FilterInput>;
};

export type Query_Notifications_SortField =
  | 'content'
  | 'createdTimestamp';

export type Query_Notifications_SortInput = {
  direction: SortDirection;
  field: Query_Notifications_SortField;
};

export type Query_Persons_FilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  omniFreeText?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  roleName?: InputMaybe<RoleName>;
};

export type Query_Persons_OptionsInput = {
  filter: Query_Persons_FilterInput;
  paginationInput?: InputMaybe<PaginationInput>;
};

export type Query_PlanSets_FilterInput = {
  projectId: Scalars['ID']['input'];
};

export type Query_PlanSets_OptionsInput = {
  filter: Query_PlanSets_FilterInput;
};

export type Query_Plans_FilterInput = {
  omniFreeText?: InputMaybe<Scalars['String']['input']>;
  planSetId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['String']['input'];
};

export type Query_Plans_OptionsInput = {
  filter?: InputMaybe<Query_Plans_FilterInput>;
  paginationInput?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Query_Plans_SortInput>;
};

export type Query_Plans_SortField =
  | 'name';

export type Query_Plans_SortInput = {
  direction: SortDirection;
  field: Query_Plans_SortField;
};

export type Question = {
  __typename?: 'Question';
  answer?: Maybe<Answer>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type RemoveImageFromDelivery_Input = {
  deliveryId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
};

export type RemoveInstallationType_Input = {
  projectId: Scalars['ID']['input'];
  typeId: Scalars['ID']['input'];
};

export type RemovePlanVersion_Input = {
  /** Plan Version ID */
  id: Scalars['ID']['input'];
  planId: Scalars['ID']['input'];
};

export type RemovePlan_Input = {
  /** id of the plan that will be removed */
  id: Scalars['ID']['input'];
};

export type RemoveRoleInput = {
  membershipId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
};

export type ReportAttachment = {
  __typename?: 'ReportAttachment';
  attachment?: Maybe<ApiFile>;
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  notesForClient: Scalars['String']['output'];
};

export type Role = {
  __typename?: 'Role';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: RoleName;
};

export type RoleName =
  | 'admin'
  | 'client'
  | 'contractor'
  | 'designer'
  | 'sharedResource'
  | 'staff'
  | 'superIntendent';

export type Room = {
  __typename?: 'Room';
  name: Scalars['String']['output'];
};

export type SaveAnswer_Input = {
  discussion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  questionId?: InputMaybe<Scalars['ID']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
};

export type SaveClientReportLink_Input = {
  /** required for create  */
  clientReportId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  notesForClient?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type SaveClientReport_Input = {
  /** will mark as final */
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** required for create */
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveComment_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** if create will need task id */
  taskId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveDailyReportPhoto_Input = {
  apiFileId: Scalars['ID']['input'];
  dailyReportId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveDailyReport_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * if want to update id is method to do that.
   * API will determine if it can create based on the report date
   */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** required for create */
  projectId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * if report already exists on the date you are trying to create report on will throw error.
   * If you update the report date and another report does not exist on that date it will allow you move the report.
   * If you update the report date IT WILL NOT UPDATE ANY EVENTS ON THAT DATE.
   * The data displayed is based on the date of each item.
   * ---
   * required for create.
   */
  reportDate?: InputMaybe<Scalars['IsoDate']['input']>;
};

export type SaveDecision_Input = {
  /**
   * if approved is false => person rejected
   * if approved is true => person approved
   */
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  decisionTypeId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['IsoDate']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** installationId needed on create */
  installationId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SaveDelivery_Input = {
  damageDescription?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  estimatedDeliveryDate?: InputMaybe<Scalars['IsoDate']['input']>;
  fileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** if creating need to provide the installationId */
  installationId?: InputMaybe<Scalars['ID']['input']>;
  issueDescription?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otherDescription?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  receivedDate?: InputMaybe<Scalars['IsoDate']['input']>;
};

export type SaveDocumentInput = {
  /** required for create */
  apiFileId?: InputMaybe<Scalars['ID']['input']>;
  folderId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** required for create */
  projectId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SaveFolderInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentFolderId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveImageToDelivery_Input = {
  /** If you two different installation ids, it will not remove the file from the first installation. IT would add same file to the second installation. */
  deliveryId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
};

export type SaveIncident_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  issueDate?: InputMaybe<Scalars['IsoDate']['input']>;
  personsInvolvedIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** needed on create */
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveInspection_Input = {
  dateInspected?: InputMaybe<Scalars['IsoDate']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inspectedBy?: InputMaybe<SaveInspectorPerson_Input>;
  inspectedSystem?: InputMaybe<Scalars['String']['input']>;
  inspectionResultId?: InputMaybe<Scalars['ID']['input']>;
  milestoneId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveInspectorPerson_Input = {
  /** if you dont pass id we will use info below to create person */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** if you pass id no need to pass anything else */
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  preferredEmail?: InputMaybe<Scalars['String']['input']>;
};

export type SaveInstallation_Input = {
  /** required on create */
  areaId?: InputMaybe<Scalars['ID']['input']>;
  durationInDays?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['IsoDate']['input']>;
  estimatedStartDate?: InputMaybe<Scalars['IsoDate']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** required on create */
  installationTypeId?: InputMaybe<Scalars['ID']['input']>;
  milestoneId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['ID']['input']>;
  /** on create must past projectID */
  projectId?: InputMaybe<Scalars['ID']['input']>;
  purchaseDate?: InputMaybe<Scalars['IsoDate']['input']>;
  roomName?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['IsoDate']['input']>;
  statusId?: InputMaybe<Scalars['ID']['input']>;
  /** required on create */
  subAreaId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveInstallations_Input = {
  decisionDueDate: Scalars['IsoDate']['input'];
  installationIds: Array<Scalars['ID']['input']>;
};

export type SaveMembershipInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  roles: Array<Scalars['ID']['input']>;
};

export type SaveMetaDelivery_Input = {
  id: Scalars['ID']['input'];
  included?: InputMaybe<Scalars['Boolean']['input']>;
  notesForClient?: InputMaybe<Scalars['String']['input']>;
};

export type SaveMetaInspection_Input = {
  id: Scalars['ID']['input'];
  included?: InputMaybe<Scalars['Boolean']['input']>;
  inspector?: InputMaybe<SavePerson_Input>;
  notesForClient?: InputMaybe<Scalars['String']['input']>;
};

export type SaveMetaMilestone_Input = {
  id: Scalars['ID']['input'];
  included?: InputMaybe<Scalars['Boolean']['input']>;
  notesForClient?: InputMaybe<Scalars['String']['input']>;
};

export type SaveMetaPhoto_Input = {
  apiFileId?: InputMaybe<Scalars['ID']['input']>;
  clientReportId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  included?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveMilestone_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** if update the duration must pass enddate as well */
  durationInDays?: InputMaybe<Scalars['Int']['input']>;
  /** if update the enddate must pass duration as well */
  endDate?: InputMaybe<Scalars['IsoDate']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** if null then will not try to update the existing relationships */
  parentMilestoneIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** if create need to provide the project Id */
  projectId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['IsoDate']['input']>;
  statusId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SaveOnSiteWorkEvent_Input = {
  dateWorked?: InputMaybe<Scalars['IsoDate']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hoursWorked?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  numberOfSiteSubContractors?: InputMaybe<Scalars['Int']['input']>;
  /**
   * This allows us to make sure person is tied to this.
   * We will create a person without a SiteUser.
   * If this person does ever want to join the invite system handles this already.
   */
  person?: InputMaybe<SavePerson_Input>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  tradeId?: InputMaybe<Scalars['ID']['input']>;
};

export type SavePerson_Input = {
  address?: InputMaybe<Address_Input>;
  apiFileId?: InputMaybe<Scalars['ID']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isSuperAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferredEmail?: InputMaybe<Scalars['String']['input']>;
};

export type SavePlanAnnotationPoint_Input = {
  id?: InputMaybe<Scalars['ID']['input']>;
  x: Scalars['Decimal']['input'];
  y: Scalars['Decimal']['input'];
};

export type SavePlanAnnotation_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  pageHeight?: InputMaybe<Scalars['Int']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageWidth?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Array<SavePlanAnnotationPoint_Input>>;
  relatedId?: InputMaybe<Scalars['ID']['input']>;
  /** required for create */
  typeId?: InputMaybe<Scalars['ID']['input']>;
  width?: InputMaybe<Scalars['Decimal']['input']>;
};

export type SavePlanSet_Input = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** required for create */
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

/** add version to a plan */
export type SavePlanVersion_Input = {
  apiFileId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** if you are not passing array from SavePlan_Input then this is required for create. If you pass from the SavePlan_Input then this will be ignored. */
  planId?: InputMaybe<Scalars['ID']['input']>;
};

export type SavePlan_Input = {
  annotations?: InputMaybe<Array<SavePlanAnnotation_Input>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  installationId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** if create will need plan set id */
  planSetId?: InputMaybe<Scalars['ID']['input']>;
  /** if sent this will be added to the plan */
  planVersion?: InputMaybe<SavePlanVersion_Input>;
  /** if create will need projectId */
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveProduct_Input = {
  finish?: InputMaybe<Scalars['String']['input']>;
  hardware?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * if you are creating you have to add the installation ID
   * if you pass the ID no need for the installationID
   */
  installationId?: InputMaybe<Scalars['ID']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
};

export type SaveProjectAddress_Input = {
  city?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  stateId?: InputMaybe<Scalars['ID']['input']>;
  streetOne?: InputMaybe<Scalars['String']['input']>;
  streetTwo?: InputMaybe<Scalars['String']['input']>;
};

export type SaveProject_Input = {
  areasToCreate?: InputMaybe<Array<ProjectArea_Input>>;
  designerPersonId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['IsoDate']['input']>;
  estimatedCompletionDate?: InputMaybe<Scalars['IsoDate']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<SaveProjectAddress_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  readableId?: InputMaybe<Scalars['String']['input']>;
  /** When a project is created, this is used for the 'estimatedStartDate'. When the project is being edited, will be set on the 'actualStartDate'. */
  startDate?: InputMaybe<Scalars['IsoDate']['input']>;
  superIntendentPersonId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveQuestion_Input = {
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  weeklyReportId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveReportAttachment_Input = {
  apiFileId?: InputMaybe<Scalars['ID']['input']>;
  /** required for create */
  clientReportId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notesForClient?: InputMaybe<Scalars['String']['input']>;
};

/** deprecated */
export type SaveReportItemIncluded_Input = {
  id: Scalars['ID']['input'];
  included: Scalars['Boolean']['input'];
};

export type SaveRoleInput = {
  membershipId: Scalars['ID']['input'];
  /** id of the role to add to the membership */
  roleId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveStandardAreaInstallation_Input = {
  areaId?: InputMaybe<Scalars['ID']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  milestoneId?: InputMaybe<Scalars['ID']['input']>;
  subAreaId?: InputMaybe<Scalars['ID']['input']>;
  typeId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveTask_Input = {
  /** apiFile that will be attached to this task */
  apiFileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  areaId?: InputMaybe<Scalars['ID']['input']>;
  assigneePersonId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['IsoDate']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** add projectId if create */
  projectId?: InputMaybe<Scalars['ID']['input']>;
  statusId?: InputMaybe<Scalars['ID']['input']>;
  taskCategoryId?: InputMaybe<Scalars['ID']['input']>;
};

/** ALL FIELDS REQUIRED FOR CREATE */
export type SaveWeather_Input = {
  /** Required for create */
  conditionId?: InputMaybe<Scalars['ID']['input']>;
  /** Required for create */
  dailyReportId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  maxUvIndex?: InputMaybe<Scalars['Int']['input']>;
  precipitationAmount?: InputMaybe<Scalars['Float']['input']>;
  precipitationChange?: InputMaybe<Scalars['Float']['input']>;
  /** Required for create */
  precipitationTypeId?: InputMaybe<Scalars['ID']['input']>;
  snowfallAmount?: InputMaybe<Scalars['Float']['input']>;
  solarNoon?: InputMaybe<Scalars['Timestamp']['input']>;
  sunrise?: InputMaybe<Scalars['Timestamp']['input']>;
  sunset?: InputMaybe<Scalars['Timestamp']['input']>;
  temperatureMax?: InputMaybe<Scalars['Float']['input']>;
  temperatureMin?: InputMaybe<Scalars['Float']['input']>;
};

export type SaveWeeklyReport_Input = {
  id?: InputMaybe<Scalars['ID']['input']>;
  meetingDate?: InputMaybe<Scalars['IsoDate']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  participantPersonIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SendDailyNotifications_Input = {
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SiteUserFull = {
  __typename?: 'SiteUserFull';
  authProviderUserId: Scalars['String']['output'];
  cognitoEmail: Scalars['String']['output'];
  createdTimestamp: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  isSuperAdmin: Scalars['Boolean']['output'];
  person: Person;
};

export type SiteUser_RegisterInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  inviteCode?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferredEmail: Scalars['String']['input'];
};

export type SortDirection =
  | 'ascending'
  | 'descending';

export type StandardAreaInstallation = {
  __typename?: 'StandardAreaInstallation';
  area: Area;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  milestone?: Maybe<StandardTemplateMilestone>;
  name: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
  subArea: SubArea;
  type: InstallationType;
};

export type StandardProjectTemplate = {
  __typename?: 'StandardProjectTemplate';
  templateMilestones: Array<StandardTemplateMilestone>;
};

export type StandardTemplateMilestone = {
  __typename?: 'StandardTemplateMilestone';
  description: Scalars['String']['output'];
  durationFromProjectStartDateInMills: Scalars['String']['output'];
  durationInDays: Scalars['Int']['output'];
  estimatedStartDate: Scalars['IsoDate']['output'];
  id: Scalars['ID']['output'];
  parentMilestones: Array<Milestone>;
  rank: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type SubArea = {
  __typename?: 'SubArea';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: SubAreaName;
};

export type SubAreaName =
  | 'ceiling'
  | 'deck'
  | 'door'
  | 'general'
  | 'island'
  | 'rail'
  | 'shower'
  | 'spa'
  | 'step'
  | 'tread'
  | 'trim'
  | 'vanity'
  | 'wall';

export type Subscription = {
  __typename?: 'Subscription';
  notificationPosted?: Maybe<Notification>;
};

export type Task = {
  __typename?: 'Task';
  area?: Maybe<Area>;
  assignee?: Maybe<Person>;
  attachments: Array<ApiFile>;
  category?: Maybe<TaskCategory>;
  comments: Array<Comment>;
  createdAt: Scalars['Timestamp']['output'];
  createdBy: Person;
  description: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['IsoDate']['output']>;
  id: Scalars['ID']['output'];
  isComplete: Scalars['Boolean']['output'];
  isOverdue: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  status: TaskStatus;
  /** #autogenerated number   */
  taskNumber: Scalars['String']['output'];
};

export type TaskCategory = {
  __typename?: 'TaskCategory';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: TaskCategoryName;
};

export type TaskCategoryName =
  | 'createInspection'
  | 'logEvent';

export type TaskStatus = {
  __typename?: 'TaskStatus';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: TaskStatusName;
};

/** this is just examples for now - will update with actuals */
export type TaskStatusName =
  | 'complete'
  | 'inProgress'
  | 'open';

export type UploadPartInput = {
  eTag: Scalars['String']['input'];
  partNumber: Scalars['Int']['input'];
};

export type UsState = {
  __typename?: 'UsState';
  abbreviation: UsStateAbbreviationName;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type UsStateAbbreviationName =
  | 'AK'
  | 'AL'
  | 'AR'
  | 'AZ'
  | 'CA'
  | 'CO'
  | 'CT'
  | 'DC'
  | 'DE'
  | 'FL'
  | 'GA'
  | 'HI'
  | 'IA'
  | 'ID'
  | 'IL'
  | 'IN'
  | 'KS'
  | 'KY'
  | 'LA'
  | 'MA'
  | 'MD'
  | 'ME'
  | 'MI'
  | 'MN'
  | 'MO'
  | 'MS'
  | 'MT'
  | 'NC'
  | 'ND'
  | 'NE'
  | 'NH'
  | 'NJ'
  | 'NM'
  | 'NV'
  | 'NY'
  | 'OH'
  | 'OK'
  | 'OR'
  | 'PA'
  | 'RI'
  | 'SC'
  | 'SD'
  | 'TN'
  | 'TX'
  | 'UT'
  | 'VA'
  | 'VT'
  | 'WA'
  | 'WI'
  | 'WV'
  | 'WY';

export type Weather = {
  __typename?: 'Weather';
  condition: WeatherCondition;
  id: Scalars['ID']['output'];
  maxUvIndex: Scalars['Int']['output'];
  precipitationAmount: Scalars['Float']['output'];
  precipitationChange: Scalars['Float']['output'];
  precipitationType: PrecipitationType;
  snowfallAmount: Scalars['Float']['output'];
  solarNoon: Scalars['Timestamp']['output'];
  sunrise: Scalars['Timestamp']['output'];
  sunset: Scalars['Timestamp']['output'];
  temperatureMax: Scalars['Float']['output'];
  temperatureMin: Scalars['Float']['output'];
};

export type WeatherCondition = {
  __typename?: 'WeatherCondition';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: WeatherConditionName;
};

export type WeatherConditionName =
  | 'blizzard'
  | 'blowingDust'
  | 'blowingSnow'
  | 'breezy'
  | 'clear'
  | 'cloudy'
  | 'drizzle'
  | 'flurries'
  | 'foggy'
  | 'freezingDrizzle'
  | 'freezingRain'
  | 'frigid'
  | 'hail'
  | 'haze'
  | 'heavyRain'
  | 'heavySnow'
  | 'hot'
  | 'hurricane'
  | 'isolatedThunderstorms'
  | 'mostlyClear'
  | 'mostlyCloudy'
  | 'partlyCloudy'
  | 'rain'
  | 'scatteredThunderstorms'
  | 'sleet'
  | 'smoky'
  | 'snow'
  | 'strongStorms'
  | 'sunFlurries'
  | 'sunShowers'
  | 'thunderstorms'
  | 'tropicalStorm'
  | 'windy'
  | 'wintryMix';

export type WeeklyReport = {
  __typename?: 'WeeklyReport';
  createdBy: Person;
  id: Scalars['ID']['output'];
  meetingDate: Scalars['IsoDate']['output'];
  notes: Scalars['String']['output'];
  participants: Array<Person>;
  questions: Array<Question>;
  title: Scalars['String']['output'];
};

export type WorkTrade = {
  __typename?: 'WorkTrade';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Using string instead of enum to enable us to add more via client side in the future. Reviewing fieldwire, will need to help enforce good inputs only. */
  name: Scalars['String']['output'];
};

export type DashboardActivityQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DashboardActivityQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, overdueTasks: Array<{ __typename?: 'Task', id: string, dueDate?: DateTime | null }>, completedTasks: Array<{ __typename?: 'Task', id: string, dueDate?: DateTime | null }>, tasks: Array<{ __typename?: 'Task', id: string, dueDate?: DateTime | null, isOverdue: boolean, isComplete: boolean, status: { __typename?: 'TaskStatus', id: string, name: TaskStatusName, displayName: string } }> } | null };

export type GetInstallationFullQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetInstallationFullQuery = { __typename?: 'Query', installation?: { __typename?: 'Installation', id: string, name: string, roomName: string, estimatedStartDate: DateTime, status: { __typename?: 'InstallationStatus', id: string, name: InstallationStatusName, displayName: string }, area: { __typename?: 'Area', id: string, name: AreaName, displayName: string }, subArea: { __typename?: 'SubArea', id: string, name: SubAreaName, displayName: string }, product?: { __typename?: 'Product', id: string, name: string, supplier: string, manufacturer: string, model: string, hardware: string, finish: string, notes: string } | null, decisions: Array<{ __typename?: 'Decision', id: string, dueDate?: DateTime | null }>, installationType: { __typename?: 'InstallationType', id: string, name: InstallationTypeName, displayName: string }, plan?: { __typename?: 'Plan', id: string, name: string } | null } | null };

export type NotificationPostedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NotificationPostedSubscription = { __typename?: 'Subscription', notificationPosted?: { __typename?: 'Notification', id: string, isRead: boolean, title: string, content: string } | null };

export type ApiFileFieldsFragment = { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string };

export type PlanVersionFieldsFragment = { __typename?: 'PlanVersion', id: string, createdTimestamp: DateTime, name: string, uploadedBy: { __typename?: 'Person', id: string, fullName: string }, file: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } };

export type AddressFieldsFragment = { __typename?: 'Address', id: string, street1: string, street2: string, city: string, postalCode: string, formattedFullAddress: string, state: { __typename?: 'UsState', id: string, name: string, displayName: string, abbreviation: UsStateAbbreviationName } };

export type CreateFileMultiPartReservationMutationVariables = Exact<{
  input: CreateMultiPartFileReservationInput;
}>;


export type CreateFileMultiPartReservationMutation = { __typename?: 'Mutation', createMultipartFileReservation?: { __typename?: 'MultiPartFileReservation', id: string, signedUploadUrls?: Array<string> | null, uploadId?: string | null } | null };

export type FinalizeFileMultiPartReservationMutationVariables = Exact<{
  input: FinalizeMultiPartFileReservationInput;
}>;


export type FinalizeFileMultiPartReservationMutation = { __typename?: 'Mutation', finalizeMultiPartFileReservation?: { __typename?: 'MultiPartFileReservation', id: string, apiFile?: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } | null } | null };

export type GetAccessPolicyQueryVariables = Exact<{
  options: Query_EntityAccessPolicy_OptionsInput;
}>;


export type GetAccessPolicyQuery = { __typename?: 'Query', loggedInUser?: { __typename?: 'SiteUserFull', id: string, isSuperAdmin: boolean } | null, entityAccessPolicy: { __typename?: 'AccessControlPolicy', create: boolean, update: boolean, view: boolean, delete: boolean } };

export type CreateFileReservationMutationVariables = Exact<{
  input: CreateFileReservationInput;
}>;


export type CreateFileReservationMutation = { __typename?: 'Mutation', createFileReservation?: { __typename?: 'FileReservation', id: string, signedUploadUrl: string } | null };

export type FinalizeFileReservationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FinalizeFileReservationMutation = { __typename?: 'Mutation', finalizeFileReservation?: { __typename?: 'FileReservation', id: string, apiFile?: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } | null } | null };

export type AuthStateQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthStateQuery = { __typename?: 'Query', authQuery: { __typename?: 'ClientAuthorizationStatus', authStatus: AuthenticationStatus } };

export type GetMembershipsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMembershipsQuery = { __typename?: 'Query', loggedInUser?: { __typename?: 'SiteUserFull', id: string, isSuperAdmin: boolean, person: { __typename?: 'Person', id: string, memberships: Array<{ __typename?: 'Membership', id: string, roles: Array<{ __typename?: 'Role', id: string, name: RoleName, displayName: string }>, project: { __typename?: 'Project', id: string } }> } } | null };

export type StyledFileUploadFieldQueryVariables = Exact<{
  apiFileId: Scalars['ID']['input'];
}>;


export type StyledFileUploadFieldQuery = { __typename?: 'Query', apiFile?: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } | null };

export type StyledPhotoUploadFieldQueryVariables = Exact<{
  apiFileId: Scalars['ID']['input'];
}>;


export type StyledPhotoUploadFieldQuery = { __typename?: 'Query', apiFile?: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } | null };

export type NotificationSubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NotificationSubscriptionSubscription = { __typename?: 'Subscription', notificationPosted?: { __typename?: 'Notification', id: string, isRead: boolean, title: string, content: string } | null };

export type NotificationWidgetQueryVariables = Exact<{
  options: Query_Notifications_OptionsInput;
}>;


export type NotificationWidgetQuery = { __typename?: 'Query', notifications: Array<{ __typename?: 'Notification', id: string, title: string, content: string, isRead: boolean, createdTimestamp: DateTime }> };

export type SaveNotificationWidgetMutationVariables = Exact<{
  input: MarkAllNotificationsAsRead_Input;
}>;


export type SaveNotificationWidgetMutation = { __typename?: 'Mutation', markAllNotificationsAsRead: Array<{ __typename?: 'Notification', id: string, isRead: boolean, title: string, content: string, createdTimestamp: DateTime }> };

export type OrganizationNavBarQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrganizationNavBarQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, name: string } | null, loggedInUser?: { __typename?: 'SiteUserFull', id: string, isSuperAdmin: boolean } | null };

export type InspectionResultSelectFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type InspectionResultSelectFieldQuery = { __typename?: 'Query', inspectionResults: Array<{ __typename?: 'InspectionResult', id: string, name: InspectionResultName, displayName: string }> };

export type GetPlanSetsQueryVariables = Exact<{
  options: Query_PlanSets_OptionsInput;
}>;


export type GetPlanSetsQuery = { __typename?: 'Query', planSets: Array<{ __typename?: 'PlanSet', id: string, name: string, displayName: string }> };

export type SelectFolderQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type SelectFolderQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, folders: Array<{ __typename?: 'Folder', id: string, name: string }> } | null };

export type SelectInspectorFieldQueryVariables = Exact<{
  options: Query_Persons_OptionsInput;
}>;


export type SelectInspectorFieldQuery = { __typename?: 'Query', persons: Array<{ __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string }> };

export type GetAllAreasQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAreasQuery = { __typename?: 'Query', areas: Array<{ __typename?: 'Area', id: string, name: AreaName, displayName: string }> };

export type SelectInstallationRoomFieldQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SelectInstallationRoomFieldQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, rooms: Array<{ __typename?: 'Room', name: string }>, installations: Array<{ __typename?: 'Installation', id: string, roomName: string }> } | null };

export type GetAllInstallationStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllInstallationStatusesQuery = { __typename?: 'Query', installationStatuses?: Array<{ __typename?: 'InstallationStatus', id: string, name: InstallationStatusName, displayName: string }> | null };

export type GetAllInstallationTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllInstallationTypesQuery = { __typename?: 'Query', installationTypes?: Array<{ __typename?: 'InstallationType', id: string, name: InstallationTypeName, displayName: string }> | null };

export type SelectMilestoneFieldQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SelectMilestoneFieldQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, milestones: Array<{ __typename?: 'Milestone', id: string, title: string }> } | null };

export type SelectPersonFieldQueryVariables = Exact<{
  options: Query_Persons_OptionsInput;
}>;


export type SelectPersonFieldQuery = { __typename?: 'Query', persons: Array<{ __typename?: 'Person', id: string, firstName: string, lastName: string, createdTimestamp: DateTime, preferredEmail: string, phoneNumber: string, isActive: boolean, fullName: string, profilePicture?: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } | null }> };

export type SelectPersonInWorkEventFieldQueryVariables = Exact<{
  options: Query_Persons_OptionsInput;
}>;


export type SelectPersonInWorkEventFieldQuery = { __typename?: 'Query', persons: Array<{ __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string }> };

export type SelectPersonsInIncidentFieldQueryVariables = Exact<{
  options: Query_Persons_OptionsInput;
}>;


export type SelectPersonsInIncidentFieldQuery = { __typename?: 'Query', persons: Array<{ __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string, profilePicture?: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } | null }> };

export type SelectPlanFieldQueryVariables = Exact<{
  options: Query_Plans_OptionsInput;
}>;


export type SelectPlanFieldQuery = { __typename?: 'Query', plans: Array<{ __typename?: 'Plan', id: string, name: string }> };

export type SavePlanVersionMutationVariables = Exact<{
  input: SavePlanVersion_Input;
}>;


export type SavePlanVersionMutation = { __typename?: 'Mutation', savePlanVersion?: { __typename?: 'PlanVersion', id: string, createdTimestamp: DateTime, name: string, uploadedBy: { __typename?: 'Person', id: string, fullName: string }, file: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } } | null };

export type SelectPlanVersionFieldQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SelectPlanVersionFieldQuery = { __typename?: 'Query', plan?: { __typename?: 'Plan', id: string, versions: Array<{ __typename?: 'PlanVersion', id: string, createdTimestamp: DateTime, name: string, uploadedBy: { __typename?: 'Person', id: string, fullName: string }, file: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } }> } | null };

export type SelectPrecipitationTypeFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectPrecipitationTypeFieldQuery = { __typename?: 'Query', precipitationTypes?: Array<{ __typename?: 'PrecipitationType', id: string, name: PrecipitationTypeName, displayName: string }> | null };

export type SelectRoleFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectRoleFieldQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'Role', id: string, name: RoleName, displayName: string }> };

export type SelectStandardTemplateMilestoneFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectStandardTemplateMilestoneFieldQuery = { __typename?: 'Query', standardTemplateMilestones: Array<{ __typename?: 'StandardTemplateMilestone', id: string, title: string }> };

export type SelectSubAreaFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectSubAreaFieldQuery = { __typename?: 'Query', subAreas?: Array<{ __typename?: 'SubArea', id: string, name: SubAreaName, displayName: string }> | null };

export type SelectTaskAssigneeFieldQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SelectTaskAssigneeFieldQuery = { __typename?: 'Query', persons: Array<{ __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string }> };

export type SelectTaskCategoryFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectTaskCategoryFieldQuery = { __typename?: 'Query', taskCategories?: Array<{ __typename?: 'TaskCategory', id: string, name: TaskCategoryName, displayName: string }> | null };

export type SelectWeatherConditionFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectWeatherConditionFieldQuery = { __typename?: 'Query', weatherConditions?: Array<{ __typename?: 'WeatherCondition', id: string, name: WeatherConditionName, displayName: string }> | null };

export type SelectWorkTradeFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectWorkTradeFieldQuery = { __typename?: 'Query', workTrades?: Array<{ __typename?: 'WorkTrade', id: string, name: string, displayName: string }> | null };

export type FolderQrCodeQueryVariables = Exact<{
  folderId: Scalars['ID']['input'];
}>;


export type FolderQrCodeQuery = { __typename?: 'Query', folder?: { __typename?: 'Folder', id: string, name: string, project: { __typename?: 'Project', id: string, name: string } } | null };

export type PdfViewerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PdfViewerQuery = { __typename?: 'Query', apiFile?: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } | null };

export type ApproveDailyReportMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ApproveDailyReportMutation = { __typename?: 'Mutation', approveDailyReport?: { __typename?: 'DailyReport', id: string, approvedAt?: DateTime | null, approvedBy?: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string } | null } | null };

export type CreateDocumentsMutationVariables = Exact<{
  input: CreateDocuments_Input;
}>;


export type CreateDocumentsMutation = { __typename?: 'Mutation', createDocuments?: Array<{ __typename?: 'Document', id: string, createdTimestamp: DateTime, updatedTimestamp: DateTime, title: string, folder?: { __typename?: 'Folder', id: string, fileCount: number, name: string, createdTimestamp: DateTime, updatedTimestamp: DateTime } | null, uploadedBy: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string }, apiFile: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } }> | null };

export type CreateRoomsMutationVariables = Exact<{
  input: CreateRooms_Input;
}>;


export type CreateRoomsMutation = { __typename?: 'Mutation', createRooms?: { __typename?: 'Project', id: string, estimatedStartDate: DateTime, startDate?: DateTime | null, name: string, estimatedCompletionDate: DateTime, locationAddress: { __typename?: 'Address', id: string, street1: string, street2: string, city: string, postalCode: string, formattedFullAddress: string, state: { __typename?: 'UsState', id: string, name: string, displayName: string, abbreviation: UsStateAbbreviationName } }, memberships: Array<{ __typename?: 'Membership', id: string }>, tasks: Array<{ __typename?: 'Task', id: string }>, installations: Array<{ __typename?: 'Installation', id: string, startDate?: DateTime | null, name: string, roomName: string }>, milestones: Array<{ __typename?: 'Milestone', id: string, title: string, estimatedStartDate: DateTime, startDate: DateTime }> } | null };

export type InviteNonUserMutationVariables = Exact<{
  input: InviteNonUser_Input;
}>;


export type InviteNonUserMutation = { __typename?: 'Mutation', inviteNonUser?: { __typename?: 'Invite', id: string, person: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string, memberships: Array<{ __typename?: 'Membership', id: string, roles: Array<{ __typename?: 'Role', id: string, name: RoleName, displayName: string }> }> } } | null };

export type InvitePersonMutationVariables = Exact<{
  input: Invite_InviteUserInput;
}>;


export type InvitePersonMutation = { __typename?: 'Mutation', inviteUser?: { __typename?: 'Invite', id: string, person: { __typename?: 'Person', id: string, firstName: string, lastName: string, phoneNumber: string, preferredEmail: string, createdTimestamp: DateTime, fullName: string, profilePicture?: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } | null } } | null };

export type RegisterMutationVariables = Exact<{
  input: SiteUser_RegisterInput;
}>;


export type RegisterMutation = { __typename?: 'Mutation', siteUser_register?: { __typename?: 'SiteUserFull', id: string, person: { __typename?: 'Person', id: string, isActive: boolean, firstName: string, lastName: string, fullName: string, memberships: Array<{ __typename?: 'Membership', id: string, createdTimestamp: DateTime, project: { __typename?: 'Project', id: string } }> } } | null };

export type RemoveClientReportMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveClientReportMutation = { __typename?: 'Mutation', removeClientReport?: string | null };

export type RemoveDecisionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveDecisionMutation = { __typename?: 'Mutation', removeDecision?: { __typename?: 'Decision', id: string } | null };

export type RemoveIncidentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveIncidentMutation = { __typename?: 'Mutation', removeIncident?: string | null };

export type RemoveInspectionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveInspectionMutation = { __typename?: 'Mutation', removeInspection?: string | null };

export type RemoveInstallationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveInstallationMutation = { __typename?: 'Mutation', removeInstallation?: string | null };

export type RemoveMembershipMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveMembershipMutation = { __typename?: 'Mutation', removeMembership?: boolean | null };

export type RemoveMilestoneMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveMilestoneMutation = { __typename?: 'Mutation', removeMilestone?: string | null };

export type RemovePlanMutationVariables = Exact<{
  input: RemovePlan_Input;
}>;


export type RemovePlanMutation = { __typename?: 'Mutation', removePlan?: boolean | null };

export type RemovePlanSetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemovePlanSetMutation = { __typename?: 'Mutation', removePlanSet?: { __typename?: 'PlanSet', id: string } | null };

export type RemoveProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveProjectMutation = { __typename?: 'Mutation', removeProject?: string | null };

export type RemoveStandardAreaInstallationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveStandardAreaInstallationMutation = { __typename?: 'Mutation', removeStandardAreaInstallation?: { __typename?: 'StandardAreaInstallation', id: string } | null };

export type ClientReportFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ClientReportFormQuery = { __typename?: 'Query', clientReport?: { __typename?: 'ClientReport', id: string, description: string, approvedAt?: DateTime | null } | null };

export type SaveClientReportMutationVariables = Exact<{
  input: SaveClientReport_Input;
}>;


export type SaveClientReportMutation = { __typename?: 'Mutation', saveClientReport?: { __typename?: 'ClientReport', id: string, createdAt: DateTime, updatedAt: DateTime, startDate: DateTime, endDate: DateTime, description: string, approvedAt?: DateTime | null, milestones: Array<{ __typename?: 'MetaMilestone', id: string }>, inspections: Array<{ __typename?: 'MetaInspection', id: string }>, photos: Array<{ __typename?: 'MetaPhoto', id: string }>, links: Array<{ __typename?: 'ClientReportLink', id: string }>, attachments: Array<{ __typename?: 'ReportAttachment', id: string }>, deliveries: Array<{ __typename?: 'MetaDelivery', id: string }>, approvedBy?: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string } | null } | null };

export type ClientReportLinkFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ClientReportLinkFormQuery = { __typename?: 'Query', clientReportLink?: { __typename?: 'ClientReportLink', id: string, createdAt: DateTime, notesForClient: string, url: string } | null };

export type SaveClientReportLinkMutationVariables = Exact<{
  input: SaveClientReportLink_Input;
}>;


export type SaveClientReportLinkMutation = { __typename?: 'Mutation', saveClientReportLink?: { __typename?: 'ClientReportLink', id: string, createdAt: DateTime, notesForClient: string, url: string } | null };

export type SaveCommentMutationVariables = Exact<{
  input: SaveComment_Input;
}>;


export type SaveCommentMutation = { __typename?: 'Mutation', saveComment?: { __typename?: 'Comment', id: string, createdAt: DateTime, description: string, person: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string } } | null };

export type DailyReportFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DailyReportFormQuery = { __typename?: 'Query', dailyReport?: { __typename?: 'DailyReport', id: string, reportDate: DateTime, description: string, project: { __typename?: 'Project', id: string } } | null };

export type SaveDailyReportMutationVariables = Exact<{
  input: SaveDailyReport_Input;
}>;


export type SaveDailyReportMutation = { __typename?: 'Mutation', saveDailyReport?: { __typename?: 'DailyReport', id: string, description: string, reportDate: DateTime, approvedAt?: DateTime | null, numberOfIncidents: number, numberOfDeliveries: number, numberOfInspections?: number | null, numberOfWorkEvents: number, incidents: Array<{ __typename?: 'Incident', id: string }>, inspections: Array<{ __typename?: 'Inspection', id: string }>, deliveries: Array<{ __typename?: 'MaterialDelivery', id: string }>, workLog: Array<{ __typename?: 'OnSiteWorkEvent', id: string }>, approvedBy?: { __typename?: 'Person', id: string, firstName: string, lastName: string, phoneNumber: string, preferredEmail: string, fullName: string, profilePicture?: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } | null } | null } | null };

export type SaveDailyReportPhotoMutationVariables = Exact<{
  input: SaveDailyReportPhoto_Input;
}>;


export type SaveDailyReportPhotoMutation = { __typename?: 'Mutation', saveDailyReportPhoto?: { __typename?: 'DailyReportPhoto', id: string } | null };

export type GetDecisionDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDecisionDetailQuery = { __typename?: 'Query', decision?: { __typename?: 'Decision', id: string, dueDate?: DateTime | null, title: string, description: string, approved?: boolean | null, type: { __typename?: 'DecisionType', id: string, name: DecisionTypeName, displayName: string }, assignee?: { __typename?: 'Person', id: string, fullName: string } | null } | null };

export type SaveDecisionMutationVariables = Exact<{
  input: SaveDecision_Input;
}>;


export type SaveDecisionMutation = { __typename?: 'Mutation', saveDecision?: { __typename?: 'Decision', id: string, title: string, description: string, dueDate?: DateTime | null, approved?: boolean | null, isOverdue: boolean, isComplete: boolean, isDueSoon: boolean, decidedTimestamp?: DateTime | null, type: { __typename?: 'DecisionType', id: string, name: DecisionTypeName, displayName: string } } | null };

export type GetDeliveryDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDeliveryDetailQuery = { __typename?: 'Query', materialDelivery?: { __typename?: 'MaterialDelivery', id: string, createdTimestamp: DateTime, estimatedDeliveryDate?: DateTime | null, receivedDate?: DateTime | null, name: string, description: string, quantity: number, damageDescription: string, issueDescription: string, otherDescription: string, attachments: Array<{ __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string }> } | null };

export type RemoveDeliveryAttachmentMutationVariables = Exact<{
  input: RemoveImageFromDelivery_Input;
}>;


export type RemoveDeliveryAttachmentMutation = { __typename?: 'Mutation', removeImageFromDelivery?: { __typename: 'MaterialDelivery', id: string, receivedDate?: DateTime | null, name: string, description: string, quantity: number, damageDescription: string, issueDescription: string, otherDescription: string, estimatedDeliveryDate?: DateTime | null, createdTimestamp: DateTime, attachments: Array<{ __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string }> } | null };

export type SaveDeliveryMutationVariables = Exact<{
  input: SaveDelivery_Input;
}>;


export type SaveDeliveryMutation = { __typename?: 'Mutation', saveDelivery?: { __typename: 'MaterialDelivery', id: string, receivedDate?: DateTime | null, name: string, description: string, quantity: number, damageDescription: string, issueDescription: string, otherDescription: string, estimatedDeliveryDate?: DateTime | null, createdTimestamp: DateTime, attachments: Array<{ __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string }> } | null };

export type SaveDocumentMutationVariables = Exact<{
  input: SaveDocumentInput;
}>;


export type SaveDocumentMutation = { __typename?: 'Mutation', saveDocument?: { __typename?: 'Document', id: string, createdTimestamp: DateTime, updatedTimestamp: DateTime, title: string, folder?: { __typename?: 'Folder', id: string, fileCount: number, name: string, createdTimestamp: DateTime, updatedTimestamp: DateTime } | null, uploadedBy: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string }, apiFile: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } } | null };

export type SaveDocumentFieldsFragment = { __typename?: 'Document', id: string, createdTimestamp: DateTime, updatedTimestamp: DateTime, title: string, folder?: { __typename?: 'Folder', id: string, fileCount: number, name: string, createdTimestamp: DateTime, updatedTimestamp: DateTime } | null, uploadedBy: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string }, apiFile: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } };

export type SaveDocumentFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SaveDocumentFormQuery = { __typename?: 'Query', document?: { __typename?: 'Document', id: string, createdTimestamp: DateTime, updatedTimestamp: DateTime, title: string, folder?: { __typename?: 'Folder', id: string, fileCount: number, name: string, createdTimestamp: DateTime, updatedTimestamp: DateTime } | null, uploadedBy: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string }, apiFile: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } } | null };

export type SaveFolderMutationVariables = Exact<{
  input: SaveFolderInput;
}>;


export type SaveFolderMutation = { __typename?: 'Mutation', saveFolder?: { __typename?: 'Folder', id: string, createdTimestamp: DateTime, updatedTimestamp: DateTime, name: string, fileCount: number, documents: Array<{ __typename?: 'Document', id: string, createdTimestamp: DateTime, updatedTimestamp: DateTime, title: string, folder?: { __typename?: 'Folder', id: string, fileCount: number, name: string, createdTimestamp: DateTime, updatedTimestamp: DateTime } | null, uploadedBy: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string }, apiFile: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } }>, parent?: { __typename?: 'Folder', id: string } | null } | null };

export type SaveFolderFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SaveFolderFormQuery = { __typename?: 'Query', folder?: { __typename?: 'Folder', id: string, createdTimestamp: DateTime, updatedTimestamp: DateTime, name: string, fileCount: number, parent?: { __typename?: 'Folder', id: string } | null } | null };

export type IncidentFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IncidentFormQuery = { __typename?: 'Query', incident?: { __typename?: 'Incident', id: string, createdOn: DateTime, issueDate: DateTime, description: string, personsInvolved: Array<{ __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string, profilePicture?: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } | null }>, project: { __typename?: 'Project', id: string } } | null };

export type SaveIncidentMutationVariables = Exact<{
  input: SaveIncident_Input;
}>;


export type SaveIncidentMutation = { __typename?: 'Mutation', saveIncident?: { __typename?: 'Incident', id: string, createdOn: DateTime, issueDate: DateTime, description: string, project: { __typename?: 'Project', id: string }, personsInvolved: Array<{ __typename?: 'Person', id: string, firstName: string, lastName: string, phoneNumber: string, preferredEmail: string, fullName: string, profilePicture?: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } | null }> } | null };

export type InspectionFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InspectionFormQuery = { __typename?: 'Query', inspection?: { __typename?: 'Inspection', id: string, createdAt: DateTime, inspectedSystem: string, dateInspected: DateTime, description: string, inspectedBy: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string }, inspectionResult?: { __typename?: 'InspectionResult', id: string, name: InspectionResultName, displayName: string } | null, project: { __typename?: 'Project', id: string } } | null };

export type SaveInspectionMutationVariables = Exact<{
  input: SaveInspection_Input;
}>;


export type SaveInspectionMutation = { __typename?: 'Mutation', saveInspection?: { __typename?: 'Inspection', id: string, createdAt: DateTime, dateInspected: DateTime, inspectedSystem: string, description: string, inspectedBy: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string }, inspectionResult?: { __typename?: 'InspectionResult', id: string, name: InspectionResultName, displayName: string } | null, project: { __typename?: 'Project', id: string } } | null };

export type SaveInstallationMutationVariables = Exact<{
  input: SaveInstallation_Input;
}>;


export type SaveInstallationMutation = { __typename?: 'Mutation', saveInstallation?: { __typename?: 'Installation', id: string, endDate?: DateTime | null, name: string, roomName: string, estimatedStartDate: DateTime, startDate?: DateTime | null, durationInDays: number, purchaseDate?: DateTime | null, isComplete: boolean, isOverDue: boolean, isDueSoon: boolean, area: { __typename?: 'Area', id: string, name: AreaName, displayName: string }, plan?: { __typename?: 'Plan', id: string, createdDate: DateTime, updatedDate: DateTime, name: string, planSet: { __typename?: 'PlanSet', id: string, name: string, displayName: string }, versions: Array<{ __typename?: 'PlanVersion', id: string, createdTimestamp: DateTime, name: string, uploadedBy: { __typename?: 'Person', id: string, fullName: string }, file: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } }> } | null, associatedDeliveries: Array<{ __typename?: 'MaterialDelivery', id: string, name: string }>, subArea: { __typename?: 'SubArea', id: string, name: SubAreaName, displayName: string }, installationType: { __typename?: 'InstallationType', id: string, name: InstallationTypeName, displayName: string }, milestone?: { __typename?: 'Milestone', id: string } | null, status: { __typename?: 'InstallationStatus', id: string, name: InstallationStatusName, displayName: string }, decisions: Array<{ __typename?: 'Decision', id: string, title: string }> } | null };

export type SaveInstallationFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SaveInstallationFormQuery = { __typename?: 'Query', installation?: { __typename?: 'Installation', id: string, endDate?: DateTime | null, name: string, estimatedStartDate: DateTime, roomName: string, startDate?: DateTime | null, durationInDays: number, purchaseDate?: DateTime | null, area: { __typename?: 'Area', id: string, name: AreaName, displayName: string }, milestone?: { __typename?: 'Milestone', id: string } | null, subArea: { __typename?: 'SubArea', id: string, name: SubAreaName, displayName: string }, installationType: { __typename?: 'InstallationType', id: string, name: InstallationTypeName, displayName: string }, status: { __typename?: 'InstallationStatus', id: string, name: InstallationStatusName, displayName: string } } | null };

export type SaveInstallationPlanFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SaveInstallationPlanFormQuery = { __typename?: 'Query', installation?: { __typename?: 'Installation', id: string, plan?: { __typename?: 'Plan', id: string, createdDate: DateTime } | null } | null };

export type SaveInstallationsMutationVariables = Exact<{
  input: SaveInstallations_Input;
}>;


export type SaveInstallationsMutation = { __typename?: 'Mutation', saveInstallations?: Array<{ __typename?: 'Installation', id: string, name: string, roomName: string, estimatedStartDate: DateTime, startDate?: DateTime | null, isComplete: boolean, area: { __typename?: 'Area', id: string, name: AreaName, displayName: string }, installationType: { __typename?: 'InstallationType', id: string, name: InstallationTypeName, displayName: string }, subArea: { __typename?: 'SubArea', id: string, name: SubAreaName, displayName: string }, status: { __typename?: 'InstallationStatus', id: string, name: InstallationStatusName, displayName: string }, milestone?: { __typename?: 'Milestone', id: string } | null, decisions: Array<{ __typename?: 'Decision', id: string, title: string, dueDate?: DateTime | null, approved?: boolean | null }>, product?: { __typename?: 'Product', id: string, name: string } | null, associatedDeliveries: Array<{ __typename?: 'MaterialDelivery', id: string, name: string }> }> | null };

export type SaveInstallationsFormQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type SaveInstallationsFormQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, installations: Array<{ __typename?: 'Installation', id: string, name: string, roomName: string }> } | null };

export type MembershipFormQueryVariables = Exact<{
  options: Query_Membership_OptionsInput;
}>;


export type MembershipFormQuery = { __typename?: 'Query', membership?: { __typename?: 'Membership', id: string, roles: Array<{ __typename?: 'Role', id: string, name: RoleName, displayName: string }> } | null };

export type SaveMembershipMutationVariables = Exact<{
  input: SaveMembershipInput;
}>;


export type SaveMembershipMutation = { __typename?: 'Mutation', saveMembership?: { __typename?: 'Membership', id: string } | null };

export type MetaDeliveryFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MetaDeliveryFormQuery = { __typename?: 'Query', metaDelivery?: { __typename?: 'MetaDelivery', id: string, notesForClient: string, createdAt: DateTime, included: boolean, receivedDate: DateTime, deliveryName: string } | null };

export type SaveMetaDeliveryMutationVariables = Exact<{
  input: SaveMetaDelivery_Input;
}>;


export type SaveMetaDeliveryMutation = { __typename?: 'Mutation', saveMetaDelivery?: { __typename?: 'MetaDelivery', id: string, notesForClient: string, createdAt: DateTime, included: boolean, receivedDate: DateTime, deliveryName: string } | null };

export type MetaInspectionFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MetaInspectionFormQuery = { __typename?: 'Query', metaInspection?: { __typename?: 'MetaInspection', id: string, inspectionName: string, notesForClient: string, included: boolean, inspector: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string } } | null };

export type SaveMetaInspectionMutationVariables = Exact<{
  input: SaveMetaInspection_Input;
}>;


export type SaveMetaInspectionMutation = { __typename?: 'Mutation', saveMetaInspection?: { __typename?: 'MetaInspection', id: string, notesForClient: string, included: boolean } | null };

export type MetaMilestoneFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MetaMilestoneFormQuery = { __typename?: 'Query', metaMilestone?: { __typename?: 'MetaMilestone', id: string, createdAt: DateTime, milestoneUpdated: DateTime, milestoneName: string, notesForClient: string, included: boolean, milestoneStatus: { __typename?: 'MilestoneStatus', id: string, name: MilestoneStatusName, displayName: string } } | null };

export type SaveMetaMilestoneMutationVariables = Exact<{
  input: SaveMetaMilestone_Input;
}>;


export type SaveMetaMilestoneMutation = { __typename?: 'Mutation', saveMetaMilestone?: { __typename?: 'MetaMilestone', id: string, createdAt: DateTime, milestoneUpdated: DateTime, milestoneName: string, notesForClient: string, included: boolean, milestoneStatus: { __typename?: 'MilestoneStatus', id: string, name: MilestoneStatusName, displayName: string } } | null };

export type SaveMetaPhotoMutationVariables = Exact<{
  input: SaveMetaPhoto_Input;
}>;


export type SaveMetaPhotoMutation = { __typename?: 'Mutation', saveMetaPhoto?: { __typename?: 'MetaPhoto', id: string, included: boolean, attachment?: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } | null } | null };

export type GetMilestoneQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMilestoneQuery = { __typename?: 'Query', milestone?: { __typename?: 'Milestone', id: string, title: string, description: string, estimatedStartDate: DateTime, startDate: DateTime, endDate?: DateTime | null, durationInDays: number, auditLog: Array<{ __typename?: 'AuditLogEvent', id: string, createdTimestamp: DateTime, title: string, description: string, createdBy?: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string } | null }>, status: { __typename?: 'MilestoneStatus', id: string, name: MilestoneStatusName, displayName: string } } | null };

export type SaveMilestoneMutationVariables = Exact<{
  input: SaveMilestone_Input;
}>;


export type SaveMilestoneMutation = { __typename?: 'Mutation', saveMilestone?: { __typename?: 'Milestone', id: string, title: string, description: string, estimatedStartDate: DateTime, durationInDays: number, startDate: DateTime, endDate?: DateTime | null, auditLog: Array<{ __typename?: 'AuditLogEvent', id: string, createdTimestamp: DateTime, title: string, description: string, createdBy?: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string } | null }>, status: { __typename?: 'MilestoneStatus', id: string, name: MilestoneStatusName, displayName: string } } | null };

export type OnSiteWorkEventFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OnSiteWorkEventFormQuery = { __typename?: 'Query', onSiteWorkEvent?: { __typename?: 'OnSiteWorkEvent', id: string, dateWorked: DateTime, hoursWorked: number, onSiteSubContractors: number, description: string, trade?: { __typename?: 'WorkTrade', id: string, name: string, displayName: string } | null, person: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string }, project: { __typename?: 'Project', id: string } } | null };

export type SaveOnSiteWorkEventMutationVariables = Exact<{
  input: SaveOnSiteWorkEvent_Input;
}>;


export type SaveOnSiteWorkEventMutation = { __typename?: 'Mutation', saveOnSiteWorkEvent?: { __typename?: 'OnSiteWorkEvent', id: string, dateWorked: DateTime, hoursWorked: number, onSiteSubContractors: number, description: string, trade?: { __typename?: 'WorkTrade', id: string, name: string, displayName: string } | null, person: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string } } | null };

export type SavePersonMutationVariables = Exact<{
  input: SavePerson_Input;
}>;


export type SavePersonMutation = { __typename?: 'Mutation', savePerson?: { __typename?: 'Person', id: string, firstName: string, lastName: string, createdTimestamp: DateTime, phoneNumber: string, preferredEmail: string, fullName: string, profilePicture?: { __typename?: 'ApiFile', id: string, urlExpiry: DateTime, url: string } | null } | null };

export type SavePersonFormQueryVariables = Exact<{ [key: string]: never; }>;


export type SavePersonFormQuery = { __typename?: 'Query', loggedInUser?: { __typename?: 'SiteUserFull', id: string, person: { __typename?: 'Person', id: string, firstName: string, lastName: string, createdTimestamp: DateTime, phoneNumber: string, preferredEmail: string, fullName: string, profilePicture?: { __typename?: 'ApiFile', id: string, urlExpiry: DateTime, url: string } | null } } | null };

export type GetPlanQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPlanQuery = { __typename?: 'Query', plan?: { __typename?: 'Plan', id: string, createdDate: DateTime, updatedDate: DateTime, name: string, planSet: { __typename?: 'PlanSet', id: string, name: string, displayName: string }, versions: Array<{ __typename?: 'PlanVersion', id: string, createdTimestamp: DateTime, name: string, uploadedBy: { __typename?: 'Person', id: string, fullName: string }, file: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } }> } | null };

export type SavePlanMutationVariables = Exact<{
  input: SavePlan_Input;
}>;


export type SavePlanMutation = { __typename?: 'Mutation', savePlan?: { __typename?: 'Plan', id: string, createdDate: DateTime, updatedDate: DateTime, name: string, planSet: { __typename?: 'PlanSet', id: string, name: string, displayName: string }, versions: Array<{ __typename?: 'PlanVersion', id: string, createdTimestamp: DateTime, name: string, uploadedBy: { __typename?: 'Person', id: string, fullName: string }, file: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } }> } | null };

export type PlanSetFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PlanSetFormQuery = { __typename?: 'Query', planSet?: { __typename?: 'PlanSet', id: string, name: string, displayName: string } | null };

export type SavePlanSetFormMutationVariables = Exact<{
  input: SavePlanSet_Input;
}>;


export type SavePlanSetFormMutation = { __typename?: 'Mutation', savePlanSet?: { __typename?: 'PlanSet', id: string, name: string, displayName: string } | null };

export type SaveProductMutationVariables = Exact<{
  input: SaveProduct_Input;
}>;


export type SaveProductMutation = { __typename?: 'Mutation', saveProduct?: { __typename: 'Product', id: string, finish: string, hardware: string, manufacturer: string, model: string, name: string, notes: string, supplier: string } | null };

export type GetStandardInstallationsForAreaQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStandardInstallationsForAreaQuery = { __typename?: 'Query', standardTemplateMilestones: Array<{ __typename?: 'StandardTemplateMilestone', id: string, estimatedStartDate: DateTime, durationInDays: number, durationFromProjectStartDateInMills: string, title: string, rank: number, description: string }> };

export type SaveProjectMutationVariables = Exact<{
  input: SaveProject_Input;
}>;


export type SaveProjectMutation = { __typename?: 'Mutation', saveProject?: { __typename?: 'Project', id: string, estimatedStartDate: DateTime, startDate?: DateTime | null, name: string, estimatedCompletionDate: DateTime, locationAddress: { __typename?: 'Address', id: string, street1: string, street2: string, city: string, postalCode: string, formattedFullAddress: string, state: { __typename?: 'UsState', id: string, name: string, displayName: string, abbreviation: UsStateAbbreviationName } }, memberships: Array<{ __typename?: 'Membership', id: string }>, tasks: Array<{ __typename?: 'Task', id: string }>, installations: Array<{ __typename?: 'Installation', id: string, startDate?: DateTime | null, name: string, roomName: string }>, milestones: Array<{ __typename?: 'Milestone', id: string, title: string, estimatedStartDate: DateTime, startDate: DateTime }> } | null };

export type SaveProjectFormQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type SaveProjectFormQuery = { __typename?: 'Query', usStates?: Array<{ __typename?: 'UsState', id: string, name: string, displayName: string, abbreviation: UsStateAbbreviationName } | null> | null, project?: { __typename?: 'Project', id: string, name: string, startDate?: DateTime | null, estimatedStartDate: DateTime, installations: Array<{ __typename?: 'Installation', id: string, roomName: string, area: { __typename?: 'Area', id: string, name: AreaName, displayName: string }, subArea: { __typename?: 'SubArea', id: string, name: SubAreaName, displayName: string } }>, rooms: Array<{ __typename?: 'Room', name: string }>, locationAddress: { __typename?: 'Address', id: string, street1: string, street2: string, city: string, postalCode: string, formattedFullAddress: string, state: { __typename?: 'UsState', id: string, name: string, displayName: string, abbreviation: UsStateAbbreviationName } } } | null };

export type SaveStandardAreaInstallationMutationVariables = Exact<{
  input: SaveStandardAreaInstallation_Input;
}>;


export type SaveStandardAreaInstallationMutation = { __typename?: 'Mutation', saveStandardAreaInstallation?: { __typename?: 'StandardAreaInstallation', id: string, displayName: string, area: { __typename?: 'Area', id: string, name: AreaName, displayName: string }, subArea: { __typename?: 'SubArea', id: string, name: SubAreaName, displayName: string }, milestone?: { __typename?: 'StandardTemplateMilestone', id: string, title: string } | null, type: { __typename?: 'InstallationType', id: string, name: InstallationTypeName, displayName: string } } | null };

export type StandardAreaInstallationFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StandardAreaInstallationFormQuery = { __typename?: 'Query', standardAreaInstallation?: { __typename?: 'StandardAreaInstallation', id: string, displayName: string, area: { __typename?: 'Area', id: string, name: AreaName, displayName: string }, subArea: { __typename?: 'SubArea', id: string, name: SubAreaName, displayName: string }, milestone?: { __typename?: 'StandardTemplateMilestone', id: string, title: string } | null, type: { __typename?: 'InstallationType', id: string, name: InstallationTypeName, displayName: string } } | null };

export type SaveTaskFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SaveTaskFormQuery = { __typename?: 'Query', task?: { __typename?: 'Task', id: string, taskNumber: string, dueDate?: DateTime | null, name: string, description: string, assignee?: { __typename?: 'Person', id: string } | null, area?: { __typename?: 'Area', id: string } | null, category?: { __typename?: 'TaskCategory', id: string } | null, attachments: Array<{ __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string }>, status: { __typename?: 'TaskStatus', id: string, name: TaskStatusName, displayName: string } } | null };

export type SaveTaskMutationVariables = Exact<{
  input: SaveTask_Input;
}>;


export type SaveTaskMutation = { __typename?: 'Mutation', saveTask?: { __typename?: 'Task', id: string, taskNumber: string, dueDate?: DateTime | null, name: string, createdAt: DateTime, description: string, isOverdue: boolean, isComplete: boolean, assignee?: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string } | null, area?: { __typename?: 'Area', id: string, name: AreaName, displayName: string } | null, category?: { __typename?: 'TaskCategory', id: string, name: TaskCategoryName, displayName: string } | null, attachments: Array<{ __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string }>, status: { __typename?: 'TaskStatus', id: string, name: TaskStatusName, displayName: string } } | null };

export type SaveWeatherMutationVariables = Exact<{
  input: SaveWeather_Input;
}>;


export type SaveWeatherMutation = { __typename?: 'Mutation', saveWeather?: { __typename?: 'Weather', id: string, temperatureMax: number, temperatureMin: number, precipitationAmount: number, precipitationType: { __typename?: 'PrecipitationType', id: string, name: PrecipitationTypeName, displayName: string }, condition: { __typename?: 'WeatherCondition', id: string, name: WeatherConditionName, displayName: string } } | null };

export type WeatherFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WeatherFormQuery = { __typename?: 'Query', weather?: { __typename?: 'Weather', id: string, temperatureMax: number, temperatureMin: number, precipitationAmount: number, condition: { __typename?: 'WeatherCondition', id: string, name: WeatherConditionName, displayName: string }, precipitationType: { __typename?: 'PrecipitationType', id: string, name: PrecipitationTypeName, displayName: string } } | null };

export type GetProjectTemplateMilestonesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProjectTemplateMilestonesQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, milestones: Array<{ __typename?: 'Milestone', id: string, startDate: DateTime, durationInDays: number, title: string, installations: Array<{ __typename?: 'Installation', id: string, name: string, roomName: string }> }> } | null };

export type ModalCommentSectionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ModalCommentSectionQuery = { __typename?: 'Query', task?: { __typename?: 'Task', id: string, comments: Array<{ __typename?: 'Comment', id: string, createdAt: DateTime, description: string, person: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string } }> } | null };

export type SaveTaskModalDetailSectionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SaveTaskModalDetailSectionQuery = { __typename?: 'Query', task?: { __typename?: 'Task', id: string, taskNumber: string, dueDate?: DateTime | null, name: string, description: string, assignee?: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string } | null, comments: Array<{ __typename?: 'Comment', id: string, description: string, person: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string } }>, area?: { __typename?: 'Area', id: string, name: AreaName, displayName: string } | null, category?: { __typename?: 'TaskCategory', id: string, name: TaskCategoryName, displayName: string } | null, status: { __typename?: 'TaskStatus', id: string, name: TaskStatusName, displayName: string }, attachments: Array<{ __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string }> } | null };

export type DeleteFolderModalMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteFolderModalMutation = { __typename?: 'Mutation', deleteFolder?: { __typename?: 'Folder', id: string } | null };

export type DuplicateFolderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DuplicateFolderMutation = { __typename?: 'Mutation', duplicateFolder?: { __typename?: 'Folder', id: string, createdTimestamp: DateTime, updatedTimestamp: DateTime, name: string, fileCount: number, documents: Array<{ __typename?: 'Document', id: string, createdTimestamp: DateTime, updatedTimestamp: DateTime, title: string, folder?: { __typename?: 'Folder', id: string, fileCount: number, name: string, createdTimestamp: DateTime, updatedTimestamp: DateTime } | null, uploadedBy: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string }, apiFile: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } }>, parent?: { __typename?: 'Folder', id: string } | null } | null };

export type RemoveDeliveryModalMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveDeliveryModalMutation = { __typename?: 'Mutation', removeDelivery?: string | null };

export type RemoveDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveDocumentMutation = { __typename?: 'Mutation', deleteDocument: string };

export type RemoveInstallationTypeMutationVariables = Exact<{
  input: RemoveInstallationType_Input;
}>;


export type RemoveInstallationTypeMutation = { __typename?: 'Mutation', removeInstallationType: { __typename?: 'InstallationType', id: string, name: InstallationTypeName, displayName: string } };

export type RemoveOnSiteWorkEventMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveOnSiteWorkEventMutation = { __typename?: 'Mutation', removeOnSiteWorkEvent: string };

export type ResetProjectMilestonesModalMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ResetProjectMilestonesModalMutation = { __typename?: 'Mutation', resetProjectMilestones?: Array<{ __typename?: 'Milestone', id: string, title: string, description: string, estimatedStartDate: DateTime, durationInDays: number, startDate: DateTime, endDate?: DateTime | null, status: { __typename?: 'MilestoneStatus', id: string, name: MilestoneStatusName, displayName: string } }> | null };

export type UpdateSuperAdminMutationVariables = Exact<{
  input: SavePerson_Input;
}>;


export type UpdateSuperAdminMutation = { __typename?: 'Mutation', savePerson?: { __typename?: 'Person', id: string, firstName: string, lastName: string, createdTimestamp: DateTime, phoneNumber: string, isActive: boolean, preferredEmail: string, fullName: string, profilePicture?: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } | null } | null };

export type SaveReportAttachmentMutationVariables = Exact<{
  input: SaveReportAttachment_Input;
}>;


export type SaveReportAttachmentMutation = { __typename?: 'Mutation', saveClientReportAttachment?: { __typename?: 'ReportAttachment', id: string, createdAt: DateTime, attachment?: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } | null } | null };

export type SaveClientReportMetaDeliveryMutationVariables = Exact<{
  input: SaveMetaDelivery_Input;
}>;


export type SaveClientReportMetaDeliveryMutation = { __typename?: 'Mutation', saveMetaDelivery?: { __typename?: 'MetaDelivery', id: string, createdAt: DateTime, receivedDate: DateTime, deliveryName: string, notesForClient: string, included: boolean } | null };

export type SaveClientReportMetaInspectionMutationVariables = Exact<{
  input: SaveMetaInspection_Input;
}>;


export type SaveClientReportMetaInspectionMutation = { __typename?: 'Mutation', saveMetaInspection?: { __typename?: 'MetaInspection', id: string, createdAt: DateTime, inspectionUpdated: DateTime, inspectionName: string, notesForClient: string, included: boolean, inspectionResult: { __typename?: 'InspectionResult', id: string, name: InspectionResultName, displayName: string }, inspector: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string } } | null };

export type SaveClientReportMetaMilestoneMutationVariables = Exact<{
  input: SaveMetaMilestone_Input;
}>;


export type SaveClientReportMetaMilestoneMutation = { __typename?: 'Mutation', saveMetaMilestone?: { __typename?: 'MetaMilestone', id: string, createdAt: DateTime, milestoneUpdated: DateTime, milestoneName: string, notesForClient: string, included: boolean, milestoneStatus: { __typename?: 'MilestoneStatus', id: string, name: MilestoneStatusName, displayName: string } } | null };

export type SaveClientReportPhotoCardMutationVariables = Exact<{
  input: SaveMetaPhoto_Input;
}>;


export type SaveClientReportPhotoCardMutation = { __typename?: 'Mutation', saveMetaPhoto?: { __typename?: 'MetaPhoto', id: string, included: boolean, attachment?: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } | null } | null };

export type GetInstallationDecisionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetInstallationDecisionsQuery = { __typename?: 'Query', installation?: { __typename?: 'Installation', id: string, decisions: Array<{ __typename?: 'Decision', id: string, title: string, description: string, dueDate?: DateTime | null, approved?: boolean | null, isOverdue: boolean, isComplete: boolean, isDueSoon: boolean, decidedTimestamp?: DateTime | null, type: { __typename?: 'DecisionType', id: string, name: DecisionTypeName, displayName: string } }> } | null };

export type GetInstallationDeliveriesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetInstallationDeliveriesQuery = { __typename?: 'Query', installation?: { __typename?: 'Installation', id: string, associatedDeliveries: Array<{ __typename: 'MaterialDelivery', id: string, receivedDate?: DateTime | null, name: string, description: string, quantity: number, damageDescription: string, issueDescription: string, otherDescription: string, estimatedDeliveryDate?: DateTime | null, createdTimestamp: DateTime, attachments: Array<{ __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string }> }> } | null };

export type RemoveDeliveryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveDeliveryMutation = { __typename?: 'Mutation', removeDelivery?: string | null };

export type GetInstallationGeneralDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetInstallationGeneralDetailQuery = { __typename?: 'Query', installation?: { __typename?: 'Installation', id: string, name: string, fullAreaName: string, isComplete: boolean, isOverDue: boolean, isDueSoon: boolean, installationType: { __typename?: 'InstallationType', id: string, name: InstallationTypeName, displayName: string }, area: { __typename?: 'Area', id: string, name: AreaName, displayName: string }, subArea: { __typename?: 'SubArea', id: string, name: SubAreaName, displayName: string }, decisions: Array<{ __typename?: 'Decision', id: string }> } | null };

export type GetInstallationPlansQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetInstallationPlansQuery = { __typename?: 'Query', installation?: { __typename?: 'Installation', id: string, plan?: { __typename?: 'Plan', id: string, createdDate: DateTime, updatedDate: DateTime, name: string, planSet: { __typename?: 'PlanSet', id: string, name: string, displayName: string }, versions: Array<{ __typename?: 'PlanVersion', id: string, createdTimestamp: DateTime, name: string, uploadedBy: { __typename?: 'Person', id: string, fullName: string }, file: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } }> } | null } | null };

export type GetInstallationProductDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetInstallationProductDetailQuery = { __typename?: 'Query', installation?: { __typename?: 'Installation', id: string, product?: { __typename: 'Product', id: string, name: string, supplier: string, manufacturer: string, model: string, hardware: string, finish: string, notes: string } | null } | null };

export type MilestoneDetailCardQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MilestoneDetailCardQuery = { __typename?: 'Query', milestone?: { __typename?: 'Milestone', id: string, title: string, description: string, startDate: DateTime, endDate?: DateTime | null, durationInDays: number, auditLog: Array<{ __typename?: 'AuditLogEvent', id: string, createdTimestamp: DateTime, title: string, description: string, createdBy?: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string } | null }>, status: { __typename?: 'MilestoneStatus', id: string, name: MilestoneStatusName, displayName: string } } | null };

export type UserDetailCardQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserDetailCardQuery = { __typename?: 'Query', person?: { __typename?: 'Person', id: string, createdTimestamp: DateTime, firstName: string, lastName: string, phoneNumber: string, preferredEmail: string, fullName: string, profilePicture?: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } | null } | null };

export type UserProfileDetailCardQueryVariables = Exact<{ [key: string]: never; }>;


export type UserProfileDetailCardQuery = { __typename?: 'Query', loggedInUser?: { __typename?: 'SiteUserFull', id: string, person: { __typename?: 'Person', id: string, createdTimestamp: DateTime, firstName: string, lastName: string, phoneNumber: string, preferredEmail: string, fullName: string, profilePicture?: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } | null, notificationSettings: Array<{ __typename?: 'NotificationSetting', id: string, enabled: boolean, type: { __typename?: 'NotificationType', id: string, name: NotificationTypeName, displayName: string } }> } } | null };

export type UserProfileDetailCardSaveNotificationSettingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserProfileDetailCardSaveNotificationSettingMutation = { __typename?: 'Mutation', saveNotificationSetting?: { __typename?: 'NotificationSetting', id: string, enabled: boolean, type: { __typename?: 'NotificationType', id: string, displayName: string } } | null };

export type ClientReportTableQueryVariables = Exact<{
  options: Query_ClientReports_OptionsInput;
}>;


export type ClientReportTableQuery = { __typename?: 'Query', clientReports: Array<{ __typename?: 'ClientReport', id: string, createdAt: DateTime, updatedAt: DateTime, startDate: DateTime, endDate: DateTime, description: string, approvedAt?: DateTime | null, milestones: Array<{ __typename?: 'MetaMilestone', id: string }>, inspections: Array<{ __typename?: 'MetaInspection', id: string }>, photos: Array<{ __typename?: 'MetaPhoto', id: string }>, links: Array<{ __typename?: 'ClientReportLink', id: string }>, attachments: Array<{ __typename?: 'ReportAttachment', id: string }>, deliveries: Array<{ __typename?: 'MetaDelivery', id: string }>, approvedBy?: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string } | null }> };

export type DailyReportTableQueryVariables = Exact<{
  options: Query_DailyReports_OptionsInput;
}>;


export type DailyReportTableQuery = { __typename?: 'Query', dailyReports: Array<{ __typename?: 'DailyReport', id: string, description: string, reportDate: DateTime, approvedAt?: DateTime | null, numberOfIncidents: number, numberOfDeliveries: number, numberOfInspections?: number | null, numberOfWorkEvents: number, incidents: Array<{ __typename?: 'Incident', id: string }>, inspections: Array<{ __typename?: 'Inspection', id: string }>, deliveries: Array<{ __typename?: 'MaterialDelivery', id: string }>, workLog: Array<{ __typename?: 'OnSiteWorkEvent', id: string }>, approvedBy?: { __typename?: 'Person', id: string, firstName: string, lastName: string, phoneNumber: string, preferredEmail: string, fullName: string, profilePicture?: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } | null } | null }> };

export type DocumentTableQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type DocumentTableQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, documents: Array<{ __typename?: 'Document', id: string, createdTimestamp: DateTime, updatedTimestamp: DateTime, title: string, folder?: { __typename?: 'Folder', id: string, fileCount: number, name: string, createdTimestamp: DateTime, updatedTimestamp: DateTime } | null, uploadedBy: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string }, apiFile: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } }> } | null };

export type ExternalFolderDetailTableQueryVariables = Exact<{
  folderId: Scalars['ID']['input'];
}>;


export type ExternalFolderDetailTableQuery = { __typename?: 'Query', folder?: { __typename?: 'Folder', id: string, name: string, project: { __typename?: 'Project', id: string, name: string }, documents: Array<{ __typename?: 'Document', id: string, title: string, apiFile: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } }> } | null };

export type MilestoneTableQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MilestoneTableQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, milestones: Array<{ __typename?: 'Milestone', id: string, title: string, description: string, startDate: DateTime, durationInDays: number, endDate?: DateTime | null, installations: Array<{ __typename?: 'Installation', id: string, name: string, roomName: string }>, status: { __typename?: 'MilestoneStatus', id: string, name: MilestoneStatusName, displayName: string } }> } | null };

export type PersonTableQueryVariables = Exact<{
  options: Query_Persons_OptionsInput;
}>;


export type PersonTableQuery = { __typename?: 'Query', persons: Array<{ __typename?: 'Person', id: string, firstName: string, lastName: string, createdTimestamp: DateTime, phoneNumber: string, preferredEmail: string, isActive: boolean, fullName: string, profilePicture?: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } | null, memberships: Array<{ __typename?: 'Membership', id: string }> }> };

export type PlanSetTableQueryVariables = Exact<{
  options: Query_PlanSets_OptionsInput;
}>;


export type PlanSetTableQuery = { __typename?: 'Query', planSets: Array<{ __typename?: 'PlanSet', id: string, name: string, displayName: string, createdAt: DateTime, updatedAt: DateTime, planCount: number }> };

export type PlanTableQueryVariables = Exact<{
  options: Query_Plans_OptionsInput;
}>;


export type PlanTableQuery = { __typename?: 'Query', plans: Array<{ __typename?: 'Plan', id: string, createdDate: DateTime, name: string, updatedDate: DateTime, planSet: { __typename?: 'PlanSet', id: string, name: string, displayName: string }, versions: Array<{ __typename?: 'PlanVersion', id: string, createdTimestamp: DateTime, name: string, uploadedBy: { __typename?: 'Person', id: string, fullName: string }, file: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } }> }> };

export type GetProjectInstallationsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetProjectInstallationsQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, rooms: Array<{ __typename?: 'Room', name: string }>, installations: Array<{ __typename?: 'Installation', id: string, name: string, roomName: string, estimatedStartDate: DateTime, startDate?: DateTime | null, isComplete: boolean, area: { __typename?: 'Area', id: string, name: AreaName, displayName: string }, installationType: { __typename?: 'InstallationType', id: string, name: InstallationTypeName, displayName: string }, subArea: { __typename?: 'SubArea', id: string, name: SubAreaName, displayName: string }, status: { __typename?: 'InstallationStatus', id: string, name: InstallationStatusName, displayName: string }, milestone?: { __typename?: 'Milestone', id: string } | null, decisions: Array<{ __typename?: 'Decision', id: string, title: string, dueDate?: DateTime | null, approved?: boolean | null }> }> } | null };

export type GetAllProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProjectsQuery = { __typename?: 'Query', projects?: Array<{ __typename?: 'Project', id: string, name: string, startDate?: DateTime | null, estimatedStartDate: DateTime, estimatedCompletionDate: DateTime, locationAddress: { __typename?: 'Address', id: string, street1: string, street2: string, city: string, postalCode: string, formattedFullAddress: string, state: { __typename?: 'UsState', id: string, name: string, displayName: string, abbreviation: UsStateAbbreviationName } } }> | null };

export type StandardAreaInstallationTableQueryVariables = Exact<{ [key: string]: never; }>;


export type StandardAreaInstallationTableQuery = { __typename?: 'Query', standardAreaInstallations?: Array<{ __typename?: 'StandardAreaInstallation', id: string, name: string, displayName: string, area: { __typename?: 'Area', id: string, name: AreaName, displayName: string }, subArea: { __typename?: 'SubArea', id: string, name: SubAreaName, displayName: string }, type: { __typename?: 'InstallationType', id: string, name: InstallationTypeName, displayName: string }, milestone?: { __typename?: 'StandardTemplateMilestone', id: string, title: string } | null }> | null };

export type SuperAdminTableQueryVariables = Exact<{
  options: Query_Persons_OptionsInput;
}>;


export type SuperAdminTableQuery = { __typename?: 'Query', persons: Array<{ __typename?: 'Person', id: string, firstName: string, lastName: string, createdTimestamp: DateTime, phoneNumber: string, isActive: boolean, preferredEmail: string, fullName: string, profilePicture?: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } | null }> };

export type TaskTableQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TaskTableQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, overdueTasks: Array<{ __typename?: 'Task', id: string, dueDate?: DateTime | null }>, completedTasks: Array<{ __typename?: 'Task', id: string, dueDate?: DateTime | null }>, dueTasks: Array<{ __typename?: 'Task', id: string, dueDate?: DateTime | null }>, tasks: Array<{ __typename?: 'Task', id: string, name: string, taskNumber: string, dueDate?: DateTime | null, createdAt: DateTime, isOverdue: boolean, isComplete: boolean, assignee?: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string } | null, category?: { __typename?: 'TaskCategory', id: string, name: TaskCategoryName, displayName: string } | null, attachments: Array<{ __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string }>, status: { __typename?: 'TaskStatus', id: string, name: TaskStatusName, displayName: string } }> } | null };

export type TaskTableQueryFieldsFragment = { __typename?: 'Task', id: string, name: string, taskNumber: string, dueDate?: DateTime | null, createdAt: DateTime, isOverdue: boolean, isComplete: boolean, assignee?: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string } | null, category?: { __typename?: 'TaskCategory', id: string, name: TaskCategoryName, displayName: string } | null, attachments: Array<{ __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string }>, status: { __typename?: 'TaskStatus', id: string, name: TaskStatusName, displayName: string } };

export type FolderListSectionQueryVariables = Exact<{
  options: Query_Folders_OptionsInput;
}>;


export type FolderListSectionQuery = { __typename?: 'Query', folders: Array<{ __typename?: 'Folder', id: string, name: string, fileCount: number, createdTimestamp: DateTime, updatedTimestamp: DateTime, parent?: { __typename?: 'Folder', id: string } | null, documents: Array<{ __typename?: 'Document', id: string, createdTimestamp: DateTime, updatedTimestamp: DateTime, title: string, folder?: { __typename?: 'Folder', id: string, fileCount: number, name: string, createdTimestamp: DateTime, updatedTimestamp: DateTime } | null, uploadedBy: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string }, apiFile: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } }> }> };

export type InstallationsSummaryMetricsSectionQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type InstallationsSummaryMetricsSectionQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, installations: Array<{ __typename?: 'Installation', id: string, decisions: Array<{ __typename?: 'Decision', id: string, dueDate?: DateTime | null, approved?: boolean | null }> }>, installationsWithUpcomingDecisions: Array<{ __typename?: 'Installation', id: string }>, installationsWithOverDueDecisions: Array<{ __typename?: 'Installation', id: string }>, installationsWithAllDecisionsComplete: Array<{ __typename?: 'Installation', id: string }>, installationsWithDecisionsRemaining: Array<{ __typename?: 'Installation', id: string }> } | null };

export type TaskSummaryMetricsSectionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TaskSummaryMetricsSectionQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, overdueTasks: Array<{ __typename?: 'Task', id: string, dueDate?: DateTime | null }>, completedTasks: Array<{ __typename?: 'Task', id: string, dueDate?: DateTime | null }>, dueTasks: Array<{ __typename?: 'Task', id: string, dueDate?: DateTime | null }>, tasks: Array<{ __typename?: 'Task', id: string, dueDate?: DateTime | null, createdAt: DateTime, isOverdue: boolean, isComplete: boolean, status: { __typename?: 'TaskStatus', id: string, name: TaskStatusName, displayName: string } }> } | null };

export type ClientReportDetailSectionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ClientReportDetailSectionQuery = { __typename?: 'Query', clientReport?: { __typename?: 'ClientReport', id: string, createdAt: DateTime, updatedAt: DateTime, description: string, startDate: DateTime, endDate: DateTime, approvedAt?: DateTime | null, deliveries: Array<{ __typename?: 'MetaDelivery', id: string, notesForClient: string, createdAt: DateTime, included: boolean, receivedDate: DateTime, deliveryName: string, attachments: Array<{ __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string }> }>, inspections: Array<{ __typename?: 'MetaInspection', id: string, inspectionName: string, notesForClient: string, createdAt: DateTime, included: boolean, inspectionResult: { __typename?: 'InspectionResult', id: string, name: InspectionResultName, displayName: string }, inspector: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string } }>, photos: Array<{ __typename?: 'MetaPhoto', id: string, included: boolean, notesForClient: string, attachment?: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } | null }>, milestones: Array<{ __typename?: 'MetaMilestone', id: string, createdAt: DateTime, milestoneUpdated: DateTime, milestoneName: string, notesForClient: string, included: boolean, milestoneStatus: { __typename?: 'MilestoneStatus', id: string, name: MilestoneStatusName, displayName: string } }>, links: Array<{ __typename?: 'ClientReportLink', id: string, createdAt: DateTime, notesForClient: string, url: string }>, attachments: Array<{ __typename?: 'ReportAttachment', id: string, createdAt: DateTime, attachment?: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } | null }>, approvedBy?: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string } | null } | null };

export type ClientReportHeaderSectionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ClientReportHeaderSectionQuery = { __typename?: 'Query', clientReport?: { __typename?: 'ClientReport', id: string, approvedAt?: DateTime | null, startDate: DateTime, endDate: DateTime } | null };

export type DailyReportDetailSectionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DailyReportDetailSectionQuery = { __typename?: 'Query', dailyReport?: { __typename?: 'DailyReport', id: string, description: string, reportDate: DateTime, approvedAt?: DateTime | null, approvedBy?: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string } | null, inspections: Array<{ __typename?: 'Inspection', id: string, createdAt: DateTime, inspectedSystem: string, dateInspected: DateTime, description: string, inspectedBy: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string }, inspectionResult?: { __typename?: 'InspectionResult', id: string, name: InspectionResultName, displayName: string } | null }>, incidents: Array<{ __typename?: 'Incident', id: string, createdOn: DateTime, issueDate: DateTime, description: string, personsInvolved: Array<{ __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string, profilePicture?: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } | null }> }>, photos: Array<{ __typename?: 'DailyReportPhoto', id: string, apiFile: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } }>, deliveries: Array<{ __typename?: 'MaterialDelivery', id: string, createdTimestamp: DateTime, receivedDate?: DateTime | null, name: string, description: string, quantity: number, damageDescription: string, issueDescription: string, otherDescription: string, attachments: Array<{ __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string }> }>, workLog: Array<{ __typename?: 'OnSiteWorkEvent', id: string, dateWorked: DateTime, onSiteSubContractors: number, description: string, hoursWorked: number, trade?: { __typename?: 'WorkTrade', id: string, name: string, displayName: string } | null, person: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string } }> } | null };

export type DailyReportHeaderSectionQueryVariables = Exact<{
  options: Query_DailyReports_OptionsInput;
}>;


export type DailyReportHeaderSectionQuery = { __typename?: 'Query', dailyReports: Array<{ __typename?: 'DailyReport', id: string, reportDate: DateTime, approvedAt?: DateTime | null, numberOfInspections?: number | null, numberOfIncidents: number, project: { __typename?: 'Project', id: string, name: string, locationAddress: { __typename?: 'Address', id: string, street1: string, street2: string, city: string, postalCode: string, formattedFullAddress: string, state: { __typename?: 'UsState', id: string, name: string, displayName: string, abbreviation: UsStateAbbreviationName } } }, weather: { __typename?: 'Weather', id: string, precipitationAmount: number, temperatureMax: number, temperatureMin: number, condition: { __typename?: 'WeatherCondition', id: string, name: WeatherConditionName, displayName: string }, precipitationType: { __typename?: 'PrecipitationType', id: string, name: PrecipitationTypeName, displayName: string } } }> };

export type DailyReportsHeaderSectionQueryVariables = Exact<{
  options: Query_DailyReports_OptionsInput;
}>;


export type DailyReportsHeaderSectionQuery = { __typename?: 'Query', dailyReports: Array<{ __typename?: 'DailyReport', id: string, numberOfIncidents: number, numberOfDeliveries: number, numberOfInspections?: number | null, numberOfWorkEvents: number }> };

export type ExternalFolderHeaderSectionQueryVariables = Exact<{
  folderId: Scalars['ID']['input'];
}>;


export type ExternalFolderHeaderSectionQuery = { __typename?: 'Query', folder?: { __typename?: 'Folder', id: string, name: string, project: { __typename?: 'Project', id: string, locationAddress: { __typename?: 'Address', id: string, street1: string, street2: string, city: string, postalCode: string, formattedFullAddress: string, state: { __typename?: 'UsState', id: string, name: string, displayName: string, abbreviation: UsStateAbbreviationName } } } } | null };

export type FileDetailSectionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FileDetailSectionQuery = { __typename?: 'Query', document?: { __typename?: 'Document', id: string, createdTimestamp: DateTime, updatedTimestamp: DateTime, title: string, folder?: { __typename?: 'Folder', id: string, fileCount: number, name: string, createdTimestamp: DateTime, updatedTimestamp: DateTime } | null, uploadedBy: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string }, apiFile: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } } | null };

export type FolderHeaderSectionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FolderHeaderSectionQuery = { __typename?: 'Query', folder?: { __typename?: 'Folder', id: string, name: string } | null };

export type PlanDetailSectionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PlanDetailSectionQuery = { __typename?: 'Query', plan?: { __typename?: 'Plan', id: string, createdDate: DateTime, updatedDate: DateTime, name: string, versions: Array<{ __typename?: 'PlanVersion', id: string, createdTimestamp: DateTime, updatedTimestamp: DateTime, name: string, uploadedBy: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string }, file: { __typename?: 'ApiFile', id: string, url: string, fileName: string, sizeBytes: number, mimeType: string, formattedFileSize: string } }>, annotations: Array<{ __typename?: 'Annotation', id: string, color: string, relatedId?: string | null, width: number, type: { __typename?: 'AnnotationType', id: string, name: AnnotationTypeName, displayName: string }, page: { __typename?: 'PageDetail', pageNumber: number, height: number, width: number }, points: Array<{ __typename?: 'AnnotationPoint', id: string, x: Big, y: Big }> }>, documents: Array<{ __typename?: 'Document', id: string, title: string, createdTimestamp: DateTime, updatedTimestamp: DateTime, uploadedBy: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string } }>, tasks: Array<{ __typename?: 'Task', id: string, dueDate?: DateTime | null, description: string, name: string, area?: { __typename?: 'Area', id: string, name: AreaName, displayName: string } | null, category?: { __typename?: 'TaskCategory', id: string, name: TaskCategoryName, displayName: string } | null }> } | null };

export type PlanSetHeaderSectionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PlanSetHeaderSectionQuery = { __typename?: 'Query', planSet?: { __typename?: 'PlanSet', id: string, name: string, displayName: string } | null };

export type SendTestNotificationToSelfMutationVariables = Exact<{ [key: string]: never; }>;


export type SendTestNotificationToSelfMutation = { __typename?: 'Mutation', notification_createTestForSelf?: { __typename?: 'Notification', id: string, isRead: boolean, title: string, content: string, createdTimestamp: DateTime } | null };

export type GetInstallationHeaderMetricsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetInstallationHeaderMetricsQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, installations: Array<{ __typename?: 'Installation', id: string, name: string, roomName: string, decisions: Array<{ __typename?: 'Decision', id: string, dueDate?: DateTime | null, approved?: boolean | null }> }>, installationsWithUpcomingDecisions: Array<{ __typename?: 'Installation', id: string }>, installationsWithOverDueDecisions: Array<{ __typename?: 'Installation', id: string }>, installationsWithAllDecisionsComplete: Array<{ __typename?: 'Installation', id: string }>, installationsWithDecisionsRemaining: Array<{ __typename?: 'Installation', id: string }> } | null };

export type MilestoneDetailSectionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MilestoneDetailSectionQuery = { __typename?: 'Query', milestone?: { __typename?: 'Milestone', id: string, title: string, description: string, startDate: DateTime, endDate?: DateTime | null, durationInDays: number, auditLog: Array<{ __typename?: 'AuditLogEvent', id: string, createdTimestamp: DateTime, title: string, description: string, createdBy?: { __typename?: 'Person', id: string, firstName: string, lastName: string, fullName: string } | null }>, status: { __typename?: 'MilestoneStatus', id: string, name: MilestoneStatusName, displayName: string } } | null };

export type MileStoneHeaderSectionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MileStoneHeaderSectionQuery = { __typename?: 'Query', milestone?: { __typename?: 'Milestone', id: string, title: string, description: string } | null };

export const ApiFileFieldsFragmentDoc = gql`
    fragment apiFileFields on ApiFile {
  id
  url
  fileName
  sizeBytes
  mimeType
  formattedFileSize @client
}
    `;
export const PlanVersionFieldsFragmentDoc = gql`
    fragment planVersionFields on PlanVersion {
  id
  createdTimestamp
  uploadedBy {
    id
    fullName @client
  }
  name
  file {
    ...apiFileFields
  }
}
    ${ApiFileFieldsFragmentDoc}`;
export const AddressFieldsFragmentDoc = gql`
    fragment addressFields on Address {
  id
  street1
  street2
  city
  postalCode
  state {
    id
    name
    displayName
    abbreviation
  }
  formattedFullAddress @client
}
    `;
export const SaveDocumentFieldsFragmentDoc = gql`
    fragment saveDocumentFields on Document {
  id
  createdTimestamp
  updatedTimestamp
  title
  folder {
    id
    fileCount
    name
    fileCount
    createdTimestamp
    updatedTimestamp
  }
  uploadedBy {
    id
    firstName
    lastName
    fullName @client
  }
  apiFile {
    ...apiFileFields
  }
}
    ${ApiFileFieldsFragmentDoc}`;
export const TaskTableQueryFieldsFragmentDoc = gql`
    fragment taskTableQueryFields on Task {
  id
  name
  assignee {
    id
    firstName
    lastName
    fullName @client
  }
  category {
    id
    name
    displayName
  }
  attachments {
    ...apiFileFields
  }
  taskNumber
  dueDate
  createdAt
  isOverdue @client
  isComplete @client
  status {
    id
    name
    displayName
  }
}
    ${ApiFileFieldsFragmentDoc}`;
export const DashboardActivityDocument = gql`
    query DashboardActivity($id: ID!) {
  project(id: $id) {
    id
    overdueTasks @client {
      id
      dueDate
    }
    completedTasks @client {
      id
      dueDate
    }
    tasks {
      id
      dueDate
      isOverdue @client
      isComplete @client
      status {
        id
        name
        displayName
      }
    }
  }
}
    `;

/**
 * __useDashboardActivityQuery__
 *
 * To run a query within a React component, call `useDashboardActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardActivityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDashboardActivityQuery(baseOptions: Apollo.QueryHookOptions<DashboardActivityQuery, DashboardActivityQueryVariables> & ({ variables: DashboardActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardActivityQuery, DashboardActivityQueryVariables>(DashboardActivityDocument, options);
      }
export function useDashboardActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardActivityQuery, DashboardActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardActivityQuery, DashboardActivityQueryVariables>(DashboardActivityDocument, options);
        }
export function useDashboardActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardActivityQuery, DashboardActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardActivityQuery, DashboardActivityQueryVariables>(DashboardActivityDocument, options);
        }
export type DashboardActivityQueryHookResult = ReturnType<typeof useDashboardActivityQuery>;
export type DashboardActivityLazyQueryHookResult = ReturnType<typeof useDashboardActivityLazyQuery>;
export type DashboardActivitySuspenseQueryHookResult = ReturnType<typeof useDashboardActivitySuspenseQuery>;
export type DashboardActivityQueryResult = Apollo.QueryResult<DashboardActivityQuery, DashboardActivityQueryVariables>;
export const GetInstallationFullDocument = gql`
    query GetInstallationFull($id: ID!) {
  installation(id: $id) {
    id
    name
    roomName
    status {
      id
      name
      displayName
    }
    area {
      id
      name
      displayName
    }
    subArea {
      id
      name
      displayName
    }
    product {
      id
      name
      supplier
      manufacturer
      model
      hardware
      finish
      notes
    }
    decisions {
      id
      dueDate
    }
    installationType {
      id
      name
      displayName
    }
    plan {
      id
      name
    }
    estimatedStartDate
  }
}
    `;

/**
 * __useGetInstallationFullQuery__
 *
 * To run a query within a React component, call `useGetInstallationFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstallationFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstallationFullQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInstallationFullQuery(baseOptions: Apollo.QueryHookOptions<GetInstallationFullQuery, GetInstallationFullQueryVariables> & ({ variables: GetInstallationFullQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstallationFullQuery, GetInstallationFullQueryVariables>(GetInstallationFullDocument, options);
      }
export function useGetInstallationFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstallationFullQuery, GetInstallationFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstallationFullQuery, GetInstallationFullQueryVariables>(GetInstallationFullDocument, options);
        }
export function useGetInstallationFullSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInstallationFullQuery, GetInstallationFullQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInstallationFullQuery, GetInstallationFullQueryVariables>(GetInstallationFullDocument, options);
        }
export type GetInstallationFullQueryHookResult = ReturnType<typeof useGetInstallationFullQuery>;
export type GetInstallationFullLazyQueryHookResult = ReturnType<typeof useGetInstallationFullLazyQuery>;
export type GetInstallationFullSuspenseQueryHookResult = ReturnType<typeof useGetInstallationFullSuspenseQuery>;
export type GetInstallationFullQueryResult = Apollo.QueryResult<GetInstallationFullQuery, GetInstallationFullQueryVariables>;
export const NotificationPostedDocument = gql`
    subscription NotificationPosted {
  notificationPosted {
    id
    isRead
    title
    content
  }
}
    `;

/**
 * __useNotificationPostedSubscription__
 *
 * To run a query within a React component, call `useNotificationPostedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNotificationPostedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationPostedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNotificationPostedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<NotificationPostedSubscription, NotificationPostedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NotificationPostedSubscription, NotificationPostedSubscriptionVariables>(NotificationPostedDocument, options);
      }
export type NotificationPostedSubscriptionHookResult = ReturnType<typeof useNotificationPostedSubscription>;
export type NotificationPostedSubscriptionResult = Apollo.SubscriptionResult<NotificationPostedSubscription>;
export const CreateFileMultiPartReservationDocument = gql`
    mutation CreateFileMultiPartReservation($input: CreateMultiPartFileReservationInput!) {
  createMultipartFileReservation(input: $input) {
    id
    signedUploadUrls
    uploadId
  }
}
    `;
export type CreateFileMultiPartReservationMutationFn = Apollo.MutationFunction<CreateFileMultiPartReservationMutation, CreateFileMultiPartReservationMutationVariables>;

/**
 * __useCreateFileMultiPartReservationMutation__
 *
 * To run a mutation, you first call `useCreateFileMultiPartReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFileMultiPartReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFileMultiPartReservationMutation, { data, loading, error }] = useCreateFileMultiPartReservationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFileMultiPartReservationMutation(baseOptions?: Apollo.MutationHookOptions<CreateFileMultiPartReservationMutation, CreateFileMultiPartReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFileMultiPartReservationMutation, CreateFileMultiPartReservationMutationVariables>(CreateFileMultiPartReservationDocument, options);
      }
export type CreateFileMultiPartReservationMutationHookResult = ReturnType<typeof useCreateFileMultiPartReservationMutation>;
export type CreateFileMultiPartReservationMutationResult = Apollo.MutationResult<CreateFileMultiPartReservationMutation>;
export type CreateFileMultiPartReservationMutationOptions = Apollo.BaseMutationOptions<CreateFileMultiPartReservationMutation, CreateFileMultiPartReservationMutationVariables>;
export const FinalizeFileMultiPartReservationDocument = gql`
    mutation FinalizeFileMultiPartReservation($input: FinalizeMultiPartFileReservationInput!) {
  finalizeMultiPartFileReservation(input: $input) {
    id
    apiFile {
      ...apiFileFields
    }
  }
}
    ${ApiFileFieldsFragmentDoc}`;
export type FinalizeFileMultiPartReservationMutationFn = Apollo.MutationFunction<FinalizeFileMultiPartReservationMutation, FinalizeFileMultiPartReservationMutationVariables>;

/**
 * __useFinalizeFileMultiPartReservationMutation__
 *
 * To run a mutation, you first call `useFinalizeFileMultiPartReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeFileMultiPartReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeFileMultiPartReservationMutation, { data, loading, error }] = useFinalizeFileMultiPartReservationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFinalizeFileMultiPartReservationMutation(baseOptions?: Apollo.MutationHookOptions<FinalizeFileMultiPartReservationMutation, FinalizeFileMultiPartReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizeFileMultiPartReservationMutation, FinalizeFileMultiPartReservationMutationVariables>(FinalizeFileMultiPartReservationDocument, options);
      }
export type FinalizeFileMultiPartReservationMutationHookResult = ReturnType<typeof useFinalizeFileMultiPartReservationMutation>;
export type FinalizeFileMultiPartReservationMutationResult = Apollo.MutationResult<FinalizeFileMultiPartReservationMutation>;
export type FinalizeFileMultiPartReservationMutationOptions = Apollo.BaseMutationOptions<FinalizeFileMultiPartReservationMutation, FinalizeFileMultiPartReservationMutationVariables>;
export const GetAccessPolicyDocument = gql`
    query GetAccessPolicy($options: Query_EntityAccessPolicy_OptionsInput!) {
  loggedInUser {
    id
    isSuperAdmin
  }
  entityAccessPolicy(options: $options) @client {
    create
    update
    view
    delete
  }
}
    `;

/**
 * __useGetAccessPolicyQuery__
 *
 * To run a query within a React component, call `useGetAccessPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccessPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccessPolicyQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetAccessPolicyQuery(baseOptions: Apollo.QueryHookOptions<GetAccessPolicyQuery, GetAccessPolicyQueryVariables> & ({ variables: GetAccessPolicyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccessPolicyQuery, GetAccessPolicyQueryVariables>(GetAccessPolicyDocument, options);
      }
export function useGetAccessPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccessPolicyQuery, GetAccessPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccessPolicyQuery, GetAccessPolicyQueryVariables>(GetAccessPolicyDocument, options);
        }
export function useGetAccessPolicySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccessPolicyQuery, GetAccessPolicyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccessPolicyQuery, GetAccessPolicyQueryVariables>(GetAccessPolicyDocument, options);
        }
export type GetAccessPolicyQueryHookResult = ReturnType<typeof useGetAccessPolicyQuery>;
export type GetAccessPolicyLazyQueryHookResult = ReturnType<typeof useGetAccessPolicyLazyQuery>;
export type GetAccessPolicySuspenseQueryHookResult = ReturnType<typeof useGetAccessPolicySuspenseQuery>;
export type GetAccessPolicyQueryResult = Apollo.QueryResult<GetAccessPolicyQuery, GetAccessPolicyQueryVariables>;
export const CreateFileReservationDocument = gql`
    mutation CreateFileReservation($input: CreateFileReservationInput!) {
  createFileReservation(input: $input) {
    id
    signedUploadUrl
  }
}
    `;
export type CreateFileReservationMutationFn = Apollo.MutationFunction<CreateFileReservationMutation, CreateFileReservationMutationVariables>;

/**
 * __useCreateFileReservationMutation__
 *
 * To run a mutation, you first call `useCreateFileReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFileReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFileReservationMutation, { data, loading, error }] = useCreateFileReservationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFileReservationMutation(baseOptions?: Apollo.MutationHookOptions<CreateFileReservationMutation, CreateFileReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFileReservationMutation, CreateFileReservationMutationVariables>(CreateFileReservationDocument, options);
      }
export type CreateFileReservationMutationHookResult = ReturnType<typeof useCreateFileReservationMutation>;
export type CreateFileReservationMutationResult = Apollo.MutationResult<CreateFileReservationMutation>;
export type CreateFileReservationMutationOptions = Apollo.BaseMutationOptions<CreateFileReservationMutation, CreateFileReservationMutationVariables>;
export const FinalizeFileReservationDocument = gql`
    mutation FinalizeFileReservation($id: ID!) {
  finalizeFileReservation(id: $id) {
    id
    apiFile {
      ...apiFileFields
    }
  }
}
    ${ApiFileFieldsFragmentDoc}`;
export type FinalizeFileReservationMutationFn = Apollo.MutationFunction<FinalizeFileReservationMutation, FinalizeFileReservationMutationVariables>;

/**
 * __useFinalizeFileReservationMutation__
 *
 * To run a mutation, you first call `useFinalizeFileReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeFileReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeFileReservationMutation, { data, loading, error }] = useFinalizeFileReservationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFinalizeFileReservationMutation(baseOptions?: Apollo.MutationHookOptions<FinalizeFileReservationMutation, FinalizeFileReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizeFileReservationMutation, FinalizeFileReservationMutationVariables>(FinalizeFileReservationDocument, options);
      }
export type FinalizeFileReservationMutationHookResult = ReturnType<typeof useFinalizeFileReservationMutation>;
export type FinalizeFileReservationMutationResult = Apollo.MutationResult<FinalizeFileReservationMutation>;
export type FinalizeFileReservationMutationOptions = Apollo.BaseMutationOptions<FinalizeFileReservationMutation, FinalizeFileReservationMutationVariables>;
export const AuthStateDocument = gql`
    query AuthState {
  authQuery @client {
    authStatus
  }
}
    `;

/**
 * __useAuthStateQuery__
 *
 * To run a query within a React component, call `useAuthStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthStateQuery(baseOptions?: Apollo.QueryHookOptions<AuthStateQuery, AuthStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthStateQuery, AuthStateQueryVariables>(AuthStateDocument, options);
      }
export function useAuthStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthStateQuery, AuthStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthStateQuery, AuthStateQueryVariables>(AuthStateDocument, options);
        }
export function useAuthStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthStateQuery, AuthStateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthStateQuery, AuthStateQueryVariables>(AuthStateDocument, options);
        }
export type AuthStateQueryHookResult = ReturnType<typeof useAuthStateQuery>;
export type AuthStateLazyQueryHookResult = ReturnType<typeof useAuthStateLazyQuery>;
export type AuthStateSuspenseQueryHookResult = ReturnType<typeof useAuthStateSuspenseQuery>;
export type AuthStateQueryResult = Apollo.QueryResult<AuthStateQuery, AuthStateQueryVariables>;
export const GetMembershipsDocument = gql`
    query GetMemberships {
  loggedInUser {
    id
    isSuperAdmin
    person {
      id
      memberships {
        id
        roles {
          id
          name
          displayName
        }
        project {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetMembershipsQuery__
 *
 * To run a query within a React component, call `useGetMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembershipsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMembershipsQuery(baseOptions?: Apollo.QueryHookOptions<GetMembershipsQuery, GetMembershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMembershipsQuery, GetMembershipsQueryVariables>(GetMembershipsDocument, options);
      }
export function useGetMembershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMembershipsQuery, GetMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMembershipsQuery, GetMembershipsQueryVariables>(GetMembershipsDocument, options);
        }
export function useGetMembershipsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMembershipsQuery, GetMembershipsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMembershipsQuery, GetMembershipsQueryVariables>(GetMembershipsDocument, options);
        }
export type GetMembershipsQueryHookResult = ReturnType<typeof useGetMembershipsQuery>;
export type GetMembershipsLazyQueryHookResult = ReturnType<typeof useGetMembershipsLazyQuery>;
export type GetMembershipsSuspenseQueryHookResult = ReturnType<typeof useGetMembershipsSuspenseQuery>;
export type GetMembershipsQueryResult = Apollo.QueryResult<GetMembershipsQuery, GetMembershipsQueryVariables>;
export const StyledFileUploadFieldDocument = gql`
    query StyledFileUploadField($apiFileId: ID!) {
  apiFile(id: $apiFileId) {
    ...apiFileFields
  }
}
    ${ApiFileFieldsFragmentDoc}`;

/**
 * __useStyledFileUploadFieldQuery__
 *
 * To run a query within a React component, call `useStyledFileUploadFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useStyledFileUploadFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStyledFileUploadFieldQuery({
 *   variables: {
 *      apiFileId: // value for 'apiFileId'
 *   },
 * });
 */
export function useStyledFileUploadFieldQuery(baseOptions: Apollo.QueryHookOptions<StyledFileUploadFieldQuery, StyledFileUploadFieldQueryVariables> & ({ variables: StyledFileUploadFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StyledFileUploadFieldQuery, StyledFileUploadFieldQueryVariables>(StyledFileUploadFieldDocument, options);
      }
export function useStyledFileUploadFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StyledFileUploadFieldQuery, StyledFileUploadFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StyledFileUploadFieldQuery, StyledFileUploadFieldQueryVariables>(StyledFileUploadFieldDocument, options);
        }
export function useStyledFileUploadFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StyledFileUploadFieldQuery, StyledFileUploadFieldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StyledFileUploadFieldQuery, StyledFileUploadFieldQueryVariables>(StyledFileUploadFieldDocument, options);
        }
export type StyledFileUploadFieldQueryHookResult = ReturnType<typeof useStyledFileUploadFieldQuery>;
export type StyledFileUploadFieldLazyQueryHookResult = ReturnType<typeof useStyledFileUploadFieldLazyQuery>;
export type StyledFileUploadFieldSuspenseQueryHookResult = ReturnType<typeof useStyledFileUploadFieldSuspenseQuery>;
export type StyledFileUploadFieldQueryResult = Apollo.QueryResult<StyledFileUploadFieldQuery, StyledFileUploadFieldQueryVariables>;
export const StyledPhotoUploadFieldDocument = gql`
    query StyledPhotoUploadField($apiFileId: ID!) {
  apiFile(id: $apiFileId) {
    ...apiFileFields
  }
}
    ${ApiFileFieldsFragmentDoc}`;

/**
 * __useStyledPhotoUploadFieldQuery__
 *
 * To run a query within a React component, call `useStyledPhotoUploadFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useStyledPhotoUploadFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStyledPhotoUploadFieldQuery({
 *   variables: {
 *      apiFileId: // value for 'apiFileId'
 *   },
 * });
 */
export function useStyledPhotoUploadFieldQuery(baseOptions: Apollo.QueryHookOptions<StyledPhotoUploadFieldQuery, StyledPhotoUploadFieldQueryVariables> & ({ variables: StyledPhotoUploadFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StyledPhotoUploadFieldQuery, StyledPhotoUploadFieldQueryVariables>(StyledPhotoUploadFieldDocument, options);
      }
export function useStyledPhotoUploadFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StyledPhotoUploadFieldQuery, StyledPhotoUploadFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StyledPhotoUploadFieldQuery, StyledPhotoUploadFieldQueryVariables>(StyledPhotoUploadFieldDocument, options);
        }
export function useStyledPhotoUploadFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StyledPhotoUploadFieldQuery, StyledPhotoUploadFieldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StyledPhotoUploadFieldQuery, StyledPhotoUploadFieldQueryVariables>(StyledPhotoUploadFieldDocument, options);
        }
export type StyledPhotoUploadFieldQueryHookResult = ReturnType<typeof useStyledPhotoUploadFieldQuery>;
export type StyledPhotoUploadFieldLazyQueryHookResult = ReturnType<typeof useStyledPhotoUploadFieldLazyQuery>;
export type StyledPhotoUploadFieldSuspenseQueryHookResult = ReturnType<typeof useStyledPhotoUploadFieldSuspenseQuery>;
export type StyledPhotoUploadFieldQueryResult = Apollo.QueryResult<StyledPhotoUploadFieldQuery, StyledPhotoUploadFieldQueryVariables>;
export const NotificationSubscriptionDocument = gql`
    subscription NotificationSubscription {
  notificationPosted {
    id
    isRead
    title
    content
  }
}
    `;

/**
 * __useNotificationSubscriptionSubscription__
 *
 * To run a query within a React component, call `useNotificationSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNotificationSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNotificationSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<NotificationSubscriptionSubscription, NotificationSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NotificationSubscriptionSubscription, NotificationSubscriptionSubscriptionVariables>(NotificationSubscriptionDocument, options);
      }
export type NotificationSubscriptionSubscriptionHookResult = ReturnType<typeof useNotificationSubscriptionSubscription>;
export type NotificationSubscriptionSubscriptionResult = Apollo.SubscriptionResult<NotificationSubscriptionSubscription>;
export const NotificationWidgetDocument = gql`
    query NotificationWidget($options: Query_Notifications_OptionsInput!) {
  notifications(options: $options) {
    id
    title
    content
    isRead
    createdTimestamp
  }
}
    `;

/**
 * __useNotificationWidgetQuery__
 *
 * To run a query within a React component, call `useNotificationWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationWidgetQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useNotificationWidgetQuery(baseOptions: Apollo.QueryHookOptions<NotificationWidgetQuery, NotificationWidgetQueryVariables> & ({ variables: NotificationWidgetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationWidgetQuery, NotificationWidgetQueryVariables>(NotificationWidgetDocument, options);
      }
export function useNotificationWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationWidgetQuery, NotificationWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationWidgetQuery, NotificationWidgetQueryVariables>(NotificationWidgetDocument, options);
        }
export function useNotificationWidgetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotificationWidgetQuery, NotificationWidgetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationWidgetQuery, NotificationWidgetQueryVariables>(NotificationWidgetDocument, options);
        }
export type NotificationWidgetQueryHookResult = ReturnType<typeof useNotificationWidgetQuery>;
export type NotificationWidgetLazyQueryHookResult = ReturnType<typeof useNotificationWidgetLazyQuery>;
export type NotificationWidgetSuspenseQueryHookResult = ReturnType<typeof useNotificationWidgetSuspenseQuery>;
export type NotificationWidgetQueryResult = Apollo.QueryResult<NotificationWidgetQuery, NotificationWidgetQueryVariables>;
export const SaveNotificationWidgetDocument = gql`
    mutation SaveNotificationWidget($input: MarkAllNotificationsAsRead_Input!) {
  markAllNotificationsAsRead(input: $input) {
    id
    isRead
    title
    content
    createdTimestamp
  }
}
    `;
export type SaveNotificationWidgetMutationFn = Apollo.MutationFunction<SaveNotificationWidgetMutation, SaveNotificationWidgetMutationVariables>;

/**
 * __useSaveNotificationWidgetMutation__
 *
 * To run a mutation, you first call `useSaveNotificationWidgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveNotificationWidgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveNotificationWidgetMutation, { data, loading, error }] = useSaveNotificationWidgetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveNotificationWidgetMutation(baseOptions?: Apollo.MutationHookOptions<SaveNotificationWidgetMutation, SaveNotificationWidgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveNotificationWidgetMutation, SaveNotificationWidgetMutationVariables>(SaveNotificationWidgetDocument, options);
      }
export type SaveNotificationWidgetMutationHookResult = ReturnType<typeof useSaveNotificationWidgetMutation>;
export type SaveNotificationWidgetMutationResult = Apollo.MutationResult<SaveNotificationWidgetMutation>;
export type SaveNotificationWidgetMutationOptions = Apollo.BaseMutationOptions<SaveNotificationWidgetMutation, SaveNotificationWidgetMutationVariables>;
export const OrganizationNavBarDocument = gql`
    query OrganizationNavBar($id: ID!) {
  project(id: $id) {
    id
    name
  }
  loggedInUser {
    id
    isSuperAdmin
  }
}
    `;

/**
 * __useOrganizationNavBarQuery__
 *
 * To run a query within a React component, call `useOrganizationNavBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationNavBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationNavBarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationNavBarQuery(baseOptions: Apollo.QueryHookOptions<OrganizationNavBarQuery, OrganizationNavBarQueryVariables> & ({ variables: OrganizationNavBarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationNavBarQuery, OrganizationNavBarQueryVariables>(OrganizationNavBarDocument, options);
      }
export function useOrganizationNavBarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationNavBarQuery, OrganizationNavBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationNavBarQuery, OrganizationNavBarQueryVariables>(OrganizationNavBarDocument, options);
        }
export function useOrganizationNavBarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationNavBarQuery, OrganizationNavBarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationNavBarQuery, OrganizationNavBarQueryVariables>(OrganizationNavBarDocument, options);
        }
export type OrganizationNavBarQueryHookResult = ReturnType<typeof useOrganizationNavBarQuery>;
export type OrganizationNavBarLazyQueryHookResult = ReturnType<typeof useOrganizationNavBarLazyQuery>;
export type OrganizationNavBarSuspenseQueryHookResult = ReturnType<typeof useOrganizationNavBarSuspenseQuery>;
export type OrganizationNavBarQueryResult = Apollo.QueryResult<OrganizationNavBarQuery, OrganizationNavBarQueryVariables>;
export const InspectionResultSelectFieldDocument = gql`
    query InspectionResultSelectField {
  inspectionResults {
    id
    name
    displayName
  }
}
    `;

/**
 * __useInspectionResultSelectFieldQuery__
 *
 * To run a query within a React component, call `useInspectionResultSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectionResultSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectionResultSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useInspectionResultSelectFieldQuery(baseOptions?: Apollo.QueryHookOptions<InspectionResultSelectFieldQuery, InspectionResultSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InspectionResultSelectFieldQuery, InspectionResultSelectFieldQueryVariables>(InspectionResultSelectFieldDocument, options);
      }
export function useInspectionResultSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectionResultSelectFieldQuery, InspectionResultSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InspectionResultSelectFieldQuery, InspectionResultSelectFieldQueryVariables>(InspectionResultSelectFieldDocument, options);
        }
export function useInspectionResultSelectFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InspectionResultSelectFieldQuery, InspectionResultSelectFieldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InspectionResultSelectFieldQuery, InspectionResultSelectFieldQueryVariables>(InspectionResultSelectFieldDocument, options);
        }
export type InspectionResultSelectFieldQueryHookResult = ReturnType<typeof useInspectionResultSelectFieldQuery>;
export type InspectionResultSelectFieldLazyQueryHookResult = ReturnType<typeof useInspectionResultSelectFieldLazyQuery>;
export type InspectionResultSelectFieldSuspenseQueryHookResult = ReturnType<typeof useInspectionResultSelectFieldSuspenseQuery>;
export type InspectionResultSelectFieldQueryResult = Apollo.QueryResult<InspectionResultSelectFieldQuery, InspectionResultSelectFieldQueryVariables>;
export const GetPlanSetsDocument = gql`
    query GetPlanSets($options: Query_PlanSets_OptionsInput!) {
  planSets(options: $options) {
    id
    name
    displayName
  }
}
    `;

/**
 * __useGetPlanSetsQuery__
 *
 * To run a query within a React component, call `useGetPlanSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanSetsQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetPlanSetsQuery(baseOptions: Apollo.QueryHookOptions<GetPlanSetsQuery, GetPlanSetsQueryVariables> & ({ variables: GetPlanSetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlanSetsQuery, GetPlanSetsQueryVariables>(GetPlanSetsDocument, options);
      }
export function useGetPlanSetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlanSetsQuery, GetPlanSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlanSetsQuery, GetPlanSetsQueryVariables>(GetPlanSetsDocument, options);
        }
export function useGetPlanSetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlanSetsQuery, GetPlanSetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlanSetsQuery, GetPlanSetsQueryVariables>(GetPlanSetsDocument, options);
        }
export type GetPlanSetsQueryHookResult = ReturnType<typeof useGetPlanSetsQuery>;
export type GetPlanSetsLazyQueryHookResult = ReturnType<typeof useGetPlanSetsLazyQuery>;
export type GetPlanSetsSuspenseQueryHookResult = ReturnType<typeof useGetPlanSetsSuspenseQuery>;
export type GetPlanSetsQueryResult = Apollo.QueryResult<GetPlanSetsQuery, GetPlanSetsQueryVariables>;
export const SelectFolderDocument = gql`
    query SelectFolder($projectId: ID!) {
  project(id: $projectId) {
    id
    folders {
      id
      name
    }
  }
}
    `;

/**
 * __useSelectFolderQuery__
 *
 * To run a query within a React component, call `useSelectFolderQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectFolderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectFolderQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useSelectFolderQuery(baseOptions: Apollo.QueryHookOptions<SelectFolderQuery, SelectFolderQueryVariables> & ({ variables: SelectFolderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectFolderQuery, SelectFolderQueryVariables>(SelectFolderDocument, options);
      }
export function useSelectFolderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectFolderQuery, SelectFolderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectFolderQuery, SelectFolderQueryVariables>(SelectFolderDocument, options);
        }
export function useSelectFolderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelectFolderQuery, SelectFolderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectFolderQuery, SelectFolderQueryVariables>(SelectFolderDocument, options);
        }
export type SelectFolderQueryHookResult = ReturnType<typeof useSelectFolderQuery>;
export type SelectFolderLazyQueryHookResult = ReturnType<typeof useSelectFolderLazyQuery>;
export type SelectFolderSuspenseQueryHookResult = ReturnType<typeof useSelectFolderSuspenseQuery>;
export type SelectFolderQueryResult = Apollo.QueryResult<SelectFolderQuery, SelectFolderQueryVariables>;
export const SelectInspectorFieldDocument = gql`
    query SelectInspectorField($options: Query_Persons_OptionsInput!) {
  persons(options: $options) {
    id
    firstName
    lastName
    fullName @client
  }
}
    `;

/**
 * __useSelectInspectorFieldQuery__
 *
 * To run a query within a React component, call `useSelectInspectorFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectInspectorFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectInspectorFieldQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useSelectInspectorFieldQuery(baseOptions: Apollo.QueryHookOptions<SelectInspectorFieldQuery, SelectInspectorFieldQueryVariables> & ({ variables: SelectInspectorFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectInspectorFieldQuery, SelectInspectorFieldQueryVariables>(SelectInspectorFieldDocument, options);
      }
export function useSelectInspectorFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectInspectorFieldQuery, SelectInspectorFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectInspectorFieldQuery, SelectInspectorFieldQueryVariables>(SelectInspectorFieldDocument, options);
        }
export function useSelectInspectorFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelectInspectorFieldQuery, SelectInspectorFieldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectInspectorFieldQuery, SelectInspectorFieldQueryVariables>(SelectInspectorFieldDocument, options);
        }
export type SelectInspectorFieldQueryHookResult = ReturnType<typeof useSelectInspectorFieldQuery>;
export type SelectInspectorFieldLazyQueryHookResult = ReturnType<typeof useSelectInspectorFieldLazyQuery>;
export type SelectInspectorFieldSuspenseQueryHookResult = ReturnType<typeof useSelectInspectorFieldSuspenseQuery>;
export type SelectInspectorFieldQueryResult = Apollo.QueryResult<SelectInspectorFieldQuery, SelectInspectorFieldQueryVariables>;
export const GetAllAreasDocument = gql`
    query GetAllAreas {
  areas {
    id
    name
    displayName
  }
}
    `;

/**
 * __useGetAllAreasQuery__
 *
 * To run a query within a React component, call `useGetAllAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAreasQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllAreasQuery(baseOptions?: Apollo.QueryHookOptions<GetAllAreasQuery, GetAllAreasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAreasQuery, GetAllAreasQueryVariables>(GetAllAreasDocument, options);
      }
export function useGetAllAreasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAreasQuery, GetAllAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAreasQuery, GetAllAreasQueryVariables>(GetAllAreasDocument, options);
        }
export function useGetAllAreasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAreasQuery, GetAllAreasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllAreasQuery, GetAllAreasQueryVariables>(GetAllAreasDocument, options);
        }
export type GetAllAreasQueryHookResult = ReturnType<typeof useGetAllAreasQuery>;
export type GetAllAreasLazyQueryHookResult = ReturnType<typeof useGetAllAreasLazyQuery>;
export type GetAllAreasSuspenseQueryHookResult = ReturnType<typeof useGetAllAreasSuspenseQuery>;
export type GetAllAreasQueryResult = Apollo.QueryResult<GetAllAreasQuery, GetAllAreasQueryVariables>;
export const SelectInstallationRoomFieldDocument = gql`
    query SelectInstallationRoomField($id: ID!) {
  project(id: $id) {
    id
    rooms @client {
      name
    }
    installations {
      id
      roomName
    }
  }
}
    `;

/**
 * __useSelectInstallationRoomFieldQuery__
 *
 * To run a query within a React component, call `useSelectInstallationRoomFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectInstallationRoomFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectInstallationRoomFieldQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSelectInstallationRoomFieldQuery(baseOptions: Apollo.QueryHookOptions<SelectInstallationRoomFieldQuery, SelectInstallationRoomFieldQueryVariables> & ({ variables: SelectInstallationRoomFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectInstallationRoomFieldQuery, SelectInstallationRoomFieldQueryVariables>(SelectInstallationRoomFieldDocument, options);
      }
export function useSelectInstallationRoomFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectInstallationRoomFieldQuery, SelectInstallationRoomFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectInstallationRoomFieldQuery, SelectInstallationRoomFieldQueryVariables>(SelectInstallationRoomFieldDocument, options);
        }
export function useSelectInstallationRoomFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelectInstallationRoomFieldQuery, SelectInstallationRoomFieldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectInstallationRoomFieldQuery, SelectInstallationRoomFieldQueryVariables>(SelectInstallationRoomFieldDocument, options);
        }
export type SelectInstallationRoomFieldQueryHookResult = ReturnType<typeof useSelectInstallationRoomFieldQuery>;
export type SelectInstallationRoomFieldLazyQueryHookResult = ReturnType<typeof useSelectInstallationRoomFieldLazyQuery>;
export type SelectInstallationRoomFieldSuspenseQueryHookResult = ReturnType<typeof useSelectInstallationRoomFieldSuspenseQuery>;
export type SelectInstallationRoomFieldQueryResult = Apollo.QueryResult<SelectInstallationRoomFieldQuery, SelectInstallationRoomFieldQueryVariables>;
export const GetAllInstallationStatusesDocument = gql`
    query GetAllInstallationStatuses {
  installationStatuses {
    id
    name
    displayName
  }
}
    `;

/**
 * __useGetAllInstallationStatusesQuery__
 *
 * To run a query within a React component, call `useGetAllInstallationStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllInstallationStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllInstallationStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllInstallationStatusesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllInstallationStatusesQuery, GetAllInstallationStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllInstallationStatusesQuery, GetAllInstallationStatusesQueryVariables>(GetAllInstallationStatusesDocument, options);
      }
export function useGetAllInstallationStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllInstallationStatusesQuery, GetAllInstallationStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllInstallationStatusesQuery, GetAllInstallationStatusesQueryVariables>(GetAllInstallationStatusesDocument, options);
        }
export function useGetAllInstallationStatusesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllInstallationStatusesQuery, GetAllInstallationStatusesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllInstallationStatusesQuery, GetAllInstallationStatusesQueryVariables>(GetAllInstallationStatusesDocument, options);
        }
export type GetAllInstallationStatusesQueryHookResult = ReturnType<typeof useGetAllInstallationStatusesQuery>;
export type GetAllInstallationStatusesLazyQueryHookResult = ReturnType<typeof useGetAllInstallationStatusesLazyQuery>;
export type GetAllInstallationStatusesSuspenseQueryHookResult = ReturnType<typeof useGetAllInstallationStatusesSuspenseQuery>;
export type GetAllInstallationStatusesQueryResult = Apollo.QueryResult<GetAllInstallationStatusesQuery, GetAllInstallationStatusesQueryVariables>;
export const GetAllInstallationTypesDocument = gql`
    query GetAllInstallationTypes {
  installationTypes {
    id
    name
    displayName
  }
}
    `;

/**
 * __useGetAllInstallationTypesQuery__
 *
 * To run a query within a React component, call `useGetAllInstallationTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllInstallationTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllInstallationTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllInstallationTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllInstallationTypesQuery, GetAllInstallationTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllInstallationTypesQuery, GetAllInstallationTypesQueryVariables>(GetAllInstallationTypesDocument, options);
      }
export function useGetAllInstallationTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllInstallationTypesQuery, GetAllInstallationTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllInstallationTypesQuery, GetAllInstallationTypesQueryVariables>(GetAllInstallationTypesDocument, options);
        }
export function useGetAllInstallationTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllInstallationTypesQuery, GetAllInstallationTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllInstallationTypesQuery, GetAllInstallationTypesQueryVariables>(GetAllInstallationTypesDocument, options);
        }
export type GetAllInstallationTypesQueryHookResult = ReturnType<typeof useGetAllInstallationTypesQuery>;
export type GetAllInstallationTypesLazyQueryHookResult = ReturnType<typeof useGetAllInstallationTypesLazyQuery>;
export type GetAllInstallationTypesSuspenseQueryHookResult = ReturnType<typeof useGetAllInstallationTypesSuspenseQuery>;
export type GetAllInstallationTypesQueryResult = Apollo.QueryResult<GetAllInstallationTypesQuery, GetAllInstallationTypesQueryVariables>;
export const SelectMilestoneFieldDocument = gql`
    query SelectMilestoneField($id: ID!) {
  project(id: $id) {
    id
    milestones {
      id
      title
    }
  }
}
    `;

/**
 * __useSelectMilestoneFieldQuery__
 *
 * To run a query within a React component, call `useSelectMilestoneFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectMilestoneFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectMilestoneFieldQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSelectMilestoneFieldQuery(baseOptions: Apollo.QueryHookOptions<SelectMilestoneFieldQuery, SelectMilestoneFieldQueryVariables> & ({ variables: SelectMilestoneFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectMilestoneFieldQuery, SelectMilestoneFieldQueryVariables>(SelectMilestoneFieldDocument, options);
      }
export function useSelectMilestoneFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectMilestoneFieldQuery, SelectMilestoneFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectMilestoneFieldQuery, SelectMilestoneFieldQueryVariables>(SelectMilestoneFieldDocument, options);
        }
export function useSelectMilestoneFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelectMilestoneFieldQuery, SelectMilestoneFieldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectMilestoneFieldQuery, SelectMilestoneFieldQueryVariables>(SelectMilestoneFieldDocument, options);
        }
export type SelectMilestoneFieldQueryHookResult = ReturnType<typeof useSelectMilestoneFieldQuery>;
export type SelectMilestoneFieldLazyQueryHookResult = ReturnType<typeof useSelectMilestoneFieldLazyQuery>;
export type SelectMilestoneFieldSuspenseQueryHookResult = ReturnType<typeof useSelectMilestoneFieldSuspenseQuery>;
export type SelectMilestoneFieldQueryResult = Apollo.QueryResult<SelectMilestoneFieldQuery, SelectMilestoneFieldQueryVariables>;
export const SelectPersonFieldDocument = gql`
    query SelectPersonField($options: Query_Persons_OptionsInput!) {
  persons(options: $options) {
    id
    firstName
    lastName
    createdTimestamp
    preferredEmail
    phoneNumber
    isActive
    profilePicture {
      ...apiFileFields
    }
    fullName @client
  }
}
    ${ApiFileFieldsFragmentDoc}`;

/**
 * __useSelectPersonFieldQuery__
 *
 * To run a query within a React component, call `useSelectPersonFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectPersonFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectPersonFieldQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useSelectPersonFieldQuery(baseOptions: Apollo.QueryHookOptions<SelectPersonFieldQuery, SelectPersonFieldQueryVariables> & ({ variables: SelectPersonFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectPersonFieldQuery, SelectPersonFieldQueryVariables>(SelectPersonFieldDocument, options);
      }
export function useSelectPersonFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectPersonFieldQuery, SelectPersonFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectPersonFieldQuery, SelectPersonFieldQueryVariables>(SelectPersonFieldDocument, options);
        }
export function useSelectPersonFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelectPersonFieldQuery, SelectPersonFieldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectPersonFieldQuery, SelectPersonFieldQueryVariables>(SelectPersonFieldDocument, options);
        }
export type SelectPersonFieldQueryHookResult = ReturnType<typeof useSelectPersonFieldQuery>;
export type SelectPersonFieldLazyQueryHookResult = ReturnType<typeof useSelectPersonFieldLazyQuery>;
export type SelectPersonFieldSuspenseQueryHookResult = ReturnType<typeof useSelectPersonFieldSuspenseQuery>;
export type SelectPersonFieldQueryResult = Apollo.QueryResult<SelectPersonFieldQuery, SelectPersonFieldQueryVariables>;
export const SelectPersonInWorkEventFieldDocument = gql`
    query SelectPersonInWorkEventField($options: Query_Persons_OptionsInput!) {
  persons(options: $options) {
    id
    firstName
    lastName
    fullName @client
  }
}
    `;

/**
 * __useSelectPersonInWorkEventFieldQuery__
 *
 * To run a query within a React component, call `useSelectPersonInWorkEventFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectPersonInWorkEventFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectPersonInWorkEventFieldQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useSelectPersonInWorkEventFieldQuery(baseOptions: Apollo.QueryHookOptions<SelectPersonInWorkEventFieldQuery, SelectPersonInWorkEventFieldQueryVariables> & ({ variables: SelectPersonInWorkEventFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectPersonInWorkEventFieldQuery, SelectPersonInWorkEventFieldQueryVariables>(SelectPersonInWorkEventFieldDocument, options);
      }
export function useSelectPersonInWorkEventFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectPersonInWorkEventFieldQuery, SelectPersonInWorkEventFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectPersonInWorkEventFieldQuery, SelectPersonInWorkEventFieldQueryVariables>(SelectPersonInWorkEventFieldDocument, options);
        }
export function useSelectPersonInWorkEventFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelectPersonInWorkEventFieldQuery, SelectPersonInWorkEventFieldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectPersonInWorkEventFieldQuery, SelectPersonInWorkEventFieldQueryVariables>(SelectPersonInWorkEventFieldDocument, options);
        }
export type SelectPersonInWorkEventFieldQueryHookResult = ReturnType<typeof useSelectPersonInWorkEventFieldQuery>;
export type SelectPersonInWorkEventFieldLazyQueryHookResult = ReturnType<typeof useSelectPersonInWorkEventFieldLazyQuery>;
export type SelectPersonInWorkEventFieldSuspenseQueryHookResult = ReturnType<typeof useSelectPersonInWorkEventFieldSuspenseQuery>;
export type SelectPersonInWorkEventFieldQueryResult = Apollo.QueryResult<SelectPersonInWorkEventFieldQuery, SelectPersonInWorkEventFieldQueryVariables>;
export const SelectPersonsInIncidentFieldDocument = gql`
    query SelectPersonsInIncidentField($options: Query_Persons_OptionsInput!) {
  persons(options: $options) {
    id
    firstName
    lastName
    profilePicture {
      ...apiFileFields
    }
    fullName @client
  }
}
    ${ApiFileFieldsFragmentDoc}`;

/**
 * __useSelectPersonsInIncidentFieldQuery__
 *
 * To run a query within a React component, call `useSelectPersonsInIncidentFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectPersonsInIncidentFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectPersonsInIncidentFieldQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useSelectPersonsInIncidentFieldQuery(baseOptions: Apollo.QueryHookOptions<SelectPersonsInIncidentFieldQuery, SelectPersonsInIncidentFieldQueryVariables> & ({ variables: SelectPersonsInIncidentFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectPersonsInIncidentFieldQuery, SelectPersonsInIncidentFieldQueryVariables>(SelectPersonsInIncidentFieldDocument, options);
      }
export function useSelectPersonsInIncidentFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectPersonsInIncidentFieldQuery, SelectPersonsInIncidentFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectPersonsInIncidentFieldQuery, SelectPersonsInIncidentFieldQueryVariables>(SelectPersonsInIncidentFieldDocument, options);
        }
export function useSelectPersonsInIncidentFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelectPersonsInIncidentFieldQuery, SelectPersonsInIncidentFieldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectPersonsInIncidentFieldQuery, SelectPersonsInIncidentFieldQueryVariables>(SelectPersonsInIncidentFieldDocument, options);
        }
export type SelectPersonsInIncidentFieldQueryHookResult = ReturnType<typeof useSelectPersonsInIncidentFieldQuery>;
export type SelectPersonsInIncidentFieldLazyQueryHookResult = ReturnType<typeof useSelectPersonsInIncidentFieldLazyQuery>;
export type SelectPersonsInIncidentFieldSuspenseQueryHookResult = ReturnType<typeof useSelectPersonsInIncidentFieldSuspenseQuery>;
export type SelectPersonsInIncidentFieldQueryResult = Apollo.QueryResult<SelectPersonsInIncidentFieldQuery, SelectPersonsInIncidentFieldQueryVariables>;
export const SelectPlanFieldDocument = gql`
    query SelectPlanField($options: Query_Plans_OptionsInput!) {
  plans(options: $options) {
    id
    name
  }
}
    `;

/**
 * __useSelectPlanFieldQuery__
 *
 * To run a query within a React component, call `useSelectPlanFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectPlanFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectPlanFieldQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useSelectPlanFieldQuery(baseOptions: Apollo.QueryHookOptions<SelectPlanFieldQuery, SelectPlanFieldQueryVariables> & ({ variables: SelectPlanFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectPlanFieldQuery, SelectPlanFieldQueryVariables>(SelectPlanFieldDocument, options);
      }
export function useSelectPlanFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectPlanFieldQuery, SelectPlanFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectPlanFieldQuery, SelectPlanFieldQueryVariables>(SelectPlanFieldDocument, options);
        }
export function useSelectPlanFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelectPlanFieldQuery, SelectPlanFieldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectPlanFieldQuery, SelectPlanFieldQueryVariables>(SelectPlanFieldDocument, options);
        }
export type SelectPlanFieldQueryHookResult = ReturnType<typeof useSelectPlanFieldQuery>;
export type SelectPlanFieldLazyQueryHookResult = ReturnType<typeof useSelectPlanFieldLazyQuery>;
export type SelectPlanFieldSuspenseQueryHookResult = ReturnType<typeof useSelectPlanFieldSuspenseQuery>;
export type SelectPlanFieldQueryResult = Apollo.QueryResult<SelectPlanFieldQuery, SelectPlanFieldQueryVariables>;
export const SavePlanVersionDocument = gql`
    mutation SavePlanVersion($input: SavePlanVersion_Input!) {
  savePlanVersion(input: $input) {
    ...planVersionFields
  }
}
    ${PlanVersionFieldsFragmentDoc}`;
export type SavePlanVersionMutationFn = Apollo.MutationFunction<SavePlanVersionMutation, SavePlanVersionMutationVariables>;

/**
 * __useSavePlanVersionMutation__
 *
 * To run a mutation, you first call `useSavePlanVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePlanVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePlanVersionMutation, { data, loading, error }] = useSavePlanVersionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePlanVersionMutation(baseOptions?: Apollo.MutationHookOptions<SavePlanVersionMutation, SavePlanVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePlanVersionMutation, SavePlanVersionMutationVariables>(SavePlanVersionDocument, options);
      }
export type SavePlanVersionMutationHookResult = ReturnType<typeof useSavePlanVersionMutation>;
export type SavePlanVersionMutationResult = Apollo.MutationResult<SavePlanVersionMutation>;
export type SavePlanVersionMutationOptions = Apollo.BaseMutationOptions<SavePlanVersionMutation, SavePlanVersionMutationVariables>;
export const SelectPlanVersionFieldDocument = gql`
    query SelectPlanVersionField($id: ID!) {
  plan(id: $id) {
    id
    versions {
      ...planVersionFields
    }
  }
}
    ${PlanVersionFieldsFragmentDoc}`;

/**
 * __useSelectPlanVersionFieldQuery__
 *
 * To run a query within a React component, call `useSelectPlanVersionFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectPlanVersionFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectPlanVersionFieldQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSelectPlanVersionFieldQuery(baseOptions: Apollo.QueryHookOptions<SelectPlanVersionFieldQuery, SelectPlanVersionFieldQueryVariables> & ({ variables: SelectPlanVersionFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectPlanVersionFieldQuery, SelectPlanVersionFieldQueryVariables>(SelectPlanVersionFieldDocument, options);
      }
export function useSelectPlanVersionFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectPlanVersionFieldQuery, SelectPlanVersionFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectPlanVersionFieldQuery, SelectPlanVersionFieldQueryVariables>(SelectPlanVersionFieldDocument, options);
        }
export function useSelectPlanVersionFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelectPlanVersionFieldQuery, SelectPlanVersionFieldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectPlanVersionFieldQuery, SelectPlanVersionFieldQueryVariables>(SelectPlanVersionFieldDocument, options);
        }
export type SelectPlanVersionFieldQueryHookResult = ReturnType<typeof useSelectPlanVersionFieldQuery>;
export type SelectPlanVersionFieldLazyQueryHookResult = ReturnType<typeof useSelectPlanVersionFieldLazyQuery>;
export type SelectPlanVersionFieldSuspenseQueryHookResult = ReturnType<typeof useSelectPlanVersionFieldSuspenseQuery>;
export type SelectPlanVersionFieldQueryResult = Apollo.QueryResult<SelectPlanVersionFieldQuery, SelectPlanVersionFieldQueryVariables>;
export const SelectPrecipitationTypeFieldDocument = gql`
    query SelectPrecipitationTypeField {
  precipitationTypes {
    id
    name
    displayName
  }
}
    `;

/**
 * __useSelectPrecipitationTypeFieldQuery__
 *
 * To run a query within a React component, call `useSelectPrecipitationTypeFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectPrecipitationTypeFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectPrecipitationTypeFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectPrecipitationTypeFieldQuery(baseOptions?: Apollo.QueryHookOptions<SelectPrecipitationTypeFieldQuery, SelectPrecipitationTypeFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectPrecipitationTypeFieldQuery, SelectPrecipitationTypeFieldQueryVariables>(SelectPrecipitationTypeFieldDocument, options);
      }
export function useSelectPrecipitationTypeFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectPrecipitationTypeFieldQuery, SelectPrecipitationTypeFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectPrecipitationTypeFieldQuery, SelectPrecipitationTypeFieldQueryVariables>(SelectPrecipitationTypeFieldDocument, options);
        }
export function useSelectPrecipitationTypeFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelectPrecipitationTypeFieldQuery, SelectPrecipitationTypeFieldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectPrecipitationTypeFieldQuery, SelectPrecipitationTypeFieldQueryVariables>(SelectPrecipitationTypeFieldDocument, options);
        }
export type SelectPrecipitationTypeFieldQueryHookResult = ReturnType<typeof useSelectPrecipitationTypeFieldQuery>;
export type SelectPrecipitationTypeFieldLazyQueryHookResult = ReturnType<typeof useSelectPrecipitationTypeFieldLazyQuery>;
export type SelectPrecipitationTypeFieldSuspenseQueryHookResult = ReturnType<typeof useSelectPrecipitationTypeFieldSuspenseQuery>;
export type SelectPrecipitationTypeFieldQueryResult = Apollo.QueryResult<SelectPrecipitationTypeFieldQuery, SelectPrecipitationTypeFieldQueryVariables>;
export const SelectRoleFieldDocument = gql`
    query SelectRoleField {
  roles {
    id
    name
    displayName
  }
}
    `;

/**
 * __useSelectRoleFieldQuery__
 *
 * To run a query within a React component, call `useSelectRoleFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectRoleFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectRoleFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectRoleFieldQuery(baseOptions?: Apollo.QueryHookOptions<SelectRoleFieldQuery, SelectRoleFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectRoleFieldQuery, SelectRoleFieldQueryVariables>(SelectRoleFieldDocument, options);
      }
export function useSelectRoleFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectRoleFieldQuery, SelectRoleFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectRoleFieldQuery, SelectRoleFieldQueryVariables>(SelectRoleFieldDocument, options);
        }
export function useSelectRoleFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelectRoleFieldQuery, SelectRoleFieldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectRoleFieldQuery, SelectRoleFieldQueryVariables>(SelectRoleFieldDocument, options);
        }
export type SelectRoleFieldQueryHookResult = ReturnType<typeof useSelectRoleFieldQuery>;
export type SelectRoleFieldLazyQueryHookResult = ReturnType<typeof useSelectRoleFieldLazyQuery>;
export type SelectRoleFieldSuspenseQueryHookResult = ReturnType<typeof useSelectRoleFieldSuspenseQuery>;
export type SelectRoleFieldQueryResult = Apollo.QueryResult<SelectRoleFieldQuery, SelectRoleFieldQueryVariables>;
export const SelectStandardTemplateMilestoneFieldDocument = gql`
    query SelectStandardTemplateMilestoneField {
  standardTemplateMilestones {
    id
    title
  }
}
    `;

/**
 * __useSelectStandardTemplateMilestoneFieldQuery__
 *
 * To run a query within a React component, call `useSelectStandardTemplateMilestoneFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectStandardTemplateMilestoneFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectStandardTemplateMilestoneFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectStandardTemplateMilestoneFieldQuery(baseOptions?: Apollo.QueryHookOptions<SelectStandardTemplateMilestoneFieldQuery, SelectStandardTemplateMilestoneFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectStandardTemplateMilestoneFieldQuery, SelectStandardTemplateMilestoneFieldQueryVariables>(SelectStandardTemplateMilestoneFieldDocument, options);
      }
export function useSelectStandardTemplateMilestoneFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectStandardTemplateMilestoneFieldQuery, SelectStandardTemplateMilestoneFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectStandardTemplateMilestoneFieldQuery, SelectStandardTemplateMilestoneFieldQueryVariables>(SelectStandardTemplateMilestoneFieldDocument, options);
        }
export function useSelectStandardTemplateMilestoneFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelectStandardTemplateMilestoneFieldQuery, SelectStandardTemplateMilestoneFieldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectStandardTemplateMilestoneFieldQuery, SelectStandardTemplateMilestoneFieldQueryVariables>(SelectStandardTemplateMilestoneFieldDocument, options);
        }
export type SelectStandardTemplateMilestoneFieldQueryHookResult = ReturnType<typeof useSelectStandardTemplateMilestoneFieldQuery>;
export type SelectStandardTemplateMilestoneFieldLazyQueryHookResult = ReturnType<typeof useSelectStandardTemplateMilestoneFieldLazyQuery>;
export type SelectStandardTemplateMilestoneFieldSuspenseQueryHookResult = ReturnType<typeof useSelectStandardTemplateMilestoneFieldSuspenseQuery>;
export type SelectStandardTemplateMilestoneFieldQueryResult = Apollo.QueryResult<SelectStandardTemplateMilestoneFieldQuery, SelectStandardTemplateMilestoneFieldQueryVariables>;
export const SelectSubAreaFieldDocument = gql`
    query SelectSubAreaField {
  subAreas {
    id
    name
    displayName
  }
}
    `;

/**
 * __useSelectSubAreaFieldQuery__
 *
 * To run a query within a React component, call `useSelectSubAreaFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectSubAreaFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectSubAreaFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectSubAreaFieldQuery(baseOptions?: Apollo.QueryHookOptions<SelectSubAreaFieldQuery, SelectSubAreaFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectSubAreaFieldQuery, SelectSubAreaFieldQueryVariables>(SelectSubAreaFieldDocument, options);
      }
export function useSelectSubAreaFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectSubAreaFieldQuery, SelectSubAreaFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectSubAreaFieldQuery, SelectSubAreaFieldQueryVariables>(SelectSubAreaFieldDocument, options);
        }
export function useSelectSubAreaFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelectSubAreaFieldQuery, SelectSubAreaFieldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectSubAreaFieldQuery, SelectSubAreaFieldQueryVariables>(SelectSubAreaFieldDocument, options);
        }
export type SelectSubAreaFieldQueryHookResult = ReturnType<typeof useSelectSubAreaFieldQuery>;
export type SelectSubAreaFieldLazyQueryHookResult = ReturnType<typeof useSelectSubAreaFieldLazyQuery>;
export type SelectSubAreaFieldSuspenseQueryHookResult = ReturnType<typeof useSelectSubAreaFieldSuspenseQuery>;
export type SelectSubAreaFieldQueryResult = Apollo.QueryResult<SelectSubAreaFieldQuery, SelectSubAreaFieldQueryVariables>;
export const SelectTaskAssigneeFieldDocument = gql`
    query SelectTaskAssigneeField($id: ID!) {
  persons(options: {filter: {projectId: $id}}) {
    id
    firstName
    lastName
    fullName @client
  }
}
    `;

/**
 * __useSelectTaskAssigneeFieldQuery__
 *
 * To run a query within a React component, call `useSelectTaskAssigneeFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectTaskAssigneeFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectTaskAssigneeFieldQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSelectTaskAssigneeFieldQuery(baseOptions: Apollo.QueryHookOptions<SelectTaskAssigneeFieldQuery, SelectTaskAssigneeFieldQueryVariables> & ({ variables: SelectTaskAssigneeFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectTaskAssigneeFieldQuery, SelectTaskAssigneeFieldQueryVariables>(SelectTaskAssigneeFieldDocument, options);
      }
export function useSelectTaskAssigneeFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectTaskAssigneeFieldQuery, SelectTaskAssigneeFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectTaskAssigneeFieldQuery, SelectTaskAssigneeFieldQueryVariables>(SelectTaskAssigneeFieldDocument, options);
        }
export function useSelectTaskAssigneeFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelectTaskAssigneeFieldQuery, SelectTaskAssigneeFieldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectTaskAssigneeFieldQuery, SelectTaskAssigneeFieldQueryVariables>(SelectTaskAssigneeFieldDocument, options);
        }
export type SelectTaskAssigneeFieldQueryHookResult = ReturnType<typeof useSelectTaskAssigneeFieldQuery>;
export type SelectTaskAssigneeFieldLazyQueryHookResult = ReturnType<typeof useSelectTaskAssigneeFieldLazyQuery>;
export type SelectTaskAssigneeFieldSuspenseQueryHookResult = ReturnType<typeof useSelectTaskAssigneeFieldSuspenseQuery>;
export type SelectTaskAssigneeFieldQueryResult = Apollo.QueryResult<SelectTaskAssigneeFieldQuery, SelectTaskAssigneeFieldQueryVariables>;
export const SelectTaskCategoryFieldDocument = gql`
    query SelectTaskCategoryField {
  taskCategories {
    id
    name
    displayName
  }
}
    `;

/**
 * __useSelectTaskCategoryFieldQuery__
 *
 * To run a query within a React component, call `useSelectTaskCategoryFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectTaskCategoryFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectTaskCategoryFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectTaskCategoryFieldQuery(baseOptions?: Apollo.QueryHookOptions<SelectTaskCategoryFieldQuery, SelectTaskCategoryFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectTaskCategoryFieldQuery, SelectTaskCategoryFieldQueryVariables>(SelectTaskCategoryFieldDocument, options);
      }
export function useSelectTaskCategoryFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectTaskCategoryFieldQuery, SelectTaskCategoryFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectTaskCategoryFieldQuery, SelectTaskCategoryFieldQueryVariables>(SelectTaskCategoryFieldDocument, options);
        }
export function useSelectTaskCategoryFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelectTaskCategoryFieldQuery, SelectTaskCategoryFieldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectTaskCategoryFieldQuery, SelectTaskCategoryFieldQueryVariables>(SelectTaskCategoryFieldDocument, options);
        }
export type SelectTaskCategoryFieldQueryHookResult = ReturnType<typeof useSelectTaskCategoryFieldQuery>;
export type SelectTaskCategoryFieldLazyQueryHookResult = ReturnType<typeof useSelectTaskCategoryFieldLazyQuery>;
export type SelectTaskCategoryFieldSuspenseQueryHookResult = ReturnType<typeof useSelectTaskCategoryFieldSuspenseQuery>;
export type SelectTaskCategoryFieldQueryResult = Apollo.QueryResult<SelectTaskCategoryFieldQuery, SelectTaskCategoryFieldQueryVariables>;
export const SelectWeatherConditionFieldDocument = gql`
    query SelectWeatherConditionField {
  weatherConditions {
    id
    name
    displayName
  }
}
    `;

/**
 * __useSelectWeatherConditionFieldQuery__
 *
 * To run a query within a React component, call `useSelectWeatherConditionFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectWeatherConditionFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectWeatherConditionFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectWeatherConditionFieldQuery(baseOptions?: Apollo.QueryHookOptions<SelectWeatherConditionFieldQuery, SelectWeatherConditionFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectWeatherConditionFieldQuery, SelectWeatherConditionFieldQueryVariables>(SelectWeatherConditionFieldDocument, options);
      }
export function useSelectWeatherConditionFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectWeatherConditionFieldQuery, SelectWeatherConditionFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectWeatherConditionFieldQuery, SelectWeatherConditionFieldQueryVariables>(SelectWeatherConditionFieldDocument, options);
        }
export function useSelectWeatherConditionFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelectWeatherConditionFieldQuery, SelectWeatherConditionFieldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectWeatherConditionFieldQuery, SelectWeatherConditionFieldQueryVariables>(SelectWeatherConditionFieldDocument, options);
        }
export type SelectWeatherConditionFieldQueryHookResult = ReturnType<typeof useSelectWeatherConditionFieldQuery>;
export type SelectWeatherConditionFieldLazyQueryHookResult = ReturnType<typeof useSelectWeatherConditionFieldLazyQuery>;
export type SelectWeatherConditionFieldSuspenseQueryHookResult = ReturnType<typeof useSelectWeatherConditionFieldSuspenseQuery>;
export type SelectWeatherConditionFieldQueryResult = Apollo.QueryResult<SelectWeatherConditionFieldQuery, SelectWeatherConditionFieldQueryVariables>;
export const SelectWorkTradeFieldDocument = gql`
    query SelectWorkTradeField {
  workTrades {
    id
    name
    displayName
  }
}
    `;

/**
 * __useSelectWorkTradeFieldQuery__
 *
 * To run a query within a React component, call `useSelectWorkTradeFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectWorkTradeFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectWorkTradeFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectWorkTradeFieldQuery(baseOptions?: Apollo.QueryHookOptions<SelectWorkTradeFieldQuery, SelectWorkTradeFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectWorkTradeFieldQuery, SelectWorkTradeFieldQueryVariables>(SelectWorkTradeFieldDocument, options);
      }
export function useSelectWorkTradeFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectWorkTradeFieldQuery, SelectWorkTradeFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectWorkTradeFieldQuery, SelectWorkTradeFieldQueryVariables>(SelectWorkTradeFieldDocument, options);
        }
export function useSelectWorkTradeFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelectWorkTradeFieldQuery, SelectWorkTradeFieldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectWorkTradeFieldQuery, SelectWorkTradeFieldQueryVariables>(SelectWorkTradeFieldDocument, options);
        }
export type SelectWorkTradeFieldQueryHookResult = ReturnType<typeof useSelectWorkTradeFieldQuery>;
export type SelectWorkTradeFieldLazyQueryHookResult = ReturnType<typeof useSelectWorkTradeFieldLazyQuery>;
export type SelectWorkTradeFieldSuspenseQueryHookResult = ReturnType<typeof useSelectWorkTradeFieldSuspenseQuery>;
export type SelectWorkTradeFieldQueryResult = Apollo.QueryResult<SelectWorkTradeFieldQuery, SelectWorkTradeFieldQueryVariables>;
export const FolderQrCodeDocument = gql`
    query FolderQrCode($folderId: ID!) {
  folder(id: $folderId) {
    id
    name
    project {
      id
      name
    }
  }
}
    `;

/**
 * __useFolderQrCodeQuery__
 *
 * To run a query within a React component, call `useFolderQrCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFolderQrCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFolderQrCodeQuery({
 *   variables: {
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useFolderQrCodeQuery(baseOptions: Apollo.QueryHookOptions<FolderQrCodeQuery, FolderQrCodeQueryVariables> & ({ variables: FolderQrCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FolderQrCodeQuery, FolderQrCodeQueryVariables>(FolderQrCodeDocument, options);
      }
export function useFolderQrCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FolderQrCodeQuery, FolderQrCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FolderQrCodeQuery, FolderQrCodeQueryVariables>(FolderQrCodeDocument, options);
        }
export function useFolderQrCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FolderQrCodeQuery, FolderQrCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FolderQrCodeQuery, FolderQrCodeQueryVariables>(FolderQrCodeDocument, options);
        }
export type FolderQrCodeQueryHookResult = ReturnType<typeof useFolderQrCodeQuery>;
export type FolderQrCodeLazyQueryHookResult = ReturnType<typeof useFolderQrCodeLazyQuery>;
export type FolderQrCodeSuspenseQueryHookResult = ReturnType<typeof useFolderQrCodeSuspenseQuery>;
export type FolderQrCodeQueryResult = Apollo.QueryResult<FolderQrCodeQuery, FolderQrCodeQueryVariables>;
export const PdfViewerDocument = gql`
    query PdfViewer($id: ID!) {
  apiFile(id: $id) {
    ...apiFileFields
  }
}
    ${ApiFileFieldsFragmentDoc}`;

/**
 * __usePdfViewerQuery__
 *
 * To run a query within a React component, call `usePdfViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdfViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdfViewerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePdfViewerQuery(baseOptions: Apollo.QueryHookOptions<PdfViewerQuery, PdfViewerQueryVariables> & ({ variables: PdfViewerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdfViewerQuery, PdfViewerQueryVariables>(PdfViewerDocument, options);
      }
export function usePdfViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdfViewerQuery, PdfViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdfViewerQuery, PdfViewerQueryVariables>(PdfViewerDocument, options);
        }
export function usePdfViewerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PdfViewerQuery, PdfViewerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PdfViewerQuery, PdfViewerQueryVariables>(PdfViewerDocument, options);
        }
export type PdfViewerQueryHookResult = ReturnType<typeof usePdfViewerQuery>;
export type PdfViewerLazyQueryHookResult = ReturnType<typeof usePdfViewerLazyQuery>;
export type PdfViewerSuspenseQueryHookResult = ReturnType<typeof usePdfViewerSuspenseQuery>;
export type PdfViewerQueryResult = Apollo.QueryResult<PdfViewerQuery, PdfViewerQueryVariables>;
export const ApproveDailyReportDocument = gql`
    mutation ApproveDailyReport($id: ID!) {
  approveDailyReport(id: $id) {
    id
    approvedAt
    approvedBy {
      id
      firstName
      lastName
      fullName @client
    }
  }
}
    `;
export type ApproveDailyReportMutationFn = Apollo.MutationFunction<ApproveDailyReportMutation, ApproveDailyReportMutationVariables>;

/**
 * __useApproveDailyReportMutation__
 *
 * To run a mutation, you first call `useApproveDailyReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveDailyReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveDailyReportMutation, { data, loading, error }] = useApproveDailyReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveDailyReportMutation(baseOptions?: Apollo.MutationHookOptions<ApproveDailyReportMutation, ApproveDailyReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveDailyReportMutation, ApproveDailyReportMutationVariables>(ApproveDailyReportDocument, options);
      }
export type ApproveDailyReportMutationHookResult = ReturnType<typeof useApproveDailyReportMutation>;
export type ApproveDailyReportMutationResult = Apollo.MutationResult<ApproveDailyReportMutation>;
export type ApproveDailyReportMutationOptions = Apollo.BaseMutationOptions<ApproveDailyReportMutation, ApproveDailyReportMutationVariables>;
export const CreateDocumentsDocument = gql`
    mutation CreateDocuments($input: CreateDocuments_Input!) {
  createDocuments(input: $input) {
    ...saveDocumentFields
  }
}
    ${SaveDocumentFieldsFragmentDoc}`;
export type CreateDocumentsMutationFn = Apollo.MutationFunction<CreateDocumentsMutation, CreateDocumentsMutationVariables>;

/**
 * __useCreateDocumentsMutation__
 *
 * To run a mutation, you first call `useCreateDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentsMutation, { data, loading, error }] = useCreateDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<CreateDocumentsMutation, CreateDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDocumentsMutation, CreateDocumentsMutationVariables>(CreateDocumentsDocument, options);
      }
export type CreateDocumentsMutationHookResult = ReturnType<typeof useCreateDocumentsMutation>;
export type CreateDocumentsMutationResult = Apollo.MutationResult<CreateDocumentsMutation>;
export type CreateDocumentsMutationOptions = Apollo.BaseMutationOptions<CreateDocumentsMutation, CreateDocumentsMutationVariables>;
export const CreateRoomsDocument = gql`
    mutation CreateRooms($input: CreateRooms_Input!) {
  createRooms(input: $input) {
    id
    estimatedStartDate
    startDate
    name
    estimatedCompletionDate
    locationAddress {
      ...addressFields
    }
    memberships {
      id
    }
    tasks {
      id
    }
    installations {
      id
      startDate
      name
      roomName
    }
    milestones {
      id
      title
      estimatedStartDate
      startDate
    }
  }
}
    ${AddressFieldsFragmentDoc}`;
export type CreateRoomsMutationFn = Apollo.MutationFunction<CreateRoomsMutation, CreateRoomsMutationVariables>;

/**
 * __useCreateRoomsMutation__
 *
 * To run a mutation, you first call `useCreateRoomsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoomsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoomsMutation, { data, loading, error }] = useCreateRoomsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRoomsMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoomsMutation, CreateRoomsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoomsMutation, CreateRoomsMutationVariables>(CreateRoomsDocument, options);
      }
export type CreateRoomsMutationHookResult = ReturnType<typeof useCreateRoomsMutation>;
export type CreateRoomsMutationResult = Apollo.MutationResult<CreateRoomsMutation>;
export type CreateRoomsMutationOptions = Apollo.BaseMutationOptions<CreateRoomsMutation, CreateRoomsMutationVariables>;
export const InviteNonUserDocument = gql`
    mutation InviteNonUser($input: InviteNonUser_Input!) {
  inviteNonUser(input: $input) {
    id
    person {
      id
      firstName
      lastName
      memberships {
        id
        roles {
          id
          name
          displayName
        }
      }
      fullName @client
    }
  }
}
    `;
export type InviteNonUserMutationFn = Apollo.MutationFunction<InviteNonUserMutation, InviteNonUserMutationVariables>;

/**
 * __useInviteNonUserMutation__
 *
 * To run a mutation, you first call `useInviteNonUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteNonUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteNonUserMutation, { data, loading, error }] = useInviteNonUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteNonUserMutation(baseOptions?: Apollo.MutationHookOptions<InviteNonUserMutation, InviteNonUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteNonUserMutation, InviteNonUserMutationVariables>(InviteNonUserDocument, options);
      }
export type InviteNonUserMutationHookResult = ReturnType<typeof useInviteNonUserMutation>;
export type InviteNonUserMutationResult = Apollo.MutationResult<InviteNonUserMutation>;
export type InviteNonUserMutationOptions = Apollo.BaseMutationOptions<InviteNonUserMutation, InviteNonUserMutationVariables>;
export const InvitePersonDocument = gql`
    mutation InvitePerson($input: Invite_InviteUserInput!) {
  inviteUser(input: $input) {
    id
    person {
      id
      profilePicture {
        ...apiFileFields
      }
      firstName
      lastName
      phoneNumber
      preferredEmail
      createdTimestamp
      fullName @client
    }
  }
}
    ${ApiFileFieldsFragmentDoc}`;
export type InvitePersonMutationFn = Apollo.MutationFunction<InvitePersonMutation, InvitePersonMutationVariables>;

/**
 * __useInvitePersonMutation__
 *
 * To run a mutation, you first call `useInvitePersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvitePersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invitePersonMutation, { data, loading, error }] = useInvitePersonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvitePersonMutation(baseOptions?: Apollo.MutationHookOptions<InvitePersonMutation, InvitePersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvitePersonMutation, InvitePersonMutationVariables>(InvitePersonDocument, options);
      }
export type InvitePersonMutationHookResult = ReturnType<typeof useInvitePersonMutation>;
export type InvitePersonMutationResult = Apollo.MutationResult<InvitePersonMutation>;
export type InvitePersonMutationOptions = Apollo.BaseMutationOptions<InvitePersonMutation, InvitePersonMutationVariables>;
export const RegisterDocument = gql`
    mutation Register($input: SiteUser_RegisterInput!) {
  siteUser_register(input: $input) {
    id
    person {
      id
      isActive
      firstName
      lastName
      memberships {
        id
        createdTimestamp
        project {
          id
        }
      }
      fullName @client
    }
  }
}
    `;
export type RegisterMutationFn = Apollo.MutationFunction<RegisterMutation, RegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const RemoveClientReportDocument = gql`
    mutation RemoveClientReport($id: ID!) {
  removeClientReport(id: $id)
}
    `;
export type RemoveClientReportMutationFn = Apollo.MutationFunction<RemoveClientReportMutation, RemoveClientReportMutationVariables>;

/**
 * __useRemoveClientReportMutation__
 *
 * To run a mutation, you first call `useRemoveClientReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveClientReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeClientReportMutation, { data, loading, error }] = useRemoveClientReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveClientReportMutation(baseOptions?: Apollo.MutationHookOptions<RemoveClientReportMutation, RemoveClientReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveClientReportMutation, RemoveClientReportMutationVariables>(RemoveClientReportDocument, options);
      }
export type RemoveClientReportMutationHookResult = ReturnType<typeof useRemoveClientReportMutation>;
export type RemoveClientReportMutationResult = Apollo.MutationResult<RemoveClientReportMutation>;
export type RemoveClientReportMutationOptions = Apollo.BaseMutationOptions<RemoveClientReportMutation, RemoveClientReportMutationVariables>;
export const RemoveDecisionDocument = gql`
    mutation RemoveDecision($id: ID!) {
  removeDecision(id: $id) {
    id
  }
}
    `;
export type RemoveDecisionMutationFn = Apollo.MutationFunction<RemoveDecisionMutation, RemoveDecisionMutationVariables>;

/**
 * __useRemoveDecisionMutation__
 *
 * To run a mutation, you first call `useRemoveDecisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDecisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDecisionMutation, { data, loading, error }] = useRemoveDecisionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveDecisionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDecisionMutation, RemoveDecisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDecisionMutation, RemoveDecisionMutationVariables>(RemoveDecisionDocument, options);
      }
export type RemoveDecisionMutationHookResult = ReturnType<typeof useRemoveDecisionMutation>;
export type RemoveDecisionMutationResult = Apollo.MutationResult<RemoveDecisionMutation>;
export type RemoveDecisionMutationOptions = Apollo.BaseMutationOptions<RemoveDecisionMutation, RemoveDecisionMutationVariables>;
export const RemoveIncidentDocument = gql`
    mutation RemoveIncident($id: ID!) {
  removeIncident(id: $id)
}
    `;
export type RemoveIncidentMutationFn = Apollo.MutationFunction<RemoveIncidentMutation, RemoveIncidentMutationVariables>;

/**
 * __useRemoveIncidentMutation__
 *
 * To run a mutation, you first call `useRemoveIncidentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveIncidentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeIncidentMutation, { data, loading, error }] = useRemoveIncidentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveIncidentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveIncidentMutation, RemoveIncidentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveIncidentMutation, RemoveIncidentMutationVariables>(RemoveIncidentDocument, options);
      }
export type RemoveIncidentMutationHookResult = ReturnType<typeof useRemoveIncidentMutation>;
export type RemoveIncidentMutationResult = Apollo.MutationResult<RemoveIncidentMutation>;
export type RemoveIncidentMutationOptions = Apollo.BaseMutationOptions<RemoveIncidentMutation, RemoveIncidentMutationVariables>;
export const RemoveInspectionDocument = gql`
    mutation RemoveInspection($id: ID!) {
  removeInspection(id: $id)
}
    `;
export type RemoveInspectionMutationFn = Apollo.MutationFunction<RemoveInspectionMutation, RemoveInspectionMutationVariables>;

/**
 * __useRemoveInspectionMutation__
 *
 * To run a mutation, you first call `useRemoveInspectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveInspectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeInspectionMutation, { data, loading, error }] = useRemoveInspectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveInspectionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveInspectionMutation, RemoveInspectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveInspectionMutation, RemoveInspectionMutationVariables>(RemoveInspectionDocument, options);
      }
export type RemoveInspectionMutationHookResult = ReturnType<typeof useRemoveInspectionMutation>;
export type RemoveInspectionMutationResult = Apollo.MutationResult<RemoveInspectionMutation>;
export type RemoveInspectionMutationOptions = Apollo.BaseMutationOptions<RemoveInspectionMutation, RemoveInspectionMutationVariables>;
export const RemoveInstallationDocument = gql`
    mutation RemoveInstallation($id: ID!) {
  removeInstallation(id: $id)
}
    `;
export type RemoveInstallationMutationFn = Apollo.MutationFunction<RemoveInstallationMutation, RemoveInstallationMutationVariables>;

/**
 * __useRemoveInstallationMutation__
 *
 * To run a mutation, you first call `useRemoveInstallationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveInstallationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeInstallationMutation, { data, loading, error }] = useRemoveInstallationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveInstallationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveInstallationMutation, RemoveInstallationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveInstallationMutation, RemoveInstallationMutationVariables>(RemoveInstallationDocument, options);
      }
export type RemoveInstallationMutationHookResult = ReturnType<typeof useRemoveInstallationMutation>;
export type RemoveInstallationMutationResult = Apollo.MutationResult<RemoveInstallationMutation>;
export type RemoveInstallationMutationOptions = Apollo.BaseMutationOptions<RemoveInstallationMutation, RemoveInstallationMutationVariables>;
export const RemoveMembershipDocument = gql`
    mutation RemoveMembership($id: ID!) {
  removeMembership(id: $id)
}
    `;
export type RemoveMembershipMutationFn = Apollo.MutationFunction<RemoveMembershipMutation, RemoveMembershipMutationVariables>;

/**
 * __useRemoveMembershipMutation__
 *
 * To run a mutation, you first call `useRemoveMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMembershipMutation, { data, loading, error }] = useRemoveMembershipMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveMembershipMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMembershipMutation, RemoveMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMembershipMutation, RemoveMembershipMutationVariables>(RemoveMembershipDocument, options);
      }
export type RemoveMembershipMutationHookResult = ReturnType<typeof useRemoveMembershipMutation>;
export type RemoveMembershipMutationResult = Apollo.MutationResult<RemoveMembershipMutation>;
export type RemoveMembershipMutationOptions = Apollo.BaseMutationOptions<RemoveMembershipMutation, RemoveMembershipMutationVariables>;
export const RemoveMilestoneDocument = gql`
    mutation RemoveMilestone($id: ID!) {
  removeMilestone(id: $id)
}
    `;
export type RemoveMilestoneMutationFn = Apollo.MutationFunction<RemoveMilestoneMutation, RemoveMilestoneMutationVariables>;

/**
 * __useRemoveMilestoneMutation__
 *
 * To run a mutation, you first call `useRemoveMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMilestoneMutation, { data, loading, error }] = useRemoveMilestoneMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveMilestoneMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMilestoneMutation, RemoveMilestoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMilestoneMutation, RemoveMilestoneMutationVariables>(RemoveMilestoneDocument, options);
      }
export type RemoveMilestoneMutationHookResult = ReturnType<typeof useRemoveMilestoneMutation>;
export type RemoveMilestoneMutationResult = Apollo.MutationResult<RemoveMilestoneMutation>;
export type RemoveMilestoneMutationOptions = Apollo.BaseMutationOptions<RemoveMilestoneMutation, RemoveMilestoneMutationVariables>;
export const RemovePlanDocument = gql`
    mutation RemovePlan($input: RemovePlan_Input!) {
  removePlan(input: $input)
}
    `;
export type RemovePlanMutationFn = Apollo.MutationFunction<RemovePlanMutation, RemovePlanMutationVariables>;

/**
 * __useRemovePlanMutation__
 *
 * To run a mutation, you first call `useRemovePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePlanMutation, { data, loading, error }] = useRemovePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemovePlanMutation(baseOptions?: Apollo.MutationHookOptions<RemovePlanMutation, RemovePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePlanMutation, RemovePlanMutationVariables>(RemovePlanDocument, options);
      }
export type RemovePlanMutationHookResult = ReturnType<typeof useRemovePlanMutation>;
export type RemovePlanMutationResult = Apollo.MutationResult<RemovePlanMutation>;
export type RemovePlanMutationOptions = Apollo.BaseMutationOptions<RemovePlanMutation, RemovePlanMutationVariables>;
export const RemovePlanSetDocument = gql`
    mutation RemovePlanSet($id: ID!) {
  removePlanSet(id: $id) {
    id
  }
}
    `;
export type RemovePlanSetMutationFn = Apollo.MutationFunction<RemovePlanSetMutation, RemovePlanSetMutationVariables>;

/**
 * __useRemovePlanSetMutation__
 *
 * To run a mutation, you first call `useRemovePlanSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePlanSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePlanSetMutation, { data, loading, error }] = useRemovePlanSetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemovePlanSetMutation(baseOptions?: Apollo.MutationHookOptions<RemovePlanSetMutation, RemovePlanSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePlanSetMutation, RemovePlanSetMutationVariables>(RemovePlanSetDocument, options);
      }
export type RemovePlanSetMutationHookResult = ReturnType<typeof useRemovePlanSetMutation>;
export type RemovePlanSetMutationResult = Apollo.MutationResult<RemovePlanSetMutation>;
export type RemovePlanSetMutationOptions = Apollo.BaseMutationOptions<RemovePlanSetMutation, RemovePlanSetMutationVariables>;
export const RemoveProjectDocument = gql`
    mutation RemoveProject($id: ID!) {
  removeProject(id: $id)
}
    `;
export type RemoveProjectMutationFn = Apollo.MutationFunction<RemoveProjectMutation, RemoveProjectMutationVariables>;

/**
 * __useRemoveProjectMutation__
 *
 * To run a mutation, you first call `useRemoveProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProjectMutation, { data, loading, error }] = useRemoveProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveProjectMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProjectMutation, RemoveProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProjectMutation, RemoveProjectMutationVariables>(RemoveProjectDocument, options);
      }
export type RemoveProjectMutationHookResult = ReturnType<typeof useRemoveProjectMutation>;
export type RemoveProjectMutationResult = Apollo.MutationResult<RemoveProjectMutation>;
export type RemoveProjectMutationOptions = Apollo.BaseMutationOptions<RemoveProjectMutation, RemoveProjectMutationVariables>;
export const RemoveStandardAreaInstallationDocument = gql`
    mutation RemoveStandardAreaInstallation($id: ID!) {
  removeStandardAreaInstallation(id: $id) {
    id
  }
}
    `;
export type RemoveStandardAreaInstallationMutationFn = Apollo.MutationFunction<RemoveStandardAreaInstallationMutation, RemoveStandardAreaInstallationMutationVariables>;

/**
 * __useRemoveStandardAreaInstallationMutation__
 *
 * To run a mutation, you first call `useRemoveStandardAreaInstallationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveStandardAreaInstallationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeStandardAreaInstallationMutation, { data, loading, error }] = useRemoveStandardAreaInstallationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveStandardAreaInstallationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveStandardAreaInstallationMutation, RemoveStandardAreaInstallationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveStandardAreaInstallationMutation, RemoveStandardAreaInstallationMutationVariables>(RemoveStandardAreaInstallationDocument, options);
      }
export type RemoveStandardAreaInstallationMutationHookResult = ReturnType<typeof useRemoveStandardAreaInstallationMutation>;
export type RemoveStandardAreaInstallationMutationResult = Apollo.MutationResult<RemoveStandardAreaInstallationMutation>;
export type RemoveStandardAreaInstallationMutationOptions = Apollo.BaseMutationOptions<RemoveStandardAreaInstallationMutation, RemoveStandardAreaInstallationMutationVariables>;
export const ClientReportFormDocument = gql`
    query ClientReportForm($id: ID!) {
  clientReport(id: $id) {
    id
    description
    approvedAt
  }
}
    `;

/**
 * __useClientReportFormQuery__
 *
 * To run a query within a React component, call `useClientReportFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientReportFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientReportFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientReportFormQuery(baseOptions: Apollo.QueryHookOptions<ClientReportFormQuery, ClientReportFormQueryVariables> & ({ variables: ClientReportFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientReportFormQuery, ClientReportFormQueryVariables>(ClientReportFormDocument, options);
      }
export function useClientReportFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientReportFormQuery, ClientReportFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientReportFormQuery, ClientReportFormQueryVariables>(ClientReportFormDocument, options);
        }
export function useClientReportFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClientReportFormQuery, ClientReportFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientReportFormQuery, ClientReportFormQueryVariables>(ClientReportFormDocument, options);
        }
export type ClientReportFormQueryHookResult = ReturnType<typeof useClientReportFormQuery>;
export type ClientReportFormLazyQueryHookResult = ReturnType<typeof useClientReportFormLazyQuery>;
export type ClientReportFormSuspenseQueryHookResult = ReturnType<typeof useClientReportFormSuspenseQuery>;
export type ClientReportFormQueryResult = Apollo.QueryResult<ClientReportFormQuery, ClientReportFormQueryVariables>;
export const SaveClientReportDocument = gql`
    mutation SaveClientReport($input: SaveClientReport_Input!) {
  saveClientReport(input: $input) {
    id
    milestones {
      id
    }
    inspections {
      id
    }
    photos {
      id
    }
    links {
      id
    }
    attachments {
      id
    }
    deliveries {
      id
    }
    createdAt
    updatedAt
    startDate
    endDate
    description
    approvedBy {
      id
      firstName
      lastName
      fullName @client
    }
    approvedAt
  }
}
    `;
export type SaveClientReportMutationFn = Apollo.MutationFunction<SaveClientReportMutation, SaveClientReportMutationVariables>;

/**
 * __useSaveClientReportMutation__
 *
 * To run a mutation, you first call `useSaveClientReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveClientReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveClientReportMutation, { data, loading, error }] = useSaveClientReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveClientReportMutation(baseOptions?: Apollo.MutationHookOptions<SaveClientReportMutation, SaveClientReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveClientReportMutation, SaveClientReportMutationVariables>(SaveClientReportDocument, options);
      }
export type SaveClientReportMutationHookResult = ReturnType<typeof useSaveClientReportMutation>;
export type SaveClientReportMutationResult = Apollo.MutationResult<SaveClientReportMutation>;
export type SaveClientReportMutationOptions = Apollo.BaseMutationOptions<SaveClientReportMutation, SaveClientReportMutationVariables>;
export const ClientReportLinkFormDocument = gql`
    query ClientReportLinkForm($id: ID!) {
  clientReportLink(id: $id) {
    id
    createdAt
    notesForClient
    url
  }
}
    `;

/**
 * __useClientReportLinkFormQuery__
 *
 * To run a query within a React component, call `useClientReportLinkFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientReportLinkFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientReportLinkFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientReportLinkFormQuery(baseOptions: Apollo.QueryHookOptions<ClientReportLinkFormQuery, ClientReportLinkFormQueryVariables> & ({ variables: ClientReportLinkFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientReportLinkFormQuery, ClientReportLinkFormQueryVariables>(ClientReportLinkFormDocument, options);
      }
export function useClientReportLinkFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientReportLinkFormQuery, ClientReportLinkFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientReportLinkFormQuery, ClientReportLinkFormQueryVariables>(ClientReportLinkFormDocument, options);
        }
export function useClientReportLinkFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClientReportLinkFormQuery, ClientReportLinkFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientReportLinkFormQuery, ClientReportLinkFormQueryVariables>(ClientReportLinkFormDocument, options);
        }
export type ClientReportLinkFormQueryHookResult = ReturnType<typeof useClientReportLinkFormQuery>;
export type ClientReportLinkFormLazyQueryHookResult = ReturnType<typeof useClientReportLinkFormLazyQuery>;
export type ClientReportLinkFormSuspenseQueryHookResult = ReturnType<typeof useClientReportLinkFormSuspenseQuery>;
export type ClientReportLinkFormQueryResult = Apollo.QueryResult<ClientReportLinkFormQuery, ClientReportLinkFormQueryVariables>;
export const SaveClientReportLinkDocument = gql`
    mutation SaveClientReportLink($input: SaveClientReportLink_Input!) {
  saveClientReportLink(input: $input) {
    id
    createdAt
    notesForClient
    url
  }
}
    `;
export type SaveClientReportLinkMutationFn = Apollo.MutationFunction<SaveClientReportLinkMutation, SaveClientReportLinkMutationVariables>;

/**
 * __useSaveClientReportLinkMutation__
 *
 * To run a mutation, you first call `useSaveClientReportLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveClientReportLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveClientReportLinkMutation, { data, loading, error }] = useSaveClientReportLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveClientReportLinkMutation(baseOptions?: Apollo.MutationHookOptions<SaveClientReportLinkMutation, SaveClientReportLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveClientReportLinkMutation, SaveClientReportLinkMutationVariables>(SaveClientReportLinkDocument, options);
      }
export type SaveClientReportLinkMutationHookResult = ReturnType<typeof useSaveClientReportLinkMutation>;
export type SaveClientReportLinkMutationResult = Apollo.MutationResult<SaveClientReportLinkMutation>;
export type SaveClientReportLinkMutationOptions = Apollo.BaseMutationOptions<SaveClientReportLinkMutation, SaveClientReportLinkMutationVariables>;
export const SaveCommentDocument = gql`
    mutation SaveComment($input: SaveComment_Input!) {
  saveComment(input: $input) {
    id
    person {
      id
      firstName
      lastName
      fullName @client
    }
    createdAt
    description
  }
}
    `;
export type SaveCommentMutationFn = Apollo.MutationFunction<SaveCommentMutation, SaveCommentMutationVariables>;

/**
 * __useSaveCommentMutation__
 *
 * To run a mutation, you first call `useSaveCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCommentMutation, { data, loading, error }] = useSaveCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCommentMutation(baseOptions?: Apollo.MutationHookOptions<SaveCommentMutation, SaveCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCommentMutation, SaveCommentMutationVariables>(SaveCommentDocument, options);
      }
export type SaveCommentMutationHookResult = ReturnType<typeof useSaveCommentMutation>;
export type SaveCommentMutationResult = Apollo.MutationResult<SaveCommentMutation>;
export type SaveCommentMutationOptions = Apollo.BaseMutationOptions<SaveCommentMutation, SaveCommentMutationVariables>;
export const DailyReportFormDocument = gql`
    query DailyReportForm($id: ID!) {
  dailyReport(id: $id) {
    id
    reportDate
    description
    project {
      id
    }
  }
}
    `;

/**
 * __useDailyReportFormQuery__
 *
 * To run a query within a React component, call `useDailyReportFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyReportFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyReportFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDailyReportFormQuery(baseOptions: Apollo.QueryHookOptions<DailyReportFormQuery, DailyReportFormQueryVariables> & ({ variables: DailyReportFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DailyReportFormQuery, DailyReportFormQueryVariables>(DailyReportFormDocument, options);
      }
export function useDailyReportFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DailyReportFormQuery, DailyReportFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DailyReportFormQuery, DailyReportFormQueryVariables>(DailyReportFormDocument, options);
        }
export function useDailyReportFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DailyReportFormQuery, DailyReportFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DailyReportFormQuery, DailyReportFormQueryVariables>(DailyReportFormDocument, options);
        }
export type DailyReportFormQueryHookResult = ReturnType<typeof useDailyReportFormQuery>;
export type DailyReportFormLazyQueryHookResult = ReturnType<typeof useDailyReportFormLazyQuery>;
export type DailyReportFormSuspenseQueryHookResult = ReturnType<typeof useDailyReportFormSuspenseQuery>;
export type DailyReportFormQueryResult = Apollo.QueryResult<DailyReportFormQuery, DailyReportFormQueryVariables>;
export const SaveDailyReportDocument = gql`
    mutation SaveDailyReport($input: SaveDailyReport_Input!) {
  saveDailyReport(input: $input) {
    id
    description
    reportDate
    approvedAt
    incidents {
      id
    }
    inspections {
      id
    }
    deliveries {
      id
    }
    workLog {
      id
    }
    approvedBy {
      id
      firstName
      lastName
      profilePicture {
        ...apiFileFields
      }
      phoneNumber
      preferredEmail
      fullName @client
    }
    numberOfIncidents @client
    numberOfDeliveries @client
    numberOfInspections @client
    numberOfWorkEvents @client
  }
}
    ${ApiFileFieldsFragmentDoc}`;
export type SaveDailyReportMutationFn = Apollo.MutationFunction<SaveDailyReportMutation, SaveDailyReportMutationVariables>;

/**
 * __useSaveDailyReportMutation__
 *
 * To run a mutation, you first call `useSaveDailyReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDailyReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDailyReportMutation, { data, loading, error }] = useSaveDailyReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDailyReportMutation(baseOptions?: Apollo.MutationHookOptions<SaveDailyReportMutation, SaveDailyReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDailyReportMutation, SaveDailyReportMutationVariables>(SaveDailyReportDocument, options);
      }
export type SaveDailyReportMutationHookResult = ReturnType<typeof useSaveDailyReportMutation>;
export type SaveDailyReportMutationResult = Apollo.MutationResult<SaveDailyReportMutation>;
export type SaveDailyReportMutationOptions = Apollo.BaseMutationOptions<SaveDailyReportMutation, SaveDailyReportMutationVariables>;
export const SaveDailyReportPhotoDocument = gql`
    mutation SaveDailyReportPhoto($input: SaveDailyReportPhoto_Input!) {
  saveDailyReportPhoto(input: $input) {
    id
  }
}
    `;
export type SaveDailyReportPhotoMutationFn = Apollo.MutationFunction<SaveDailyReportPhotoMutation, SaveDailyReportPhotoMutationVariables>;

/**
 * __useSaveDailyReportPhotoMutation__
 *
 * To run a mutation, you first call `useSaveDailyReportPhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDailyReportPhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDailyReportPhotoMutation, { data, loading, error }] = useSaveDailyReportPhotoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDailyReportPhotoMutation(baseOptions?: Apollo.MutationHookOptions<SaveDailyReportPhotoMutation, SaveDailyReportPhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDailyReportPhotoMutation, SaveDailyReportPhotoMutationVariables>(SaveDailyReportPhotoDocument, options);
      }
export type SaveDailyReportPhotoMutationHookResult = ReturnType<typeof useSaveDailyReportPhotoMutation>;
export type SaveDailyReportPhotoMutationResult = Apollo.MutationResult<SaveDailyReportPhotoMutation>;
export type SaveDailyReportPhotoMutationOptions = Apollo.BaseMutationOptions<SaveDailyReportPhotoMutation, SaveDailyReportPhotoMutationVariables>;
export const GetDecisionDetailDocument = gql`
    query GetDecisionDetail($id: ID!) {
  decision(id: $id) {
    id
    dueDate
    title
    description
    type {
      id
      name
      displayName
    }
    approved
    assignee {
      id
      fullName @client
    }
  }
}
    `;

/**
 * __useGetDecisionDetailQuery__
 *
 * To run a query within a React component, call `useGetDecisionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDecisionDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDecisionDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDecisionDetailQuery(baseOptions: Apollo.QueryHookOptions<GetDecisionDetailQuery, GetDecisionDetailQueryVariables> & ({ variables: GetDecisionDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDecisionDetailQuery, GetDecisionDetailQueryVariables>(GetDecisionDetailDocument, options);
      }
export function useGetDecisionDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDecisionDetailQuery, GetDecisionDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDecisionDetailQuery, GetDecisionDetailQueryVariables>(GetDecisionDetailDocument, options);
        }
export function useGetDecisionDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDecisionDetailQuery, GetDecisionDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDecisionDetailQuery, GetDecisionDetailQueryVariables>(GetDecisionDetailDocument, options);
        }
export type GetDecisionDetailQueryHookResult = ReturnType<typeof useGetDecisionDetailQuery>;
export type GetDecisionDetailLazyQueryHookResult = ReturnType<typeof useGetDecisionDetailLazyQuery>;
export type GetDecisionDetailSuspenseQueryHookResult = ReturnType<typeof useGetDecisionDetailSuspenseQuery>;
export type GetDecisionDetailQueryResult = Apollo.QueryResult<GetDecisionDetailQuery, GetDecisionDetailQueryVariables>;
export const SaveDecisionDocument = gql`
    mutation SaveDecision($input: SaveDecision_Input!) {
  saveDecision(input: $input) {
    id
    title
    description
    dueDate
    approved
    isOverdue @client
    isComplete @client
    isDueSoon @client
    type {
      id
      name
      displayName
    }
    decidedTimestamp
  }
}
    `;
export type SaveDecisionMutationFn = Apollo.MutationFunction<SaveDecisionMutation, SaveDecisionMutationVariables>;

/**
 * __useSaveDecisionMutation__
 *
 * To run a mutation, you first call `useSaveDecisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDecisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDecisionMutation, { data, loading, error }] = useSaveDecisionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDecisionMutation(baseOptions?: Apollo.MutationHookOptions<SaveDecisionMutation, SaveDecisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDecisionMutation, SaveDecisionMutationVariables>(SaveDecisionDocument, options);
      }
export type SaveDecisionMutationHookResult = ReturnType<typeof useSaveDecisionMutation>;
export type SaveDecisionMutationResult = Apollo.MutationResult<SaveDecisionMutation>;
export type SaveDecisionMutationOptions = Apollo.BaseMutationOptions<SaveDecisionMutation, SaveDecisionMutationVariables>;
export const GetDeliveryDetailDocument = gql`
    query GetDeliveryDetail($id: ID!) {
  materialDelivery(id: $id) {
    id
    attachments {
      ...apiFileFields
    }
    createdTimestamp
    estimatedDeliveryDate
    receivedDate
    name
    description
    quantity
    damageDescription
    issueDescription
    otherDescription
  }
}
    ${ApiFileFieldsFragmentDoc}`;

/**
 * __useGetDeliveryDetailQuery__
 *
 * To run a query within a React component, call `useGetDeliveryDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveryDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveryDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDeliveryDetailQuery(baseOptions: Apollo.QueryHookOptions<GetDeliveryDetailQuery, GetDeliveryDetailQueryVariables> & ({ variables: GetDeliveryDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliveryDetailQuery, GetDeliveryDetailQueryVariables>(GetDeliveryDetailDocument, options);
      }
export function useGetDeliveryDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliveryDetailQuery, GetDeliveryDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliveryDetailQuery, GetDeliveryDetailQueryVariables>(GetDeliveryDetailDocument, options);
        }
export function useGetDeliveryDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeliveryDetailQuery, GetDeliveryDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDeliveryDetailQuery, GetDeliveryDetailQueryVariables>(GetDeliveryDetailDocument, options);
        }
export type GetDeliveryDetailQueryHookResult = ReturnType<typeof useGetDeliveryDetailQuery>;
export type GetDeliveryDetailLazyQueryHookResult = ReturnType<typeof useGetDeliveryDetailLazyQuery>;
export type GetDeliveryDetailSuspenseQueryHookResult = ReturnType<typeof useGetDeliveryDetailSuspenseQuery>;
export type GetDeliveryDetailQueryResult = Apollo.QueryResult<GetDeliveryDetailQuery, GetDeliveryDetailQueryVariables>;
export const RemoveDeliveryAttachmentDocument = gql`
    mutation RemoveDeliveryAttachment($input: RemoveImageFromDelivery_Input!) {
  removeImageFromDelivery(input: $input) {
    id
    attachments {
      ...apiFileFields
    }
    receivedDate
    name
    description
    quantity
    damageDescription
    issueDescription
    otherDescription
    estimatedDeliveryDate
    createdTimestamp
    __typename
  }
}
    ${ApiFileFieldsFragmentDoc}`;
export type RemoveDeliveryAttachmentMutationFn = Apollo.MutationFunction<RemoveDeliveryAttachmentMutation, RemoveDeliveryAttachmentMutationVariables>;

/**
 * __useRemoveDeliveryAttachmentMutation__
 *
 * To run a mutation, you first call `useRemoveDeliveryAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDeliveryAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDeliveryAttachmentMutation, { data, loading, error }] = useRemoveDeliveryAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveDeliveryAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDeliveryAttachmentMutation, RemoveDeliveryAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDeliveryAttachmentMutation, RemoveDeliveryAttachmentMutationVariables>(RemoveDeliveryAttachmentDocument, options);
      }
export type RemoveDeliveryAttachmentMutationHookResult = ReturnType<typeof useRemoveDeliveryAttachmentMutation>;
export type RemoveDeliveryAttachmentMutationResult = Apollo.MutationResult<RemoveDeliveryAttachmentMutation>;
export type RemoveDeliveryAttachmentMutationOptions = Apollo.BaseMutationOptions<RemoveDeliveryAttachmentMutation, RemoveDeliveryAttachmentMutationVariables>;
export const SaveDeliveryDocument = gql`
    mutation SaveDelivery($input: SaveDelivery_Input!) {
  saveDelivery(input: $input) {
    id
    attachments {
      ...apiFileFields
    }
    receivedDate
    name
    description
    quantity
    damageDescription
    issueDescription
    otherDescription
    estimatedDeliveryDate
    createdTimestamp
    __typename
  }
}
    ${ApiFileFieldsFragmentDoc}`;
export type SaveDeliveryMutationFn = Apollo.MutationFunction<SaveDeliveryMutation, SaveDeliveryMutationVariables>;

/**
 * __useSaveDeliveryMutation__
 *
 * To run a mutation, you first call `useSaveDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDeliveryMutation, { data, loading, error }] = useSaveDeliveryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<SaveDeliveryMutation, SaveDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDeliveryMutation, SaveDeliveryMutationVariables>(SaveDeliveryDocument, options);
      }
export type SaveDeliveryMutationHookResult = ReturnType<typeof useSaveDeliveryMutation>;
export type SaveDeliveryMutationResult = Apollo.MutationResult<SaveDeliveryMutation>;
export type SaveDeliveryMutationOptions = Apollo.BaseMutationOptions<SaveDeliveryMutation, SaveDeliveryMutationVariables>;
export const SaveDocumentDocument = gql`
    mutation SaveDocument($input: SaveDocumentInput!) {
  saveDocument(input: $input) {
    ...saveDocumentFields
  }
}
    ${SaveDocumentFieldsFragmentDoc}`;
export type SaveDocumentMutationFn = Apollo.MutationFunction<SaveDocumentMutation, SaveDocumentMutationVariables>;

/**
 * __useSaveDocumentMutation__
 *
 * To run a mutation, you first call `useSaveDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDocumentMutation, { data, loading, error }] = useSaveDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDocumentMutation(baseOptions?: Apollo.MutationHookOptions<SaveDocumentMutation, SaveDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDocumentMutation, SaveDocumentMutationVariables>(SaveDocumentDocument, options);
      }
export type SaveDocumentMutationHookResult = ReturnType<typeof useSaveDocumentMutation>;
export type SaveDocumentMutationResult = Apollo.MutationResult<SaveDocumentMutation>;
export type SaveDocumentMutationOptions = Apollo.BaseMutationOptions<SaveDocumentMutation, SaveDocumentMutationVariables>;
export const SaveDocumentFormDocument = gql`
    query SaveDocumentForm($id: ID!) {
  document(id: $id) {
    ...saveDocumentFields
  }
}
    ${SaveDocumentFieldsFragmentDoc}`;

/**
 * __useSaveDocumentFormQuery__
 *
 * To run a query within a React component, call `useSaveDocumentFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaveDocumentFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaveDocumentFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSaveDocumentFormQuery(baseOptions: Apollo.QueryHookOptions<SaveDocumentFormQuery, SaveDocumentFormQueryVariables> & ({ variables: SaveDocumentFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SaveDocumentFormQuery, SaveDocumentFormQueryVariables>(SaveDocumentFormDocument, options);
      }
export function useSaveDocumentFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SaveDocumentFormQuery, SaveDocumentFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SaveDocumentFormQuery, SaveDocumentFormQueryVariables>(SaveDocumentFormDocument, options);
        }
export function useSaveDocumentFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SaveDocumentFormQuery, SaveDocumentFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SaveDocumentFormQuery, SaveDocumentFormQueryVariables>(SaveDocumentFormDocument, options);
        }
export type SaveDocumentFormQueryHookResult = ReturnType<typeof useSaveDocumentFormQuery>;
export type SaveDocumentFormLazyQueryHookResult = ReturnType<typeof useSaveDocumentFormLazyQuery>;
export type SaveDocumentFormSuspenseQueryHookResult = ReturnType<typeof useSaveDocumentFormSuspenseQuery>;
export type SaveDocumentFormQueryResult = Apollo.QueryResult<SaveDocumentFormQuery, SaveDocumentFormQueryVariables>;
export const SaveFolderDocument = gql`
    mutation SaveFolder($input: SaveFolderInput!) {
  saveFolder(input: $input) {
    id
    createdTimestamp
    documents {
      ...saveDocumentFields
    }
    parent {
      id
    }
    updatedTimestamp
    name
    fileCount
  }
}
    ${SaveDocumentFieldsFragmentDoc}`;
export type SaveFolderMutationFn = Apollo.MutationFunction<SaveFolderMutation, SaveFolderMutationVariables>;

/**
 * __useSaveFolderMutation__
 *
 * To run a mutation, you first call `useSaveFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFolderMutation, { data, loading, error }] = useSaveFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveFolderMutation(baseOptions?: Apollo.MutationHookOptions<SaveFolderMutation, SaveFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveFolderMutation, SaveFolderMutationVariables>(SaveFolderDocument, options);
      }
export type SaveFolderMutationHookResult = ReturnType<typeof useSaveFolderMutation>;
export type SaveFolderMutationResult = Apollo.MutationResult<SaveFolderMutation>;
export type SaveFolderMutationOptions = Apollo.BaseMutationOptions<SaveFolderMutation, SaveFolderMutationVariables>;
export const SaveFolderFormDocument = gql`
    query SaveFolderForm($id: ID!) {
  folder(id: $id) {
    id
    parent {
      id
    }
    createdTimestamp
    updatedTimestamp
    name
    fileCount
  }
}
    `;

/**
 * __useSaveFolderFormQuery__
 *
 * To run a query within a React component, call `useSaveFolderFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaveFolderFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaveFolderFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSaveFolderFormQuery(baseOptions: Apollo.QueryHookOptions<SaveFolderFormQuery, SaveFolderFormQueryVariables> & ({ variables: SaveFolderFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SaveFolderFormQuery, SaveFolderFormQueryVariables>(SaveFolderFormDocument, options);
      }
export function useSaveFolderFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SaveFolderFormQuery, SaveFolderFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SaveFolderFormQuery, SaveFolderFormQueryVariables>(SaveFolderFormDocument, options);
        }
export function useSaveFolderFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SaveFolderFormQuery, SaveFolderFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SaveFolderFormQuery, SaveFolderFormQueryVariables>(SaveFolderFormDocument, options);
        }
export type SaveFolderFormQueryHookResult = ReturnType<typeof useSaveFolderFormQuery>;
export type SaveFolderFormLazyQueryHookResult = ReturnType<typeof useSaveFolderFormLazyQuery>;
export type SaveFolderFormSuspenseQueryHookResult = ReturnType<typeof useSaveFolderFormSuspenseQuery>;
export type SaveFolderFormQueryResult = Apollo.QueryResult<SaveFolderFormQuery, SaveFolderFormQueryVariables>;
export const IncidentFormDocument = gql`
    query IncidentForm($id: ID!) {
  incident(id: $id) {
    id
    createdOn
    issueDate
    personsInvolved {
      id
      firstName
      lastName
      profilePicture {
        ...apiFileFields
      }
      fullName @client
    }
    description
    project {
      id
    }
  }
}
    ${ApiFileFieldsFragmentDoc}`;

/**
 * __useIncidentFormQuery__
 *
 * To run a query within a React component, call `useIncidentFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncidentFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncidentFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIncidentFormQuery(baseOptions: Apollo.QueryHookOptions<IncidentFormQuery, IncidentFormQueryVariables> & ({ variables: IncidentFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IncidentFormQuery, IncidentFormQueryVariables>(IncidentFormDocument, options);
      }
export function useIncidentFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IncidentFormQuery, IncidentFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IncidentFormQuery, IncidentFormQueryVariables>(IncidentFormDocument, options);
        }
export function useIncidentFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IncidentFormQuery, IncidentFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IncidentFormQuery, IncidentFormQueryVariables>(IncidentFormDocument, options);
        }
export type IncidentFormQueryHookResult = ReturnType<typeof useIncidentFormQuery>;
export type IncidentFormLazyQueryHookResult = ReturnType<typeof useIncidentFormLazyQuery>;
export type IncidentFormSuspenseQueryHookResult = ReturnType<typeof useIncidentFormSuspenseQuery>;
export type IncidentFormQueryResult = Apollo.QueryResult<IncidentFormQuery, IncidentFormQueryVariables>;
export const SaveIncidentDocument = gql`
    mutation SaveIncident($input: SaveIncident_Input!) {
  saveIncident(input: $input) {
    id
    createdOn
    issueDate
    description
    project {
      id
    }
    personsInvolved {
      id
      firstName
      lastName
      phoneNumber
      preferredEmail
      profilePicture {
        ...apiFileFields
      }
      fullName @client
    }
  }
}
    ${ApiFileFieldsFragmentDoc}`;
export type SaveIncidentMutationFn = Apollo.MutationFunction<SaveIncidentMutation, SaveIncidentMutationVariables>;

/**
 * __useSaveIncidentMutation__
 *
 * To run a mutation, you first call `useSaveIncidentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveIncidentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveIncidentMutation, { data, loading, error }] = useSaveIncidentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveIncidentMutation(baseOptions?: Apollo.MutationHookOptions<SaveIncidentMutation, SaveIncidentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveIncidentMutation, SaveIncidentMutationVariables>(SaveIncidentDocument, options);
      }
export type SaveIncidentMutationHookResult = ReturnType<typeof useSaveIncidentMutation>;
export type SaveIncidentMutationResult = Apollo.MutationResult<SaveIncidentMutation>;
export type SaveIncidentMutationOptions = Apollo.BaseMutationOptions<SaveIncidentMutation, SaveIncidentMutationVariables>;
export const InspectionFormDocument = gql`
    query InspectionForm($id: ID!) {
  inspection(id: $id) {
    id
    createdAt
    inspectedSystem
    dateInspected
    inspectedBy {
      id
      firstName
      lastName
      fullName @client
    }
    description
    inspectionResult {
      id
      name
      displayName
    }
    project {
      id
    }
  }
}
    `;

/**
 * __useInspectionFormQuery__
 *
 * To run a query within a React component, call `useInspectionFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectionFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectionFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInspectionFormQuery(baseOptions: Apollo.QueryHookOptions<InspectionFormQuery, InspectionFormQueryVariables> & ({ variables: InspectionFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InspectionFormQuery, InspectionFormQueryVariables>(InspectionFormDocument, options);
      }
export function useInspectionFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectionFormQuery, InspectionFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InspectionFormQuery, InspectionFormQueryVariables>(InspectionFormDocument, options);
        }
export function useInspectionFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InspectionFormQuery, InspectionFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InspectionFormQuery, InspectionFormQueryVariables>(InspectionFormDocument, options);
        }
export type InspectionFormQueryHookResult = ReturnType<typeof useInspectionFormQuery>;
export type InspectionFormLazyQueryHookResult = ReturnType<typeof useInspectionFormLazyQuery>;
export type InspectionFormSuspenseQueryHookResult = ReturnType<typeof useInspectionFormSuspenseQuery>;
export type InspectionFormQueryResult = Apollo.QueryResult<InspectionFormQuery, InspectionFormQueryVariables>;
export const SaveInspectionDocument = gql`
    mutation SaveInspection($input: SaveInspection_Input!) {
  saveInspection(input: $input) {
    id
    createdAt
    dateInspected
    inspectedSystem
    inspectedBy {
      id
      firstName
      lastName
      fullName @client
    }
    description
    inspectionResult {
      id
      name
      displayName
    }
    project {
      id
    }
  }
}
    `;
export type SaveInspectionMutationFn = Apollo.MutationFunction<SaveInspectionMutation, SaveInspectionMutationVariables>;

/**
 * __useSaveInspectionMutation__
 *
 * To run a mutation, you first call `useSaveInspectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveInspectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveInspectionMutation, { data, loading, error }] = useSaveInspectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveInspectionMutation(baseOptions?: Apollo.MutationHookOptions<SaveInspectionMutation, SaveInspectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveInspectionMutation, SaveInspectionMutationVariables>(SaveInspectionDocument, options);
      }
export type SaveInspectionMutationHookResult = ReturnType<typeof useSaveInspectionMutation>;
export type SaveInspectionMutationResult = Apollo.MutationResult<SaveInspectionMutation>;
export type SaveInspectionMutationOptions = Apollo.BaseMutationOptions<SaveInspectionMutation, SaveInspectionMutationVariables>;
export const SaveInstallationDocument = gql`
    mutation SaveInstallation($input: SaveInstallation_Input!) {
  saveInstallation(input: $input) {
    id
    endDate
    name
    roomName
    estimatedStartDate
    startDate
    durationInDays
    endDate
    area {
      id
      name
      displayName
    }
    id
    plan {
      id
      createdDate
      updatedDate
      name
      planSet {
        id
        name
        displayName
      }
      versions {
        ...planVersionFields
      }
    }
    associatedDeliveries {
      id
      name
    }
    subArea {
      id
      name
      displayName
    }
    installationType {
      id
      name
      displayName
    }
    milestone {
      id
    }
    purchaseDate
    status {
      id
      name
      displayName
    }
    decisions {
      id
      title
    }
    isComplete @client
    isOverDue @client
    isDueSoon @client
  }
}
    ${PlanVersionFieldsFragmentDoc}`;
export type SaveInstallationMutationFn = Apollo.MutationFunction<SaveInstallationMutation, SaveInstallationMutationVariables>;

/**
 * __useSaveInstallationMutation__
 *
 * To run a mutation, you first call `useSaveInstallationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveInstallationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveInstallationMutation, { data, loading, error }] = useSaveInstallationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveInstallationMutation(baseOptions?: Apollo.MutationHookOptions<SaveInstallationMutation, SaveInstallationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveInstallationMutation, SaveInstallationMutationVariables>(SaveInstallationDocument, options);
      }
export type SaveInstallationMutationHookResult = ReturnType<typeof useSaveInstallationMutation>;
export type SaveInstallationMutationResult = Apollo.MutationResult<SaveInstallationMutation>;
export type SaveInstallationMutationOptions = Apollo.BaseMutationOptions<SaveInstallationMutation, SaveInstallationMutationVariables>;
export const SaveInstallationFormDocument = gql`
    query SaveInstallationForm($id: ID!) {
  installation(id: $id) {
    id
    endDate
    name
    estimatedStartDate
    roomName
    startDate
    durationInDays
    endDate
    area {
      id
      name
      displayName
    }
    milestone {
      id
    }
    subArea {
      id
      name
      displayName
    }
    installationType {
      id
      name
      displayName
    }
    purchaseDate
    status {
      id
      name
      displayName
    }
  }
}
    `;

/**
 * __useSaveInstallationFormQuery__
 *
 * To run a query within a React component, call `useSaveInstallationFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaveInstallationFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaveInstallationFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSaveInstallationFormQuery(baseOptions: Apollo.QueryHookOptions<SaveInstallationFormQuery, SaveInstallationFormQueryVariables> & ({ variables: SaveInstallationFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SaveInstallationFormQuery, SaveInstallationFormQueryVariables>(SaveInstallationFormDocument, options);
      }
export function useSaveInstallationFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SaveInstallationFormQuery, SaveInstallationFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SaveInstallationFormQuery, SaveInstallationFormQueryVariables>(SaveInstallationFormDocument, options);
        }
export function useSaveInstallationFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SaveInstallationFormQuery, SaveInstallationFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SaveInstallationFormQuery, SaveInstallationFormQueryVariables>(SaveInstallationFormDocument, options);
        }
export type SaveInstallationFormQueryHookResult = ReturnType<typeof useSaveInstallationFormQuery>;
export type SaveInstallationFormLazyQueryHookResult = ReturnType<typeof useSaveInstallationFormLazyQuery>;
export type SaveInstallationFormSuspenseQueryHookResult = ReturnType<typeof useSaveInstallationFormSuspenseQuery>;
export type SaveInstallationFormQueryResult = Apollo.QueryResult<SaveInstallationFormQuery, SaveInstallationFormQueryVariables>;
export const SaveInstallationPlanFormDocument = gql`
    query SaveInstallationPlanForm($id: ID!) {
  installation(id: $id) {
    id
    plan {
      id
      createdDate
    }
  }
}
    `;

/**
 * __useSaveInstallationPlanFormQuery__
 *
 * To run a query within a React component, call `useSaveInstallationPlanFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaveInstallationPlanFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaveInstallationPlanFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSaveInstallationPlanFormQuery(baseOptions: Apollo.QueryHookOptions<SaveInstallationPlanFormQuery, SaveInstallationPlanFormQueryVariables> & ({ variables: SaveInstallationPlanFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SaveInstallationPlanFormQuery, SaveInstallationPlanFormQueryVariables>(SaveInstallationPlanFormDocument, options);
      }
export function useSaveInstallationPlanFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SaveInstallationPlanFormQuery, SaveInstallationPlanFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SaveInstallationPlanFormQuery, SaveInstallationPlanFormQueryVariables>(SaveInstallationPlanFormDocument, options);
        }
export function useSaveInstallationPlanFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SaveInstallationPlanFormQuery, SaveInstallationPlanFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SaveInstallationPlanFormQuery, SaveInstallationPlanFormQueryVariables>(SaveInstallationPlanFormDocument, options);
        }
export type SaveInstallationPlanFormQueryHookResult = ReturnType<typeof useSaveInstallationPlanFormQuery>;
export type SaveInstallationPlanFormLazyQueryHookResult = ReturnType<typeof useSaveInstallationPlanFormLazyQuery>;
export type SaveInstallationPlanFormSuspenseQueryHookResult = ReturnType<typeof useSaveInstallationPlanFormSuspenseQuery>;
export type SaveInstallationPlanFormQueryResult = Apollo.QueryResult<SaveInstallationPlanFormQuery, SaveInstallationPlanFormQueryVariables>;
export const SaveInstallationsDocument = gql`
    mutation SaveInstallations($input: SaveInstallations_Input!) {
  saveInstallations(input: $input) {
    id
    name
    roomName
    area {
      id
      name
      displayName
    }
    installationType {
      id
      name
      displayName
    }
    subArea {
      id
      name
      displayName
    }
    status {
      id
      name
      displayName
    }
    milestone {
      id
    }
    decisions {
      id
      title
      dueDate
      approved
    }
    product {
      id
      name
    }
    estimatedStartDate
    startDate
    associatedDeliveries {
      id
      name
    }
    isComplete @client
  }
}
    `;
export type SaveInstallationsMutationFn = Apollo.MutationFunction<SaveInstallationsMutation, SaveInstallationsMutationVariables>;

/**
 * __useSaveInstallationsMutation__
 *
 * To run a mutation, you first call `useSaveInstallationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveInstallationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveInstallationsMutation, { data, loading, error }] = useSaveInstallationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveInstallationsMutation(baseOptions?: Apollo.MutationHookOptions<SaveInstallationsMutation, SaveInstallationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveInstallationsMutation, SaveInstallationsMutationVariables>(SaveInstallationsDocument, options);
      }
export type SaveInstallationsMutationHookResult = ReturnType<typeof useSaveInstallationsMutation>;
export type SaveInstallationsMutationResult = Apollo.MutationResult<SaveInstallationsMutation>;
export type SaveInstallationsMutationOptions = Apollo.BaseMutationOptions<SaveInstallationsMutation, SaveInstallationsMutationVariables>;
export const SaveInstallationsFormDocument = gql`
    query SaveInstallationsForm($projectId: ID!) {
  project(id: $projectId) {
    id
    installations @client {
      id
      name
      roomName
    }
  }
}
    `;

/**
 * __useSaveInstallationsFormQuery__
 *
 * To run a query within a React component, call `useSaveInstallationsFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaveInstallationsFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaveInstallationsFormQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useSaveInstallationsFormQuery(baseOptions: Apollo.QueryHookOptions<SaveInstallationsFormQuery, SaveInstallationsFormQueryVariables> & ({ variables: SaveInstallationsFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SaveInstallationsFormQuery, SaveInstallationsFormQueryVariables>(SaveInstallationsFormDocument, options);
      }
export function useSaveInstallationsFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SaveInstallationsFormQuery, SaveInstallationsFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SaveInstallationsFormQuery, SaveInstallationsFormQueryVariables>(SaveInstallationsFormDocument, options);
        }
export function useSaveInstallationsFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SaveInstallationsFormQuery, SaveInstallationsFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SaveInstallationsFormQuery, SaveInstallationsFormQueryVariables>(SaveInstallationsFormDocument, options);
        }
export type SaveInstallationsFormQueryHookResult = ReturnType<typeof useSaveInstallationsFormQuery>;
export type SaveInstallationsFormLazyQueryHookResult = ReturnType<typeof useSaveInstallationsFormLazyQuery>;
export type SaveInstallationsFormSuspenseQueryHookResult = ReturnType<typeof useSaveInstallationsFormSuspenseQuery>;
export type SaveInstallationsFormQueryResult = Apollo.QueryResult<SaveInstallationsFormQuery, SaveInstallationsFormQueryVariables>;
export const MembershipFormDocument = gql`
    query MembershipForm($options: Query_Membership_OptionsInput!) {
  membership(options: $options) {
    id
    roles {
      id
      name
      displayName
    }
  }
}
    `;

/**
 * __useMembershipFormQuery__
 *
 * To run a query within a React component, call `useMembershipFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipFormQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useMembershipFormQuery(baseOptions: Apollo.QueryHookOptions<MembershipFormQuery, MembershipFormQueryVariables> & ({ variables: MembershipFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipFormQuery, MembershipFormQueryVariables>(MembershipFormDocument, options);
      }
export function useMembershipFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipFormQuery, MembershipFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipFormQuery, MembershipFormQueryVariables>(MembershipFormDocument, options);
        }
export function useMembershipFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipFormQuery, MembershipFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembershipFormQuery, MembershipFormQueryVariables>(MembershipFormDocument, options);
        }
export type MembershipFormQueryHookResult = ReturnType<typeof useMembershipFormQuery>;
export type MembershipFormLazyQueryHookResult = ReturnType<typeof useMembershipFormLazyQuery>;
export type MembershipFormSuspenseQueryHookResult = ReturnType<typeof useMembershipFormSuspenseQuery>;
export type MembershipFormQueryResult = Apollo.QueryResult<MembershipFormQuery, MembershipFormQueryVariables>;
export const SaveMembershipDocument = gql`
    mutation SaveMembership($input: SaveMembershipInput!) {
  saveMembership(input: $input) {
    id
  }
}
    `;
export type SaveMembershipMutationFn = Apollo.MutationFunction<SaveMembershipMutation, SaveMembershipMutationVariables>;

/**
 * __useSaveMembershipMutation__
 *
 * To run a mutation, you first call `useSaveMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMembershipMutation, { data, loading, error }] = useSaveMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveMembershipMutation(baseOptions?: Apollo.MutationHookOptions<SaveMembershipMutation, SaveMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMembershipMutation, SaveMembershipMutationVariables>(SaveMembershipDocument, options);
      }
export type SaveMembershipMutationHookResult = ReturnType<typeof useSaveMembershipMutation>;
export type SaveMembershipMutationResult = Apollo.MutationResult<SaveMembershipMutation>;
export type SaveMembershipMutationOptions = Apollo.BaseMutationOptions<SaveMembershipMutation, SaveMembershipMutationVariables>;
export const MetaDeliveryFormDocument = gql`
    query MetaDeliveryForm($id: ID!) {
  metaDelivery(id: $id) {
    id
    notesForClient
    createdAt
    included
    receivedDate
    deliveryName
  }
}
    `;

/**
 * __useMetaDeliveryFormQuery__
 *
 * To run a query within a React component, call `useMetaDeliveryFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetaDeliveryFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetaDeliveryFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMetaDeliveryFormQuery(baseOptions: Apollo.QueryHookOptions<MetaDeliveryFormQuery, MetaDeliveryFormQueryVariables> & ({ variables: MetaDeliveryFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetaDeliveryFormQuery, MetaDeliveryFormQueryVariables>(MetaDeliveryFormDocument, options);
      }
export function useMetaDeliveryFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetaDeliveryFormQuery, MetaDeliveryFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetaDeliveryFormQuery, MetaDeliveryFormQueryVariables>(MetaDeliveryFormDocument, options);
        }
export function useMetaDeliveryFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MetaDeliveryFormQuery, MetaDeliveryFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MetaDeliveryFormQuery, MetaDeliveryFormQueryVariables>(MetaDeliveryFormDocument, options);
        }
export type MetaDeliveryFormQueryHookResult = ReturnType<typeof useMetaDeliveryFormQuery>;
export type MetaDeliveryFormLazyQueryHookResult = ReturnType<typeof useMetaDeliveryFormLazyQuery>;
export type MetaDeliveryFormSuspenseQueryHookResult = ReturnType<typeof useMetaDeliveryFormSuspenseQuery>;
export type MetaDeliveryFormQueryResult = Apollo.QueryResult<MetaDeliveryFormQuery, MetaDeliveryFormQueryVariables>;
export const SaveMetaDeliveryDocument = gql`
    mutation SaveMetaDelivery($input: SaveMetaDelivery_Input!) {
  saveMetaDelivery(input: $input) {
    id
    notesForClient
    createdAt
    included
    receivedDate
    deliveryName
  }
}
    `;
export type SaveMetaDeliveryMutationFn = Apollo.MutationFunction<SaveMetaDeliveryMutation, SaveMetaDeliveryMutationVariables>;

/**
 * __useSaveMetaDeliveryMutation__
 *
 * To run a mutation, you first call `useSaveMetaDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMetaDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMetaDeliveryMutation, { data, loading, error }] = useSaveMetaDeliveryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveMetaDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<SaveMetaDeliveryMutation, SaveMetaDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMetaDeliveryMutation, SaveMetaDeliveryMutationVariables>(SaveMetaDeliveryDocument, options);
      }
export type SaveMetaDeliveryMutationHookResult = ReturnType<typeof useSaveMetaDeliveryMutation>;
export type SaveMetaDeliveryMutationResult = Apollo.MutationResult<SaveMetaDeliveryMutation>;
export type SaveMetaDeliveryMutationOptions = Apollo.BaseMutationOptions<SaveMetaDeliveryMutation, SaveMetaDeliveryMutationVariables>;
export const MetaInspectionFormDocument = gql`
    query MetaInspectionForm($id: ID!) {
  metaInspection(id: $id) {
    id
    inspectionName
    notesForClient
    included
    inspector {
      id
      firstName
      lastName
      fullName @client
    }
  }
}
    `;

/**
 * __useMetaInspectionFormQuery__
 *
 * To run a query within a React component, call `useMetaInspectionFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetaInspectionFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetaInspectionFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMetaInspectionFormQuery(baseOptions: Apollo.QueryHookOptions<MetaInspectionFormQuery, MetaInspectionFormQueryVariables> & ({ variables: MetaInspectionFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetaInspectionFormQuery, MetaInspectionFormQueryVariables>(MetaInspectionFormDocument, options);
      }
export function useMetaInspectionFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetaInspectionFormQuery, MetaInspectionFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetaInspectionFormQuery, MetaInspectionFormQueryVariables>(MetaInspectionFormDocument, options);
        }
export function useMetaInspectionFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MetaInspectionFormQuery, MetaInspectionFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MetaInspectionFormQuery, MetaInspectionFormQueryVariables>(MetaInspectionFormDocument, options);
        }
export type MetaInspectionFormQueryHookResult = ReturnType<typeof useMetaInspectionFormQuery>;
export type MetaInspectionFormLazyQueryHookResult = ReturnType<typeof useMetaInspectionFormLazyQuery>;
export type MetaInspectionFormSuspenseQueryHookResult = ReturnType<typeof useMetaInspectionFormSuspenseQuery>;
export type MetaInspectionFormQueryResult = Apollo.QueryResult<MetaInspectionFormQuery, MetaInspectionFormQueryVariables>;
export const SaveMetaInspectionDocument = gql`
    mutation SaveMetaInspection($input: SaveMetaInspection_Input!) {
  saveMetaInspection(input: $input) {
    id
    notesForClient
    included
  }
}
    `;
export type SaveMetaInspectionMutationFn = Apollo.MutationFunction<SaveMetaInspectionMutation, SaveMetaInspectionMutationVariables>;

/**
 * __useSaveMetaInspectionMutation__
 *
 * To run a mutation, you first call `useSaveMetaInspectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMetaInspectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMetaInspectionMutation, { data, loading, error }] = useSaveMetaInspectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveMetaInspectionMutation(baseOptions?: Apollo.MutationHookOptions<SaveMetaInspectionMutation, SaveMetaInspectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMetaInspectionMutation, SaveMetaInspectionMutationVariables>(SaveMetaInspectionDocument, options);
      }
export type SaveMetaInspectionMutationHookResult = ReturnType<typeof useSaveMetaInspectionMutation>;
export type SaveMetaInspectionMutationResult = Apollo.MutationResult<SaveMetaInspectionMutation>;
export type SaveMetaInspectionMutationOptions = Apollo.BaseMutationOptions<SaveMetaInspectionMutation, SaveMetaInspectionMutationVariables>;
export const MetaMilestoneFormDocument = gql`
    query MetaMilestoneForm($id: ID!) {
  metaMilestone(id: $id) {
    id
    createdAt
    milestoneUpdated
    milestoneName
    notesForClient
    milestoneStatus {
      id
      name
      displayName
    }
    included
  }
}
    `;

/**
 * __useMetaMilestoneFormQuery__
 *
 * To run a query within a React component, call `useMetaMilestoneFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetaMilestoneFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetaMilestoneFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMetaMilestoneFormQuery(baseOptions: Apollo.QueryHookOptions<MetaMilestoneFormQuery, MetaMilestoneFormQueryVariables> & ({ variables: MetaMilestoneFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetaMilestoneFormQuery, MetaMilestoneFormQueryVariables>(MetaMilestoneFormDocument, options);
      }
export function useMetaMilestoneFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetaMilestoneFormQuery, MetaMilestoneFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetaMilestoneFormQuery, MetaMilestoneFormQueryVariables>(MetaMilestoneFormDocument, options);
        }
export function useMetaMilestoneFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MetaMilestoneFormQuery, MetaMilestoneFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MetaMilestoneFormQuery, MetaMilestoneFormQueryVariables>(MetaMilestoneFormDocument, options);
        }
export type MetaMilestoneFormQueryHookResult = ReturnType<typeof useMetaMilestoneFormQuery>;
export type MetaMilestoneFormLazyQueryHookResult = ReturnType<typeof useMetaMilestoneFormLazyQuery>;
export type MetaMilestoneFormSuspenseQueryHookResult = ReturnType<typeof useMetaMilestoneFormSuspenseQuery>;
export type MetaMilestoneFormQueryResult = Apollo.QueryResult<MetaMilestoneFormQuery, MetaMilestoneFormQueryVariables>;
export const SaveMetaMilestoneDocument = gql`
    mutation SaveMetaMilestone($input: SaveMetaMilestone_Input!) {
  saveMetaMilestone(input: $input) {
    id
    createdAt
    milestoneUpdated
    milestoneName
    notesForClient
    milestoneStatus {
      id
      name
      displayName
    }
    included
  }
}
    `;
export type SaveMetaMilestoneMutationFn = Apollo.MutationFunction<SaveMetaMilestoneMutation, SaveMetaMilestoneMutationVariables>;

/**
 * __useSaveMetaMilestoneMutation__
 *
 * To run a mutation, you first call `useSaveMetaMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMetaMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMetaMilestoneMutation, { data, loading, error }] = useSaveMetaMilestoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveMetaMilestoneMutation(baseOptions?: Apollo.MutationHookOptions<SaveMetaMilestoneMutation, SaveMetaMilestoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMetaMilestoneMutation, SaveMetaMilestoneMutationVariables>(SaveMetaMilestoneDocument, options);
      }
export type SaveMetaMilestoneMutationHookResult = ReturnType<typeof useSaveMetaMilestoneMutation>;
export type SaveMetaMilestoneMutationResult = Apollo.MutationResult<SaveMetaMilestoneMutation>;
export type SaveMetaMilestoneMutationOptions = Apollo.BaseMutationOptions<SaveMetaMilestoneMutation, SaveMetaMilestoneMutationVariables>;
export const SaveMetaPhotoDocument = gql`
    mutation SaveMetaPhoto($input: SaveMetaPhoto_Input!) {
  saveMetaPhoto(input: $input) {
    id
    included
    attachment {
      ...apiFileFields
    }
  }
}
    ${ApiFileFieldsFragmentDoc}`;
export type SaveMetaPhotoMutationFn = Apollo.MutationFunction<SaveMetaPhotoMutation, SaveMetaPhotoMutationVariables>;

/**
 * __useSaveMetaPhotoMutation__
 *
 * To run a mutation, you first call `useSaveMetaPhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMetaPhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMetaPhotoMutation, { data, loading, error }] = useSaveMetaPhotoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveMetaPhotoMutation(baseOptions?: Apollo.MutationHookOptions<SaveMetaPhotoMutation, SaveMetaPhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMetaPhotoMutation, SaveMetaPhotoMutationVariables>(SaveMetaPhotoDocument, options);
      }
export type SaveMetaPhotoMutationHookResult = ReturnType<typeof useSaveMetaPhotoMutation>;
export type SaveMetaPhotoMutationResult = Apollo.MutationResult<SaveMetaPhotoMutation>;
export type SaveMetaPhotoMutationOptions = Apollo.BaseMutationOptions<SaveMetaPhotoMutation, SaveMetaPhotoMutationVariables>;
export const GetMilestoneDocument = gql`
    query GetMilestone($id: ID!) {
  milestone(id: $id) {
    id
    title
    description
    estimatedStartDate
    startDate
    endDate
    durationInDays
    auditLog {
      id
      createdTimestamp
      createdBy {
        id
        firstName
        lastName
        fullName @client
      }
      title
      description
    }
    status {
      id
      name
      displayName
    }
  }
}
    `;

/**
 * __useGetMilestoneQuery__
 *
 * To run a query within a React component, call `useGetMilestoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMilestoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMilestoneQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMilestoneQuery(baseOptions: Apollo.QueryHookOptions<GetMilestoneQuery, GetMilestoneQueryVariables> & ({ variables: GetMilestoneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMilestoneQuery, GetMilestoneQueryVariables>(GetMilestoneDocument, options);
      }
export function useGetMilestoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMilestoneQuery, GetMilestoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMilestoneQuery, GetMilestoneQueryVariables>(GetMilestoneDocument, options);
        }
export function useGetMilestoneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMilestoneQuery, GetMilestoneQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMilestoneQuery, GetMilestoneQueryVariables>(GetMilestoneDocument, options);
        }
export type GetMilestoneQueryHookResult = ReturnType<typeof useGetMilestoneQuery>;
export type GetMilestoneLazyQueryHookResult = ReturnType<typeof useGetMilestoneLazyQuery>;
export type GetMilestoneSuspenseQueryHookResult = ReturnType<typeof useGetMilestoneSuspenseQuery>;
export type GetMilestoneQueryResult = Apollo.QueryResult<GetMilestoneQuery, GetMilestoneQueryVariables>;
export const SaveMilestoneDocument = gql`
    mutation SaveMilestone($input: SaveMilestone_Input!) {
  saveMilestone(input: $input) {
    id
    title
    description
    estimatedStartDate
    durationInDays
    startDate
    endDate
    auditLog {
      id
      createdTimestamp
      createdBy {
        id
        firstName
        lastName
        fullName @client
      }
      title
      description
    }
    status {
      id
      name
      displayName
    }
  }
}
    `;
export type SaveMilestoneMutationFn = Apollo.MutationFunction<SaveMilestoneMutation, SaveMilestoneMutationVariables>;

/**
 * __useSaveMilestoneMutation__
 *
 * To run a mutation, you first call `useSaveMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMilestoneMutation, { data, loading, error }] = useSaveMilestoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveMilestoneMutation(baseOptions?: Apollo.MutationHookOptions<SaveMilestoneMutation, SaveMilestoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMilestoneMutation, SaveMilestoneMutationVariables>(SaveMilestoneDocument, options);
      }
export type SaveMilestoneMutationHookResult = ReturnType<typeof useSaveMilestoneMutation>;
export type SaveMilestoneMutationResult = Apollo.MutationResult<SaveMilestoneMutation>;
export type SaveMilestoneMutationOptions = Apollo.BaseMutationOptions<SaveMilestoneMutation, SaveMilestoneMutationVariables>;
export const OnSiteWorkEventFormDocument = gql`
    query OnSiteWorkEventForm($id: ID!) {
  onSiteWorkEvent(id: $id) {
    id
    dateWorked
    hoursWorked
    trade {
      id
      name
      displayName
    }
    onSiteSubContractors
    description
    person {
      id
      firstName
      lastName
      fullName @client
    }
    project {
      id
    }
  }
}
    `;

/**
 * __useOnSiteWorkEventFormQuery__
 *
 * To run a query within a React component, call `useOnSiteWorkEventFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnSiteWorkEventFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnSiteWorkEventFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOnSiteWorkEventFormQuery(baseOptions: Apollo.QueryHookOptions<OnSiteWorkEventFormQuery, OnSiteWorkEventFormQueryVariables> & ({ variables: OnSiteWorkEventFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnSiteWorkEventFormQuery, OnSiteWorkEventFormQueryVariables>(OnSiteWorkEventFormDocument, options);
      }
export function useOnSiteWorkEventFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnSiteWorkEventFormQuery, OnSiteWorkEventFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnSiteWorkEventFormQuery, OnSiteWorkEventFormQueryVariables>(OnSiteWorkEventFormDocument, options);
        }
export function useOnSiteWorkEventFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OnSiteWorkEventFormQuery, OnSiteWorkEventFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OnSiteWorkEventFormQuery, OnSiteWorkEventFormQueryVariables>(OnSiteWorkEventFormDocument, options);
        }
export type OnSiteWorkEventFormQueryHookResult = ReturnType<typeof useOnSiteWorkEventFormQuery>;
export type OnSiteWorkEventFormLazyQueryHookResult = ReturnType<typeof useOnSiteWorkEventFormLazyQuery>;
export type OnSiteWorkEventFormSuspenseQueryHookResult = ReturnType<typeof useOnSiteWorkEventFormSuspenseQuery>;
export type OnSiteWorkEventFormQueryResult = Apollo.QueryResult<OnSiteWorkEventFormQuery, OnSiteWorkEventFormQueryVariables>;
export const SaveOnSiteWorkEventDocument = gql`
    mutation SaveOnSiteWorkEvent($input: SaveOnSiteWorkEvent_Input!) {
  saveOnSiteWorkEvent(input: $input) {
    id
    dateWorked
    hoursWorked
    trade {
      id
      name
      displayName
    }
    onSiteSubContractors
    description
    person {
      id
      firstName
      lastName
      fullName @client
    }
  }
}
    `;
export type SaveOnSiteWorkEventMutationFn = Apollo.MutationFunction<SaveOnSiteWorkEventMutation, SaveOnSiteWorkEventMutationVariables>;

/**
 * __useSaveOnSiteWorkEventMutation__
 *
 * To run a mutation, you first call `useSaveOnSiteWorkEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOnSiteWorkEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOnSiteWorkEventMutation, { data, loading, error }] = useSaveOnSiteWorkEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveOnSiteWorkEventMutation(baseOptions?: Apollo.MutationHookOptions<SaveOnSiteWorkEventMutation, SaveOnSiteWorkEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveOnSiteWorkEventMutation, SaveOnSiteWorkEventMutationVariables>(SaveOnSiteWorkEventDocument, options);
      }
export type SaveOnSiteWorkEventMutationHookResult = ReturnType<typeof useSaveOnSiteWorkEventMutation>;
export type SaveOnSiteWorkEventMutationResult = Apollo.MutationResult<SaveOnSiteWorkEventMutation>;
export type SaveOnSiteWorkEventMutationOptions = Apollo.BaseMutationOptions<SaveOnSiteWorkEventMutation, SaveOnSiteWorkEventMutationVariables>;
export const SavePersonDocument = gql`
    mutation SavePerson($input: SavePerson_Input!) {
  savePerson(input: $input) {
    id
    firstName
    lastName
    createdTimestamp
    phoneNumber
    preferredEmail
    profilePicture {
      id
      urlExpiry
      url
    }
    fullName @client
  }
}
    `;
export type SavePersonMutationFn = Apollo.MutationFunction<SavePersonMutation, SavePersonMutationVariables>;

/**
 * __useSavePersonMutation__
 *
 * To run a mutation, you first call `useSavePersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePersonMutation, { data, loading, error }] = useSavePersonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePersonMutation(baseOptions?: Apollo.MutationHookOptions<SavePersonMutation, SavePersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePersonMutation, SavePersonMutationVariables>(SavePersonDocument, options);
      }
export type SavePersonMutationHookResult = ReturnType<typeof useSavePersonMutation>;
export type SavePersonMutationResult = Apollo.MutationResult<SavePersonMutation>;
export type SavePersonMutationOptions = Apollo.BaseMutationOptions<SavePersonMutation, SavePersonMutationVariables>;
export const SavePersonFormDocument = gql`
    query SavePersonForm {
  loggedInUser {
    id
    person {
      id
      firstName
      lastName
      createdTimestamp
      phoneNumber
      preferredEmail
      profilePicture {
        id
        urlExpiry
        url
      }
      fullName @client
    }
  }
}
    `;

/**
 * __useSavePersonFormQuery__
 *
 * To run a query within a React component, call `useSavePersonFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavePersonFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavePersonFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useSavePersonFormQuery(baseOptions?: Apollo.QueryHookOptions<SavePersonFormQuery, SavePersonFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SavePersonFormQuery, SavePersonFormQueryVariables>(SavePersonFormDocument, options);
      }
export function useSavePersonFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SavePersonFormQuery, SavePersonFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SavePersonFormQuery, SavePersonFormQueryVariables>(SavePersonFormDocument, options);
        }
export function useSavePersonFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SavePersonFormQuery, SavePersonFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SavePersonFormQuery, SavePersonFormQueryVariables>(SavePersonFormDocument, options);
        }
export type SavePersonFormQueryHookResult = ReturnType<typeof useSavePersonFormQuery>;
export type SavePersonFormLazyQueryHookResult = ReturnType<typeof useSavePersonFormLazyQuery>;
export type SavePersonFormSuspenseQueryHookResult = ReturnType<typeof useSavePersonFormSuspenseQuery>;
export type SavePersonFormQueryResult = Apollo.QueryResult<SavePersonFormQuery, SavePersonFormQueryVariables>;
export const GetPlanDocument = gql`
    query GetPlan($id: ID!) {
  plan(id: $id) {
    id
    createdDate
    updatedDate
    name
    planSet {
      id
      name
      displayName
    }
    versions {
      ...planVersionFields
    }
  }
}
    ${PlanVersionFieldsFragmentDoc}`;

/**
 * __useGetPlanQuery__
 *
 * To run a query within a React component, call `useGetPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPlanQuery(baseOptions: Apollo.QueryHookOptions<GetPlanQuery, GetPlanQueryVariables> & ({ variables: GetPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlanQuery, GetPlanQueryVariables>(GetPlanDocument, options);
      }
export function useGetPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlanQuery, GetPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlanQuery, GetPlanQueryVariables>(GetPlanDocument, options);
        }
export function useGetPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlanQuery, GetPlanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlanQuery, GetPlanQueryVariables>(GetPlanDocument, options);
        }
export type GetPlanQueryHookResult = ReturnType<typeof useGetPlanQuery>;
export type GetPlanLazyQueryHookResult = ReturnType<typeof useGetPlanLazyQuery>;
export type GetPlanSuspenseQueryHookResult = ReturnType<typeof useGetPlanSuspenseQuery>;
export type GetPlanQueryResult = Apollo.QueryResult<GetPlanQuery, GetPlanQueryVariables>;
export const SavePlanDocument = gql`
    mutation SavePlan($input: SavePlan_Input!) {
  savePlan(input: $input) {
    id
    createdDate
    updatedDate
    name
    planSet {
      id
      name
      displayName
    }
    versions {
      ...planVersionFields
    }
  }
}
    ${PlanVersionFieldsFragmentDoc}`;
export type SavePlanMutationFn = Apollo.MutationFunction<SavePlanMutation, SavePlanMutationVariables>;

/**
 * __useSavePlanMutation__
 *
 * To run a mutation, you first call `useSavePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePlanMutation, { data, loading, error }] = useSavePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePlanMutation(baseOptions?: Apollo.MutationHookOptions<SavePlanMutation, SavePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePlanMutation, SavePlanMutationVariables>(SavePlanDocument, options);
      }
export type SavePlanMutationHookResult = ReturnType<typeof useSavePlanMutation>;
export type SavePlanMutationResult = Apollo.MutationResult<SavePlanMutation>;
export type SavePlanMutationOptions = Apollo.BaseMutationOptions<SavePlanMutation, SavePlanMutationVariables>;
export const PlanSetFormDocument = gql`
    query PlanSetForm($id: ID!) {
  planSet(id: $id) {
    id
    name
    displayName
  }
}
    `;

/**
 * __usePlanSetFormQuery__
 *
 * To run a query within a React component, call `usePlanSetFormQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanSetFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanSetFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlanSetFormQuery(baseOptions: Apollo.QueryHookOptions<PlanSetFormQuery, PlanSetFormQueryVariables> & ({ variables: PlanSetFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanSetFormQuery, PlanSetFormQueryVariables>(PlanSetFormDocument, options);
      }
export function usePlanSetFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanSetFormQuery, PlanSetFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanSetFormQuery, PlanSetFormQueryVariables>(PlanSetFormDocument, options);
        }
export function usePlanSetFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlanSetFormQuery, PlanSetFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlanSetFormQuery, PlanSetFormQueryVariables>(PlanSetFormDocument, options);
        }
export type PlanSetFormQueryHookResult = ReturnType<typeof usePlanSetFormQuery>;
export type PlanSetFormLazyQueryHookResult = ReturnType<typeof usePlanSetFormLazyQuery>;
export type PlanSetFormSuspenseQueryHookResult = ReturnType<typeof usePlanSetFormSuspenseQuery>;
export type PlanSetFormQueryResult = Apollo.QueryResult<PlanSetFormQuery, PlanSetFormQueryVariables>;
export const SavePlanSetFormDocument = gql`
    mutation SavePlanSetForm($input: SavePlanSet_Input!) {
  savePlanSet(input: $input) {
    id
    name
    displayName
  }
}
    `;
export type SavePlanSetFormMutationFn = Apollo.MutationFunction<SavePlanSetFormMutation, SavePlanSetFormMutationVariables>;

/**
 * __useSavePlanSetFormMutation__
 *
 * To run a mutation, you first call `useSavePlanSetFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePlanSetFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePlanSetFormMutation, { data, loading, error }] = useSavePlanSetFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePlanSetFormMutation(baseOptions?: Apollo.MutationHookOptions<SavePlanSetFormMutation, SavePlanSetFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePlanSetFormMutation, SavePlanSetFormMutationVariables>(SavePlanSetFormDocument, options);
      }
export type SavePlanSetFormMutationHookResult = ReturnType<typeof useSavePlanSetFormMutation>;
export type SavePlanSetFormMutationResult = Apollo.MutationResult<SavePlanSetFormMutation>;
export type SavePlanSetFormMutationOptions = Apollo.BaseMutationOptions<SavePlanSetFormMutation, SavePlanSetFormMutationVariables>;
export const SaveProductDocument = gql`
    mutation SaveProduct($input: SaveProduct_Input!) {
  saveProduct(input: $input) {
    id
    finish
    hardware
    manufacturer
    model
    name
    notes
    supplier
    __typename
  }
}
    `;
export type SaveProductMutationFn = Apollo.MutationFunction<SaveProductMutation, SaveProductMutationVariables>;

/**
 * __useSaveProductMutation__
 *
 * To run a mutation, you first call `useSaveProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProductMutation, { data, loading, error }] = useSaveProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveProductMutation(baseOptions?: Apollo.MutationHookOptions<SaveProductMutation, SaveProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveProductMutation, SaveProductMutationVariables>(SaveProductDocument, options);
      }
export type SaveProductMutationHookResult = ReturnType<typeof useSaveProductMutation>;
export type SaveProductMutationResult = Apollo.MutationResult<SaveProductMutation>;
export type SaveProductMutationOptions = Apollo.BaseMutationOptions<SaveProductMutation, SaveProductMutationVariables>;
export const GetStandardInstallationsForAreaDocument = gql`
    query GetStandardInstallationsForArea {
  standardTemplateMilestones {
    id
    estimatedStartDate @client
    durationInDays
    durationFromProjectStartDateInMills
    title
    rank
    description
  }
}
    `;

/**
 * __useGetStandardInstallationsForAreaQuery__
 *
 * To run a query within a React component, call `useGetStandardInstallationsForAreaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStandardInstallationsForAreaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStandardInstallationsForAreaQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStandardInstallationsForAreaQuery(baseOptions?: Apollo.QueryHookOptions<GetStandardInstallationsForAreaQuery, GetStandardInstallationsForAreaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStandardInstallationsForAreaQuery, GetStandardInstallationsForAreaQueryVariables>(GetStandardInstallationsForAreaDocument, options);
      }
export function useGetStandardInstallationsForAreaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStandardInstallationsForAreaQuery, GetStandardInstallationsForAreaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStandardInstallationsForAreaQuery, GetStandardInstallationsForAreaQueryVariables>(GetStandardInstallationsForAreaDocument, options);
        }
export function useGetStandardInstallationsForAreaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStandardInstallationsForAreaQuery, GetStandardInstallationsForAreaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStandardInstallationsForAreaQuery, GetStandardInstallationsForAreaQueryVariables>(GetStandardInstallationsForAreaDocument, options);
        }
export type GetStandardInstallationsForAreaQueryHookResult = ReturnType<typeof useGetStandardInstallationsForAreaQuery>;
export type GetStandardInstallationsForAreaLazyQueryHookResult = ReturnType<typeof useGetStandardInstallationsForAreaLazyQuery>;
export type GetStandardInstallationsForAreaSuspenseQueryHookResult = ReturnType<typeof useGetStandardInstallationsForAreaSuspenseQuery>;
export type GetStandardInstallationsForAreaQueryResult = Apollo.QueryResult<GetStandardInstallationsForAreaQuery, GetStandardInstallationsForAreaQueryVariables>;
export const SaveProjectDocument = gql`
    mutation SaveProject($input: SaveProject_Input!) {
  saveProject(input: $input) {
    id
    estimatedStartDate
    startDate
    name
    estimatedCompletionDate
    locationAddress {
      ...addressFields
    }
    memberships {
      id
    }
    tasks {
      id
    }
    installations {
      id
      startDate
      name
      roomName
    }
    milestones {
      id
      title
      estimatedStartDate
      startDate
    }
  }
}
    ${AddressFieldsFragmentDoc}`;
export type SaveProjectMutationFn = Apollo.MutationFunction<SaveProjectMutation, SaveProjectMutationVariables>;

/**
 * __useSaveProjectMutation__
 *
 * To run a mutation, you first call `useSaveProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProjectMutation, { data, loading, error }] = useSaveProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveProjectMutation(baseOptions?: Apollo.MutationHookOptions<SaveProjectMutation, SaveProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveProjectMutation, SaveProjectMutationVariables>(SaveProjectDocument, options);
      }
export type SaveProjectMutationHookResult = ReturnType<typeof useSaveProjectMutation>;
export type SaveProjectMutationResult = Apollo.MutationResult<SaveProjectMutation>;
export type SaveProjectMutationOptions = Apollo.BaseMutationOptions<SaveProjectMutation, SaveProjectMutationVariables>;
export const SaveProjectFormDocument = gql`
    query SaveProjectForm($projectId: ID!) {
  usStates {
    id
    name
    displayName
    abbreviation
  }
  project(id: $projectId) {
    id
    name
    startDate
    estimatedStartDate
    installations {
      id
      roomName
      area {
        id
        name
        displayName
      }
      subArea {
        id
        name
        displayName
      }
    }
    rooms @client {
      name
    }
    locationAddress {
      ...addressFields
    }
  }
}
    ${AddressFieldsFragmentDoc}`;

/**
 * __useSaveProjectFormQuery__
 *
 * To run a query within a React component, call `useSaveProjectFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaveProjectFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaveProjectFormQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useSaveProjectFormQuery(baseOptions: Apollo.QueryHookOptions<SaveProjectFormQuery, SaveProjectFormQueryVariables> & ({ variables: SaveProjectFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SaveProjectFormQuery, SaveProjectFormQueryVariables>(SaveProjectFormDocument, options);
      }
export function useSaveProjectFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SaveProjectFormQuery, SaveProjectFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SaveProjectFormQuery, SaveProjectFormQueryVariables>(SaveProjectFormDocument, options);
        }
export function useSaveProjectFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SaveProjectFormQuery, SaveProjectFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SaveProjectFormQuery, SaveProjectFormQueryVariables>(SaveProjectFormDocument, options);
        }
export type SaveProjectFormQueryHookResult = ReturnType<typeof useSaveProjectFormQuery>;
export type SaveProjectFormLazyQueryHookResult = ReturnType<typeof useSaveProjectFormLazyQuery>;
export type SaveProjectFormSuspenseQueryHookResult = ReturnType<typeof useSaveProjectFormSuspenseQuery>;
export type SaveProjectFormQueryResult = Apollo.QueryResult<SaveProjectFormQuery, SaveProjectFormQueryVariables>;
export const SaveStandardAreaInstallationDocument = gql`
    mutation SaveStandardAreaInstallation($input: SaveStandardAreaInstallation_Input!) {
  saveStandardAreaInstallation(input: $input) {
    id
    area {
      id
      name
      displayName
    }
    subArea {
      id
      name
      displayName
    }
    milestone {
      id
      title
    }
    type {
      id
      name
      displayName
    }
    displayName
  }
}
    `;
export type SaveStandardAreaInstallationMutationFn = Apollo.MutationFunction<SaveStandardAreaInstallationMutation, SaveStandardAreaInstallationMutationVariables>;

/**
 * __useSaveStandardAreaInstallationMutation__
 *
 * To run a mutation, you first call `useSaveStandardAreaInstallationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveStandardAreaInstallationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveStandardAreaInstallationMutation, { data, loading, error }] = useSaveStandardAreaInstallationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveStandardAreaInstallationMutation(baseOptions?: Apollo.MutationHookOptions<SaveStandardAreaInstallationMutation, SaveStandardAreaInstallationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveStandardAreaInstallationMutation, SaveStandardAreaInstallationMutationVariables>(SaveStandardAreaInstallationDocument, options);
      }
export type SaveStandardAreaInstallationMutationHookResult = ReturnType<typeof useSaveStandardAreaInstallationMutation>;
export type SaveStandardAreaInstallationMutationResult = Apollo.MutationResult<SaveStandardAreaInstallationMutation>;
export type SaveStandardAreaInstallationMutationOptions = Apollo.BaseMutationOptions<SaveStandardAreaInstallationMutation, SaveStandardAreaInstallationMutationVariables>;
export const StandardAreaInstallationFormDocument = gql`
    query StandardAreaInstallationForm($id: ID!) {
  standardAreaInstallation(id: $id) {
    id
    area {
      id
      name
      displayName
    }
    subArea {
      id
      name
      displayName
    }
    milestone {
      id
      title
    }
    type {
      id
      name
      displayName
    }
    displayName
  }
}
    `;

/**
 * __useStandardAreaInstallationFormQuery__
 *
 * To run a query within a React component, call `useStandardAreaInstallationFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useStandardAreaInstallationFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStandardAreaInstallationFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStandardAreaInstallationFormQuery(baseOptions: Apollo.QueryHookOptions<StandardAreaInstallationFormQuery, StandardAreaInstallationFormQueryVariables> & ({ variables: StandardAreaInstallationFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StandardAreaInstallationFormQuery, StandardAreaInstallationFormQueryVariables>(StandardAreaInstallationFormDocument, options);
      }
export function useStandardAreaInstallationFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StandardAreaInstallationFormQuery, StandardAreaInstallationFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StandardAreaInstallationFormQuery, StandardAreaInstallationFormQueryVariables>(StandardAreaInstallationFormDocument, options);
        }
export function useStandardAreaInstallationFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StandardAreaInstallationFormQuery, StandardAreaInstallationFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StandardAreaInstallationFormQuery, StandardAreaInstallationFormQueryVariables>(StandardAreaInstallationFormDocument, options);
        }
export type StandardAreaInstallationFormQueryHookResult = ReturnType<typeof useStandardAreaInstallationFormQuery>;
export type StandardAreaInstallationFormLazyQueryHookResult = ReturnType<typeof useStandardAreaInstallationFormLazyQuery>;
export type StandardAreaInstallationFormSuspenseQueryHookResult = ReturnType<typeof useStandardAreaInstallationFormSuspenseQuery>;
export type StandardAreaInstallationFormQueryResult = Apollo.QueryResult<StandardAreaInstallationFormQuery, StandardAreaInstallationFormQueryVariables>;
export const SaveTaskFormDocument = gql`
    query SaveTaskForm($id: ID!) {
  task(id: $id) {
    id
    taskNumber
    dueDate
    name
    assignee {
      id
    }
    description
    area {
      id
    }
    category {
      id
    }
    attachments {
      ...apiFileFields
    }
    status {
      id
      name
      displayName
    }
  }
}
    ${ApiFileFieldsFragmentDoc}`;

/**
 * __useSaveTaskFormQuery__
 *
 * To run a query within a React component, call `useSaveTaskFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaveTaskFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaveTaskFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSaveTaskFormQuery(baseOptions: Apollo.QueryHookOptions<SaveTaskFormQuery, SaveTaskFormQueryVariables> & ({ variables: SaveTaskFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SaveTaskFormQuery, SaveTaskFormQueryVariables>(SaveTaskFormDocument, options);
      }
export function useSaveTaskFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SaveTaskFormQuery, SaveTaskFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SaveTaskFormQuery, SaveTaskFormQueryVariables>(SaveTaskFormDocument, options);
        }
export function useSaveTaskFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SaveTaskFormQuery, SaveTaskFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SaveTaskFormQuery, SaveTaskFormQueryVariables>(SaveTaskFormDocument, options);
        }
export type SaveTaskFormQueryHookResult = ReturnType<typeof useSaveTaskFormQuery>;
export type SaveTaskFormLazyQueryHookResult = ReturnType<typeof useSaveTaskFormLazyQuery>;
export type SaveTaskFormSuspenseQueryHookResult = ReturnType<typeof useSaveTaskFormSuspenseQuery>;
export type SaveTaskFormQueryResult = Apollo.QueryResult<SaveTaskFormQuery, SaveTaskFormQueryVariables>;
export const SaveTaskDocument = gql`
    mutation SaveTask($input: SaveTask_Input!) {
  saveTask(input: $input) {
    ...taskTableQueryFields
    id
    taskNumber
    dueDate
    name
    createdAt
    assignee {
      id
      firstName
      lastName
    }
    area {
      id
      name
      displayName
    }
    category {
      id
      name
      displayName
    }
    attachments {
      ...apiFileFields
    }
    description
  }
}
    ${TaskTableQueryFieldsFragmentDoc}
${ApiFileFieldsFragmentDoc}`;
export type SaveTaskMutationFn = Apollo.MutationFunction<SaveTaskMutation, SaveTaskMutationVariables>;

/**
 * __useSaveTaskMutation__
 *
 * To run a mutation, you first call `useSaveTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTaskMutation, { data, loading, error }] = useSaveTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTaskMutation(baseOptions?: Apollo.MutationHookOptions<SaveTaskMutation, SaveTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTaskMutation, SaveTaskMutationVariables>(SaveTaskDocument, options);
      }
export type SaveTaskMutationHookResult = ReturnType<typeof useSaveTaskMutation>;
export type SaveTaskMutationResult = Apollo.MutationResult<SaveTaskMutation>;
export type SaveTaskMutationOptions = Apollo.BaseMutationOptions<SaveTaskMutation, SaveTaskMutationVariables>;
export const SaveWeatherDocument = gql`
    mutation SaveWeather($input: SaveWeather_Input!) {
  saveWeather(input: $input) {
    id
    temperatureMax
    temperatureMin
    precipitationAmount
    precipitationType {
      id
      name
      displayName
    }
    condition {
      id
      name
      displayName
    }
  }
}
    `;
export type SaveWeatherMutationFn = Apollo.MutationFunction<SaveWeatherMutation, SaveWeatherMutationVariables>;

/**
 * __useSaveWeatherMutation__
 *
 * To run a mutation, you first call `useSaveWeatherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveWeatherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveWeatherMutation, { data, loading, error }] = useSaveWeatherMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveWeatherMutation(baseOptions?: Apollo.MutationHookOptions<SaveWeatherMutation, SaveWeatherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveWeatherMutation, SaveWeatherMutationVariables>(SaveWeatherDocument, options);
      }
export type SaveWeatherMutationHookResult = ReturnType<typeof useSaveWeatherMutation>;
export type SaveWeatherMutationResult = Apollo.MutationResult<SaveWeatherMutation>;
export type SaveWeatherMutationOptions = Apollo.BaseMutationOptions<SaveWeatherMutation, SaveWeatherMutationVariables>;
export const WeatherFormDocument = gql`
    query WeatherForm($id: ID!) {
  weather(id: $id) {
    id
    temperatureMax
    temperatureMin
    precipitationAmount
    condition {
      id
      name
      displayName
    }
    precipitationType {
      id
      name
      displayName
    }
  }
}
    `;

/**
 * __useWeatherFormQuery__
 *
 * To run a query within a React component, call `useWeatherFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeatherFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeatherFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWeatherFormQuery(baseOptions: Apollo.QueryHookOptions<WeatherFormQuery, WeatherFormQueryVariables> & ({ variables: WeatherFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WeatherFormQuery, WeatherFormQueryVariables>(WeatherFormDocument, options);
      }
export function useWeatherFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WeatherFormQuery, WeatherFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WeatherFormQuery, WeatherFormQueryVariables>(WeatherFormDocument, options);
        }
export function useWeatherFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WeatherFormQuery, WeatherFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WeatherFormQuery, WeatherFormQueryVariables>(WeatherFormDocument, options);
        }
export type WeatherFormQueryHookResult = ReturnType<typeof useWeatherFormQuery>;
export type WeatherFormLazyQueryHookResult = ReturnType<typeof useWeatherFormLazyQuery>;
export type WeatherFormSuspenseQueryHookResult = ReturnType<typeof useWeatherFormSuspenseQuery>;
export type WeatherFormQueryResult = Apollo.QueryResult<WeatherFormQuery, WeatherFormQueryVariables>;
export const GetProjectTemplateMilestonesDocument = gql`
    query GetProjectTemplateMilestones($id: ID!) {
  project(id: $id) {
    id
    milestones {
      id
      startDate
      durationInDays
      title
      installations {
        id
        name
        roomName
      }
    }
  }
}
    `;

/**
 * __useGetProjectTemplateMilestonesQuery__
 *
 * To run a query within a React component, call `useGetProjectTemplateMilestonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectTemplateMilestonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectTemplateMilestonesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectTemplateMilestonesQuery(baseOptions: Apollo.QueryHookOptions<GetProjectTemplateMilestonesQuery, GetProjectTemplateMilestonesQueryVariables> & ({ variables: GetProjectTemplateMilestonesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectTemplateMilestonesQuery, GetProjectTemplateMilestonesQueryVariables>(GetProjectTemplateMilestonesDocument, options);
      }
export function useGetProjectTemplateMilestonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectTemplateMilestonesQuery, GetProjectTemplateMilestonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectTemplateMilestonesQuery, GetProjectTemplateMilestonesQueryVariables>(GetProjectTemplateMilestonesDocument, options);
        }
export function useGetProjectTemplateMilestonesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectTemplateMilestonesQuery, GetProjectTemplateMilestonesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectTemplateMilestonesQuery, GetProjectTemplateMilestonesQueryVariables>(GetProjectTemplateMilestonesDocument, options);
        }
export type GetProjectTemplateMilestonesQueryHookResult = ReturnType<typeof useGetProjectTemplateMilestonesQuery>;
export type GetProjectTemplateMilestonesLazyQueryHookResult = ReturnType<typeof useGetProjectTemplateMilestonesLazyQuery>;
export type GetProjectTemplateMilestonesSuspenseQueryHookResult = ReturnType<typeof useGetProjectTemplateMilestonesSuspenseQuery>;
export type GetProjectTemplateMilestonesQueryResult = Apollo.QueryResult<GetProjectTemplateMilestonesQuery, GetProjectTemplateMilestonesQueryVariables>;
export const ModalCommentSectionDocument = gql`
    query ModalCommentSection($id: ID!) {
  task(id: $id) {
    id
    comments {
      id
      person {
        id
        firstName
        lastName
        fullName @client
      }
      createdAt
      description
    }
  }
}
    `;

/**
 * __useModalCommentSectionQuery__
 *
 * To run a query within a React component, call `useModalCommentSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useModalCommentSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModalCommentSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useModalCommentSectionQuery(baseOptions: Apollo.QueryHookOptions<ModalCommentSectionQuery, ModalCommentSectionQueryVariables> & ({ variables: ModalCommentSectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModalCommentSectionQuery, ModalCommentSectionQueryVariables>(ModalCommentSectionDocument, options);
      }
export function useModalCommentSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModalCommentSectionQuery, ModalCommentSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModalCommentSectionQuery, ModalCommentSectionQueryVariables>(ModalCommentSectionDocument, options);
        }
export function useModalCommentSectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ModalCommentSectionQuery, ModalCommentSectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ModalCommentSectionQuery, ModalCommentSectionQueryVariables>(ModalCommentSectionDocument, options);
        }
export type ModalCommentSectionQueryHookResult = ReturnType<typeof useModalCommentSectionQuery>;
export type ModalCommentSectionLazyQueryHookResult = ReturnType<typeof useModalCommentSectionLazyQuery>;
export type ModalCommentSectionSuspenseQueryHookResult = ReturnType<typeof useModalCommentSectionSuspenseQuery>;
export type ModalCommentSectionQueryResult = Apollo.QueryResult<ModalCommentSectionQuery, ModalCommentSectionQueryVariables>;
export const SaveTaskModalDetailSectionDocument = gql`
    query SaveTaskModalDetailSection($id: ID!) {
  task(id: $id) {
    id
    taskNumber
    dueDate
    name
    assignee {
      id
      firstName
      lastName
      fullName @client
    }
    comments {
      id
      person {
        id
        firstName
        lastName
        fullName @client
      }
      description
    }
    area {
      id
      name
      displayName
    }
    category {
      id
      name
      displayName
    }
    description
    status {
      id
      name
      displayName
    }
    attachments {
      ...apiFileFields
    }
  }
}
    ${ApiFileFieldsFragmentDoc}`;

/**
 * __useSaveTaskModalDetailSectionQuery__
 *
 * To run a query within a React component, call `useSaveTaskModalDetailSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaveTaskModalDetailSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaveTaskModalDetailSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSaveTaskModalDetailSectionQuery(baseOptions: Apollo.QueryHookOptions<SaveTaskModalDetailSectionQuery, SaveTaskModalDetailSectionQueryVariables> & ({ variables: SaveTaskModalDetailSectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SaveTaskModalDetailSectionQuery, SaveTaskModalDetailSectionQueryVariables>(SaveTaskModalDetailSectionDocument, options);
      }
export function useSaveTaskModalDetailSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SaveTaskModalDetailSectionQuery, SaveTaskModalDetailSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SaveTaskModalDetailSectionQuery, SaveTaskModalDetailSectionQueryVariables>(SaveTaskModalDetailSectionDocument, options);
        }
export function useSaveTaskModalDetailSectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SaveTaskModalDetailSectionQuery, SaveTaskModalDetailSectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SaveTaskModalDetailSectionQuery, SaveTaskModalDetailSectionQueryVariables>(SaveTaskModalDetailSectionDocument, options);
        }
export type SaveTaskModalDetailSectionQueryHookResult = ReturnType<typeof useSaveTaskModalDetailSectionQuery>;
export type SaveTaskModalDetailSectionLazyQueryHookResult = ReturnType<typeof useSaveTaskModalDetailSectionLazyQuery>;
export type SaveTaskModalDetailSectionSuspenseQueryHookResult = ReturnType<typeof useSaveTaskModalDetailSectionSuspenseQuery>;
export type SaveTaskModalDetailSectionQueryResult = Apollo.QueryResult<SaveTaskModalDetailSectionQuery, SaveTaskModalDetailSectionQueryVariables>;
export const DeleteFolderModalDocument = gql`
    mutation DeleteFolderModal($id: ID!) {
  deleteFolder(id: $id) {
    id
  }
}
    `;
export type DeleteFolderModalMutationFn = Apollo.MutationFunction<DeleteFolderModalMutation, DeleteFolderModalMutationVariables>;

/**
 * __useDeleteFolderModalMutation__
 *
 * To run a mutation, you first call `useDeleteFolderModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFolderModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFolderModalMutation, { data, loading, error }] = useDeleteFolderModalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFolderModalMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFolderModalMutation, DeleteFolderModalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFolderModalMutation, DeleteFolderModalMutationVariables>(DeleteFolderModalDocument, options);
      }
export type DeleteFolderModalMutationHookResult = ReturnType<typeof useDeleteFolderModalMutation>;
export type DeleteFolderModalMutationResult = Apollo.MutationResult<DeleteFolderModalMutation>;
export type DeleteFolderModalMutationOptions = Apollo.BaseMutationOptions<DeleteFolderModalMutation, DeleteFolderModalMutationVariables>;
export const DuplicateFolderDocument = gql`
    mutation DuplicateFolder($id: ID!) {
  duplicateFolder(id: $id) {
    id
    createdTimestamp
    documents {
      ...saveDocumentFields
    }
    parent {
      id
    }
    updatedTimestamp
    name
    fileCount
  }
}
    ${SaveDocumentFieldsFragmentDoc}`;
export type DuplicateFolderMutationFn = Apollo.MutationFunction<DuplicateFolderMutation, DuplicateFolderMutationVariables>;

/**
 * __useDuplicateFolderMutation__
 *
 * To run a mutation, you first call `useDuplicateFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateFolderMutation, { data, loading, error }] = useDuplicateFolderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDuplicateFolderMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateFolderMutation, DuplicateFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateFolderMutation, DuplicateFolderMutationVariables>(DuplicateFolderDocument, options);
      }
export type DuplicateFolderMutationHookResult = ReturnType<typeof useDuplicateFolderMutation>;
export type DuplicateFolderMutationResult = Apollo.MutationResult<DuplicateFolderMutation>;
export type DuplicateFolderMutationOptions = Apollo.BaseMutationOptions<DuplicateFolderMutation, DuplicateFolderMutationVariables>;
export const RemoveDeliveryModalDocument = gql`
    mutation RemoveDeliveryModal($id: ID!) {
  removeDelivery(id: $id)
}
    `;
export type RemoveDeliveryModalMutationFn = Apollo.MutationFunction<RemoveDeliveryModalMutation, RemoveDeliveryModalMutationVariables>;

/**
 * __useRemoveDeliveryModalMutation__
 *
 * To run a mutation, you first call `useRemoveDeliveryModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDeliveryModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDeliveryModalMutation, { data, loading, error }] = useRemoveDeliveryModalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveDeliveryModalMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDeliveryModalMutation, RemoveDeliveryModalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDeliveryModalMutation, RemoveDeliveryModalMutationVariables>(RemoveDeliveryModalDocument, options);
      }
export type RemoveDeliveryModalMutationHookResult = ReturnType<typeof useRemoveDeliveryModalMutation>;
export type RemoveDeliveryModalMutationResult = Apollo.MutationResult<RemoveDeliveryModalMutation>;
export type RemoveDeliveryModalMutationOptions = Apollo.BaseMutationOptions<RemoveDeliveryModalMutation, RemoveDeliveryModalMutationVariables>;
export const RemoveDocumentDocument = gql`
    mutation RemoveDocument($id: ID!) {
  deleteDocument(id: $id)
}
    `;
export type RemoveDocumentMutationFn = Apollo.MutationFunction<RemoveDocumentMutation, RemoveDocumentMutationVariables>;

/**
 * __useRemoveDocumentMutation__
 *
 * To run a mutation, you first call `useRemoveDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDocumentMutation, { data, loading, error }] = useRemoveDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveDocumentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDocumentMutation, RemoveDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDocumentMutation, RemoveDocumentMutationVariables>(RemoveDocumentDocument, options);
      }
export type RemoveDocumentMutationHookResult = ReturnType<typeof useRemoveDocumentMutation>;
export type RemoveDocumentMutationResult = Apollo.MutationResult<RemoveDocumentMutation>;
export type RemoveDocumentMutationOptions = Apollo.BaseMutationOptions<RemoveDocumentMutation, RemoveDocumentMutationVariables>;
export const RemoveInstallationTypeDocument = gql`
    mutation RemoveInstallationType($input: RemoveInstallationType_Input!) {
  removeInstallationType(input: $input) {
    id
    name
    displayName
  }
}
    `;
export type RemoveInstallationTypeMutationFn = Apollo.MutationFunction<RemoveInstallationTypeMutation, RemoveInstallationTypeMutationVariables>;

/**
 * __useRemoveInstallationTypeMutation__
 *
 * To run a mutation, you first call `useRemoveInstallationTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveInstallationTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeInstallationTypeMutation, { data, loading, error }] = useRemoveInstallationTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveInstallationTypeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveInstallationTypeMutation, RemoveInstallationTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveInstallationTypeMutation, RemoveInstallationTypeMutationVariables>(RemoveInstallationTypeDocument, options);
      }
export type RemoveInstallationTypeMutationHookResult = ReturnType<typeof useRemoveInstallationTypeMutation>;
export type RemoveInstallationTypeMutationResult = Apollo.MutationResult<RemoveInstallationTypeMutation>;
export type RemoveInstallationTypeMutationOptions = Apollo.BaseMutationOptions<RemoveInstallationTypeMutation, RemoveInstallationTypeMutationVariables>;
export const RemoveOnSiteWorkEventDocument = gql`
    mutation RemoveOnSiteWorkEvent($id: ID!) {
  removeOnSiteWorkEvent(id: $id)
}
    `;
export type RemoveOnSiteWorkEventMutationFn = Apollo.MutationFunction<RemoveOnSiteWorkEventMutation, RemoveOnSiteWorkEventMutationVariables>;

/**
 * __useRemoveOnSiteWorkEventMutation__
 *
 * To run a mutation, you first call `useRemoveOnSiteWorkEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOnSiteWorkEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOnSiteWorkEventMutation, { data, loading, error }] = useRemoveOnSiteWorkEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveOnSiteWorkEventMutation(baseOptions?: Apollo.MutationHookOptions<RemoveOnSiteWorkEventMutation, RemoveOnSiteWorkEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveOnSiteWorkEventMutation, RemoveOnSiteWorkEventMutationVariables>(RemoveOnSiteWorkEventDocument, options);
      }
export type RemoveOnSiteWorkEventMutationHookResult = ReturnType<typeof useRemoveOnSiteWorkEventMutation>;
export type RemoveOnSiteWorkEventMutationResult = Apollo.MutationResult<RemoveOnSiteWorkEventMutation>;
export type RemoveOnSiteWorkEventMutationOptions = Apollo.BaseMutationOptions<RemoveOnSiteWorkEventMutation, RemoveOnSiteWorkEventMutationVariables>;
export const ResetProjectMilestonesModalDocument = gql`
    mutation ResetProjectMilestonesModal($id: ID!) {
  resetProjectMilestones(id: $id) {
    id
    title
    description
    estimatedStartDate
    durationInDays
    startDate
    endDate
    status {
      id
      name
      displayName
    }
  }
}
    `;
export type ResetProjectMilestonesModalMutationFn = Apollo.MutationFunction<ResetProjectMilestonesModalMutation, ResetProjectMilestonesModalMutationVariables>;

/**
 * __useResetProjectMilestonesModalMutation__
 *
 * To run a mutation, you first call `useResetProjectMilestonesModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetProjectMilestonesModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetProjectMilestonesModalMutation, { data, loading, error }] = useResetProjectMilestonesModalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResetProjectMilestonesModalMutation(baseOptions?: Apollo.MutationHookOptions<ResetProjectMilestonesModalMutation, ResetProjectMilestonesModalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetProjectMilestonesModalMutation, ResetProjectMilestonesModalMutationVariables>(ResetProjectMilestonesModalDocument, options);
      }
export type ResetProjectMilestonesModalMutationHookResult = ReturnType<typeof useResetProjectMilestonesModalMutation>;
export type ResetProjectMilestonesModalMutationResult = Apollo.MutationResult<ResetProjectMilestonesModalMutation>;
export type ResetProjectMilestonesModalMutationOptions = Apollo.BaseMutationOptions<ResetProjectMilestonesModalMutation, ResetProjectMilestonesModalMutationVariables>;
export const UpdateSuperAdminDocument = gql`
    mutation UpdateSuperAdmin($input: SavePerson_Input!) {
  savePerson(input: $input) {
    id
    firstName
    lastName
    createdTimestamp
    phoneNumber
    isActive
    preferredEmail
    profilePicture {
      ...apiFileFields
    }
    fullName @client
  }
}
    ${ApiFileFieldsFragmentDoc}`;
export type UpdateSuperAdminMutationFn = Apollo.MutationFunction<UpdateSuperAdminMutation, UpdateSuperAdminMutationVariables>;

/**
 * __useUpdateSuperAdminMutation__
 *
 * To run a mutation, you first call `useUpdateSuperAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSuperAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSuperAdminMutation, { data, loading, error }] = useUpdateSuperAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSuperAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSuperAdminMutation, UpdateSuperAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSuperAdminMutation, UpdateSuperAdminMutationVariables>(UpdateSuperAdminDocument, options);
      }
export type UpdateSuperAdminMutationHookResult = ReturnType<typeof useUpdateSuperAdminMutation>;
export type UpdateSuperAdminMutationResult = Apollo.MutationResult<UpdateSuperAdminMutation>;
export type UpdateSuperAdminMutationOptions = Apollo.BaseMutationOptions<UpdateSuperAdminMutation, UpdateSuperAdminMutationVariables>;
export const SaveReportAttachmentDocument = gql`
    mutation SaveReportAttachment($input: SaveReportAttachment_Input!) {
  saveClientReportAttachment(input: $input) {
    id
    createdAt
    attachment {
      ...apiFileFields
    }
  }
}
    ${ApiFileFieldsFragmentDoc}`;
export type SaveReportAttachmentMutationFn = Apollo.MutationFunction<SaveReportAttachmentMutation, SaveReportAttachmentMutationVariables>;

/**
 * __useSaveReportAttachmentMutation__
 *
 * To run a mutation, you first call `useSaveReportAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveReportAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveReportAttachmentMutation, { data, loading, error }] = useSaveReportAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveReportAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<SaveReportAttachmentMutation, SaveReportAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveReportAttachmentMutation, SaveReportAttachmentMutationVariables>(SaveReportAttachmentDocument, options);
      }
export type SaveReportAttachmentMutationHookResult = ReturnType<typeof useSaveReportAttachmentMutation>;
export type SaveReportAttachmentMutationResult = Apollo.MutationResult<SaveReportAttachmentMutation>;
export type SaveReportAttachmentMutationOptions = Apollo.BaseMutationOptions<SaveReportAttachmentMutation, SaveReportAttachmentMutationVariables>;
export const SaveClientReportMetaDeliveryDocument = gql`
    mutation SaveClientReportMetaDelivery($input: SaveMetaDelivery_Input!) {
  saveMetaDelivery(input: $input) {
    id
    createdAt
    receivedDate
    deliveryName
    notesForClient
    included
  }
}
    `;
export type SaveClientReportMetaDeliveryMutationFn = Apollo.MutationFunction<SaveClientReportMetaDeliveryMutation, SaveClientReportMetaDeliveryMutationVariables>;

/**
 * __useSaveClientReportMetaDeliveryMutation__
 *
 * To run a mutation, you first call `useSaveClientReportMetaDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveClientReportMetaDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveClientReportMetaDeliveryMutation, { data, loading, error }] = useSaveClientReportMetaDeliveryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveClientReportMetaDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<SaveClientReportMetaDeliveryMutation, SaveClientReportMetaDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveClientReportMetaDeliveryMutation, SaveClientReportMetaDeliveryMutationVariables>(SaveClientReportMetaDeliveryDocument, options);
      }
export type SaveClientReportMetaDeliveryMutationHookResult = ReturnType<typeof useSaveClientReportMetaDeliveryMutation>;
export type SaveClientReportMetaDeliveryMutationResult = Apollo.MutationResult<SaveClientReportMetaDeliveryMutation>;
export type SaveClientReportMetaDeliveryMutationOptions = Apollo.BaseMutationOptions<SaveClientReportMetaDeliveryMutation, SaveClientReportMetaDeliveryMutationVariables>;
export const SaveClientReportMetaInspectionDocument = gql`
    mutation SaveClientReportMetaInspection($input: SaveMetaInspection_Input!) {
  saveMetaInspection(input: $input) {
    id
    createdAt
    inspectionUpdated
    inspectionName
    inspectionResult {
      id
      name
      displayName
    }
    inspector {
      id
      firstName
      lastName
      fullName @client
    }
    notesForClient
    included
  }
}
    `;
export type SaveClientReportMetaInspectionMutationFn = Apollo.MutationFunction<SaveClientReportMetaInspectionMutation, SaveClientReportMetaInspectionMutationVariables>;

/**
 * __useSaveClientReportMetaInspectionMutation__
 *
 * To run a mutation, you first call `useSaveClientReportMetaInspectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveClientReportMetaInspectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveClientReportMetaInspectionMutation, { data, loading, error }] = useSaveClientReportMetaInspectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveClientReportMetaInspectionMutation(baseOptions?: Apollo.MutationHookOptions<SaveClientReportMetaInspectionMutation, SaveClientReportMetaInspectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveClientReportMetaInspectionMutation, SaveClientReportMetaInspectionMutationVariables>(SaveClientReportMetaInspectionDocument, options);
      }
export type SaveClientReportMetaInspectionMutationHookResult = ReturnType<typeof useSaveClientReportMetaInspectionMutation>;
export type SaveClientReportMetaInspectionMutationResult = Apollo.MutationResult<SaveClientReportMetaInspectionMutation>;
export type SaveClientReportMetaInspectionMutationOptions = Apollo.BaseMutationOptions<SaveClientReportMetaInspectionMutation, SaveClientReportMetaInspectionMutationVariables>;
export const SaveClientReportMetaMilestoneDocument = gql`
    mutation SaveClientReportMetaMilestone($input: SaveMetaMilestone_Input!) {
  saveMetaMilestone(input: $input) {
    id
    createdAt
    milestoneUpdated
    milestoneName
    notesForClient
    milestoneStatus {
      id
      name
      displayName
    }
    included
  }
}
    `;
export type SaveClientReportMetaMilestoneMutationFn = Apollo.MutationFunction<SaveClientReportMetaMilestoneMutation, SaveClientReportMetaMilestoneMutationVariables>;

/**
 * __useSaveClientReportMetaMilestoneMutation__
 *
 * To run a mutation, you first call `useSaveClientReportMetaMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveClientReportMetaMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveClientReportMetaMilestoneMutation, { data, loading, error }] = useSaveClientReportMetaMilestoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveClientReportMetaMilestoneMutation(baseOptions?: Apollo.MutationHookOptions<SaveClientReportMetaMilestoneMutation, SaveClientReportMetaMilestoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveClientReportMetaMilestoneMutation, SaveClientReportMetaMilestoneMutationVariables>(SaveClientReportMetaMilestoneDocument, options);
      }
export type SaveClientReportMetaMilestoneMutationHookResult = ReturnType<typeof useSaveClientReportMetaMilestoneMutation>;
export type SaveClientReportMetaMilestoneMutationResult = Apollo.MutationResult<SaveClientReportMetaMilestoneMutation>;
export type SaveClientReportMetaMilestoneMutationOptions = Apollo.BaseMutationOptions<SaveClientReportMetaMilestoneMutation, SaveClientReportMetaMilestoneMutationVariables>;
export const SaveClientReportPhotoCardDocument = gql`
    mutation SaveClientReportPhotoCard($input: SaveMetaPhoto_Input!) {
  saveMetaPhoto(input: $input) {
    id
    included
    attachment {
      ...apiFileFields
    }
  }
}
    ${ApiFileFieldsFragmentDoc}`;
export type SaveClientReportPhotoCardMutationFn = Apollo.MutationFunction<SaveClientReportPhotoCardMutation, SaveClientReportPhotoCardMutationVariables>;

/**
 * __useSaveClientReportPhotoCardMutation__
 *
 * To run a mutation, you first call `useSaveClientReportPhotoCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveClientReportPhotoCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveClientReportPhotoCardMutation, { data, loading, error }] = useSaveClientReportPhotoCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveClientReportPhotoCardMutation(baseOptions?: Apollo.MutationHookOptions<SaveClientReportPhotoCardMutation, SaveClientReportPhotoCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveClientReportPhotoCardMutation, SaveClientReportPhotoCardMutationVariables>(SaveClientReportPhotoCardDocument, options);
      }
export type SaveClientReportPhotoCardMutationHookResult = ReturnType<typeof useSaveClientReportPhotoCardMutation>;
export type SaveClientReportPhotoCardMutationResult = Apollo.MutationResult<SaveClientReportPhotoCardMutation>;
export type SaveClientReportPhotoCardMutationOptions = Apollo.BaseMutationOptions<SaveClientReportPhotoCardMutation, SaveClientReportPhotoCardMutationVariables>;
export const GetInstallationDecisionsDocument = gql`
    query GetInstallationDecisions($id: ID!) {
  installation(id: $id) {
    id
    decisions {
      id
      title
      description
      dueDate
      approved
      isOverdue @client
      isComplete @client
      isDueSoon @client
      type {
        id
        name
        displayName
      }
      decidedTimestamp
    }
  }
}
    `;

/**
 * __useGetInstallationDecisionsQuery__
 *
 * To run a query within a React component, call `useGetInstallationDecisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstallationDecisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstallationDecisionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInstallationDecisionsQuery(baseOptions: Apollo.QueryHookOptions<GetInstallationDecisionsQuery, GetInstallationDecisionsQueryVariables> & ({ variables: GetInstallationDecisionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstallationDecisionsQuery, GetInstallationDecisionsQueryVariables>(GetInstallationDecisionsDocument, options);
      }
export function useGetInstallationDecisionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstallationDecisionsQuery, GetInstallationDecisionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstallationDecisionsQuery, GetInstallationDecisionsQueryVariables>(GetInstallationDecisionsDocument, options);
        }
export function useGetInstallationDecisionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInstallationDecisionsQuery, GetInstallationDecisionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInstallationDecisionsQuery, GetInstallationDecisionsQueryVariables>(GetInstallationDecisionsDocument, options);
        }
export type GetInstallationDecisionsQueryHookResult = ReturnType<typeof useGetInstallationDecisionsQuery>;
export type GetInstallationDecisionsLazyQueryHookResult = ReturnType<typeof useGetInstallationDecisionsLazyQuery>;
export type GetInstallationDecisionsSuspenseQueryHookResult = ReturnType<typeof useGetInstallationDecisionsSuspenseQuery>;
export type GetInstallationDecisionsQueryResult = Apollo.QueryResult<GetInstallationDecisionsQuery, GetInstallationDecisionsQueryVariables>;
export const GetInstallationDeliveriesDocument = gql`
    query GetInstallationDeliveries($id: ID!) {
  installation(id: $id) {
    id
    associatedDeliveries {
      id
      attachments {
        ...apiFileFields
      }
      receivedDate
      name
      description
      quantity
      damageDescription
      issueDescription
      otherDescription
      estimatedDeliveryDate
      createdTimestamp
      __typename
    }
  }
}
    ${ApiFileFieldsFragmentDoc}`;

/**
 * __useGetInstallationDeliveriesQuery__
 *
 * To run a query within a React component, call `useGetInstallationDeliveriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstallationDeliveriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstallationDeliveriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInstallationDeliveriesQuery(baseOptions: Apollo.QueryHookOptions<GetInstallationDeliveriesQuery, GetInstallationDeliveriesQueryVariables> & ({ variables: GetInstallationDeliveriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstallationDeliveriesQuery, GetInstallationDeliveriesQueryVariables>(GetInstallationDeliveriesDocument, options);
      }
export function useGetInstallationDeliveriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstallationDeliveriesQuery, GetInstallationDeliveriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstallationDeliveriesQuery, GetInstallationDeliveriesQueryVariables>(GetInstallationDeliveriesDocument, options);
        }
export function useGetInstallationDeliveriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInstallationDeliveriesQuery, GetInstallationDeliveriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInstallationDeliveriesQuery, GetInstallationDeliveriesQueryVariables>(GetInstallationDeliveriesDocument, options);
        }
export type GetInstallationDeliveriesQueryHookResult = ReturnType<typeof useGetInstallationDeliveriesQuery>;
export type GetInstallationDeliveriesLazyQueryHookResult = ReturnType<typeof useGetInstallationDeliveriesLazyQuery>;
export type GetInstallationDeliveriesSuspenseQueryHookResult = ReturnType<typeof useGetInstallationDeliveriesSuspenseQuery>;
export type GetInstallationDeliveriesQueryResult = Apollo.QueryResult<GetInstallationDeliveriesQuery, GetInstallationDeliveriesQueryVariables>;
export const RemoveDeliveryDocument = gql`
    mutation RemoveDelivery($id: ID!) {
  removeDelivery(id: $id)
}
    `;
export type RemoveDeliveryMutationFn = Apollo.MutationFunction<RemoveDeliveryMutation, RemoveDeliveryMutationVariables>;

/**
 * __useRemoveDeliveryMutation__
 *
 * To run a mutation, you first call `useRemoveDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDeliveryMutation, { data, loading, error }] = useRemoveDeliveryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDeliveryMutation, RemoveDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDeliveryMutation, RemoveDeliveryMutationVariables>(RemoveDeliveryDocument, options);
      }
export type RemoveDeliveryMutationHookResult = ReturnType<typeof useRemoveDeliveryMutation>;
export type RemoveDeliveryMutationResult = Apollo.MutationResult<RemoveDeliveryMutation>;
export type RemoveDeliveryMutationOptions = Apollo.BaseMutationOptions<RemoveDeliveryMutation, RemoveDeliveryMutationVariables>;
export const GetInstallationGeneralDetailDocument = gql`
    query GetInstallationGeneralDetail($id: ID!) {
  installation(id: $id) {
    id
    name
    fullAreaName @client
    installationType {
      id
      name
      displayName
    }
    area {
      id
      name
      displayName
    }
    subArea {
      id
      name
      displayName
    }
    decisions {
      id
    }
    isComplete @client
    isOverDue @client
    isDueSoon @client
  }
}
    `;

/**
 * __useGetInstallationGeneralDetailQuery__
 *
 * To run a query within a React component, call `useGetInstallationGeneralDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstallationGeneralDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstallationGeneralDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInstallationGeneralDetailQuery(baseOptions: Apollo.QueryHookOptions<GetInstallationGeneralDetailQuery, GetInstallationGeneralDetailQueryVariables> & ({ variables: GetInstallationGeneralDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstallationGeneralDetailQuery, GetInstallationGeneralDetailQueryVariables>(GetInstallationGeneralDetailDocument, options);
      }
export function useGetInstallationGeneralDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstallationGeneralDetailQuery, GetInstallationGeneralDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstallationGeneralDetailQuery, GetInstallationGeneralDetailQueryVariables>(GetInstallationGeneralDetailDocument, options);
        }
export function useGetInstallationGeneralDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInstallationGeneralDetailQuery, GetInstallationGeneralDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInstallationGeneralDetailQuery, GetInstallationGeneralDetailQueryVariables>(GetInstallationGeneralDetailDocument, options);
        }
export type GetInstallationGeneralDetailQueryHookResult = ReturnType<typeof useGetInstallationGeneralDetailQuery>;
export type GetInstallationGeneralDetailLazyQueryHookResult = ReturnType<typeof useGetInstallationGeneralDetailLazyQuery>;
export type GetInstallationGeneralDetailSuspenseQueryHookResult = ReturnType<typeof useGetInstallationGeneralDetailSuspenseQuery>;
export type GetInstallationGeneralDetailQueryResult = Apollo.QueryResult<GetInstallationGeneralDetailQuery, GetInstallationGeneralDetailQueryVariables>;
export const GetInstallationPlansDocument = gql`
    query GetInstallationPlans($id: ID!) {
  installation(id: $id) {
    id
    plan {
      id
      createdDate
      updatedDate
      name
      planSet {
        id
        name
        displayName
      }
      versions {
        ...planVersionFields
      }
    }
  }
}
    ${PlanVersionFieldsFragmentDoc}`;

/**
 * __useGetInstallationPlansQuery__
 *
 * To run a query within a React component, call `useGetInstallationPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstallationPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstallationPlansQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInstallationPlansQuery(baseOptions: Apollo.QueryHookOptions<GetInstallationPlansQuery, GetInstallationPlansQueryVariables> & ({ variables: GetInstallationPlansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstallationPlansQuery, GetInstallationPlansQueryVariables>(GetInstallationPlansDocument, options);
      }
export function useGetInstallationPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstallationPlansQuery, GetInstallationPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstallationPlansQuery, GetInstallationPlansQueryVariables>(GetInstallationPlansDocument, options);
        }
export function useGetInstallationPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInstallationPlansQuery, GetInstallationPlansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInstallationPlansQuery, GetInstallationPlansQueryVariables>(GetInstallationPlansDocument, options);
        }
export type GetInstallationPlansQueryHookResult = ReturnType<typeof useGetInstallationPlansQuery>;
export type GetInstallationPlansLazyQueryHookResult = ReturnType<typeof useGetInstallationPlansLazyQuery>;
export type GetInstallationPlansSuspenseQueryHookResult = ReturnType<typeof useGetInstallationPlansSuspenseQuery>;
export type GetInstallationPlansQueryResult = Apollo.QueryResult<GetInstallationPlansQuery, GetInstallationPlansQueryVariables>;
export const GetInstallationProductDetailDocument = gql`
    query GetInstallationProductDetail($id: ID!) {
  installation(id: $id) {
    id
    product {
      id
      name
      supplier
      manufacturer
      model
      hardware
      finish
      notes
      __typename
    }
  }
}
    `;

/**
 * __useGetInstallationProductDetailQuery__
 *
 * To run a query within a React component, call `useGetInstallationProductDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstallationProductDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstallationProductDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInstallationProductDetailQuery(baseOptions: Apollo.QueryHookOptions<GetInstallationProductDetailQuery, GetInstallationProductDetailQueryVariables> & ({ variables: GetInstallationProductDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstallationProductDetailQuery, GetInstallationProductDetailQueryVariables>(GetInstallationProductDetailDocument, options);
      }
export function useGetInstallationProductDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstallationProductDetailQuery, GetInstallationProductDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstallationProductDetailQuery, GetInstallationProductDetailQueryVariables>(GetInstallationProductDetailDocument, options);
        }
export function useGetInstallationProductDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInstallationProductDetailQuery, GetInstallationProductDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInstallationProductDetailQuery, GetInstallationProductDetailQueryVariables>(GetInstallationProductDetailDocument, options);
        }
export type GetInstallationProductDetailQueryHookResult = ReturnType<typeof useGetInstallationProductDetailQuery>;
export type GetInstallationProductDetailLazyQueryHookResult = ReturnType<typeof useGetInstallationProductDetailLazyQuery>;
export type GetInstallationProductDetailSuspenseQueryHookResult = ReturnType<typeof useGetInstallationProductDetailSuspenseQuery>;
export type GetInstallationProductDetailQueryResult = Apollo.QueryResult<GetInstallationProductDetailQuery, GetInstallationProductDetailQueryVariables>;
export const MilestoneDetailCardDocument = gql`
    query MilestoneDetailCard($id: ID!) {
  milestone(id: $id) @client {
    id
    title
    description
    startDate
    endDate
    durationInDays
    auditLog {
      id
      createdTimestamp
      title
      description
      createdBy {
        id
        firstName
        lastName
        fullName @client
      }
    }
    status {
      id
      name
      displayName
    }
  }
}
    `;

/**
 * __useMilestoneDetailCardQuery__
 *
 * To run a query within a React component, call `useMilestoneDetailCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useMilestoneDetailCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMilestoneDetailCardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMilestoneDetailCardQuery(baseOptions: Apollo.QueryHookOptions<MilestoneDetailCardQuery, MilestoneDetailCardQueryVariables> & ({ variables: MilestoneDetailCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MilestoneDetailCardQuery, MilestoneDetailCardQueryVariables>(MilestoneDetailCardDocument, options);
      }
export function useMilestoneDetailCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MilestoneDetailCardQuery, MilestoneDetailCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MilestoneDetailCardQuery, MilestoneDetailCardQueryVariables>(MilestoneDetailCardDocument, options);
        }
export function useMilestoneDetailCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MilestoneDetailCardQuery, MilestoneDetailCardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MilestoneDetailCardQuery, MilestoneDetailCardQueryVariables>(MilestoneDetailCardDocument, options);
        }
export type MilestoneDetailCardQueryHookResult = ReturnType<typeof useMilestoneDetailCardQuery>;
export type MilestoneDetailCardLazyQueryHookResult = ReturnType<typeof useMilestoneDetailCardLazyQuery>;
export type MilestoneDetailCardSuspenseQueryHookResult = ReturnType<typeof useMilestoneDetailCardSuspenseQuery>;
export type MilestoneDetailCardQueryResult = Apollo.QueryResult<MilestoneDetailCardQuery, MilestoneDetailCardQueryVariables>;
export const UserDetailCardDocument = gql`
    query UserDetailCard($id: ID!) {
  person(id: $id) {
    id
    profilePicture {
      ...apiFileFields
    }
    createdTimestamp
    firstName
    lastName
    phoneNumber
    preferredEmail
    fullName @client
  }
}
    ${ApiFileFieldsFragmentDoc}`;

/**
 * __useUserDetailCardQuery__
 *
 * To run a query within a React component, call `useUserDetailCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDetailCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDetailCardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserDetailCardQuery(baseOptions: Apollo.QueryHookOptions<UserDetailCardQuery, UserDetailCardQueryVariables> & ({ variables: UserDetailCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDetailCardQuery, UserDetailCardQueryVariables>(UserDetailCardDocument, options);
      }
export function useUserDetailCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDetailCardQuery, UserDetailCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDetailCardQuery, UserDetailCardQueryVariables>(UserDetailCardDocument, options);
        }
export function useUserDetailCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserDetailCardQuery, UserDetailCardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserDetailCardQuery, UserDetailCardQueryVariables>(UserDetailCardDocument, options);
        }
export type UserDetailCardQueryHookResult = ReturnType<typeof useUserDetailCardQuery>;
export type UserDetailCardLazyQueryHookResult = ReturnType<typeof useUserDetailCardLazyQuery>;
export type UserDetailCardSuspenseQueryHookResult = ReturnType<typeof useUserDetailCardSuspenseQuery>;
export type UserDetailCardQueryResult = Apollo.QueryResult<UserDetailCardQuery, UserDetailCardQueryVariables>;
export const UserProfileDetailCardDocument = gql`
    query UserProfileDetailCard {
  loggedInUser {
    id
    person {
      id
      profilePicture {
        ...apiFileFields
      }
      createdTimestamp
      firstName
      lastName
      phoneNumber
      preferredEmail
      notificationSettings {
        id
        type {
          id
          name
          displayName
        }
        enabled
      }
      fullName @client
    }
  }
}
    ${ApiFileFieldsFragmentDoc}`;

/**
 * __useUserProfileDetailCardQuery__
 *
 * To run a query within a React component, call `useUserProfileDetailCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileDetailCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileDetailCardQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserProfileDetailCardQuery(baseOptions?: Apollo.QueryHookOptions<UserProfileDetailCardQuery, UserProfileDetailCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProfileDetailCardQuery, UserProfileDetailCardQueryVariables>(UserProfileDetailCardDocument, options);
      }
export function useUserProfileDetailCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProfileDetailCardQuery, UserProfileDetailCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProfileDetailCardQuery, UserProfileDetailCardQueryVariables>(UserProfileDetailCardDocument, options);
        }
export function useUserProfileDetailCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserProfileDetailCardQuery, UserProfileDetailCardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserProfileDetailCardQuery, UserProfileDetailCardQueryVariables>(UserProfileDetailCardDocument, options);
        }
export type UserProfileDetailCardQueryHookResult = ReturnType<typeof useUserProfileDetailCardQuery>;
export type UserProfileDetailCardLazyQueryHookResult = ReturnType<typeof useUserProfileDetailCardLazyQuery>;
export type UserProfileDetailCardSuspenseQueryHookResult = ReturnType<typeof useUserProfileDetailCardSuspenseQuery>;
export type UserProfileDetailCardQueryResult = Apollo.QueryResult<UserProfileDetailCardQuery, UserProfileDetailCardQueryVariables>;
export const UserProfileDetailCardSaveNotificationSettingDocument = gql`
    mutation UserProfileDetailCardSaveNotificationSetting($id: ID!) {
  saveNotificationSetting(id: $id) {
    id
    enabled
    type {
      id
      displayName
    }
  }
}
    `;
export type UserProfileDetailCardSaveNotificationSettingMutationFn = Apollo.MutationFunction<UserProfileDetailCardSaveNotificationSettingMutation, UserProfileDetailCardSaveNotificationSettingMutationVariables>;

/**
 * __useUserProfileDetailCardSaveNotificationSettingMutation__
 *
 * To run a mutation, you first call `useUserProfileDetailCardSaveNotificationSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserProfileDetailCardSaveNotificationSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userProfileDetailCardSaveNotificationSettingMutation, { data, loading, error }] = useUserProfileDetailCardSaveNotificationSettingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserProfileDetailCardSaveNotificationSettingMutation(baseOptions?: Apollo.MutationHookOptions<UserProfileDetailCardSaveNotificationSettingMutation, UserProfileDetailCardSaveNotificationSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserProfileDetailCardSaveNotificationSettingMutation, UserProfileDetailCardSaveNotificationSettingMutationVariables>(UserProfileDetailCardSaveNotificationSettingDocument, options);
      }
export type UserProfileDetailCardSaveNotificationSettingMutationHookResult = ReturnType<typeof useUserProfileDetailCardSaveNotificationSettingMutation>;
export type UserProfileDetailCardSaveNotificationSettingMutationResult = Apollo.MutationResult<UserProfileDetailCardSaveNotificationSettingMutation>;
export type UserProfileDetailCardSaveNotificationSettingMutationOptions = Apollo.BaseMutationOptions<UserProfileDetailCardSaveNotificationSettingMutation, UserProfileDetailCardSaveNotificationSettingMutationVariables>;
export const ClientReportTableDocument = gql`
    query ClientReportTable($options: Query_ClientReports_OptionsInput!) {
  clientReports(options: $options) {
    id
    milestones {
      id
    }
    inspections {
      id
    }
    photos {
      id
    }
    links {
      id
    }
    attachments {
      id
    }
    deliveries {
      id
    }
    createdAt
    updatedAt
    startDate
    endDate
    description
    approvedBy {
      id
      firstName
      lastName
      fullName @client
    }
    approvedAt
  }
}
    `;

/**
 * __useClientReportTableQuery__
 *
 * To run a query within a React component, call `useClientReportTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientReportTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientReportTableQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useClientReportTableQuery(baseOptions: Apollo.QueryHookOptions<ClientReportTableQuery, ClientReportTableQueryVariables> & ({ variables: ClientReportTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientReportTableQuery, ClientReportTableQueryVariables>(ClientReportTableDocument, options);
      }
export function useClientReportTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientReportTableQuery, ClientReportTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientReportTableQuery, ClientReportTableQueryVariables>(ClientReportTableDocument, options);
        }
export function useClientReportTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClientReportTableQuery, ClientReportTableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientReportTableQuery, ClientReportTableQueryVariables>(ClientReportTableDocument, options);
        }
export type ClientReportTableQueryHookResult = ReturnType<typeof useClientReportTableQuery>;
export type ClientReportTableLazyQueryHookResult = ReturnType<typeof useClientReportTableLazyQuery>;
export type ClientReportTableSuspenseQueryHookResult = ReturnType<typeof useClientReportTableSuspenseQuery>;
export type ClientReportTableQueryResult = Apollo.QueryResult<ClientReportTableQuery, ClientReportTableQueryVariables>;
export const DailyReportTableDocument = gql`
    query DailyReportTable($options: Query_DailyReports_OptionsInput!) {
  dailyReports(options: $options) {
    id
    description
    reportDate
    approvedAt
    incidents {
      id
    }
    inspections {
      id
    }
    deliveries {
      id
    }
    workLog {
      id
    }
    approvedBy {
      id
      firstName
      lastName
      profilePicture {
        ...apiFileFields
      }
      phoneNumber
      preferredEmail
      fullName @client
    }
    numberOfIncidents @client
    numberOfDeliveries @client
    numberOfInspections @client
    numberOfWorkEvents @client
  }
}
    ${ApiFileFieldsFragmentDoc}`;

/**
 * __useDailyReportTableQuery__
 *
 * To run a query within a React component, call `useDailyReportTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyReportTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyReportTableQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useDailyReportTableQuery(baseOptions: Apollo.QueryHookOptions<DailyReportTableQuery, DailyReportTableQueryVariables> & ({ variables: DailyReportTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DailyReportTableQuery, DailyReportTableQueryVariables>(DailyReportTableDocument, options);
      }
export function useDailyReportTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DailyReportTableQuery, DailyReportTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DailyReportTableQuery, DailyReportTableQueryVariables>(DailyReportTableDocument, options);
        }
export function useDailyReportTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DailyReportTableQuery, DailyReportTableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DailyReportTableQuery, DailyReportTableQueryVariables>(DailyReportTableDocument, options);
        }
export type DailyReportTableQueryHookResult = ReturnType<typeof useDailyReportTableQuery>;
export type DailyReportTableLazyQueryHookResult = ReturnType<typeof useDailyReportTableLazyQuery>;
export type DailyReportTableSuspenseQueryHookResult = ReturnType<typeof useDailyReportTableSuspenseQuery>;
export type DailyReportTableQueryResult = Apollo.QueryResult<DailyReportTableQuery, DailyReportTableQueryVariables>;
export const DocumentTableDocument = gql`
    query DocumentTable($projectId: ID!) {
  project(id: $projectId) {
    id
    documents {
      ...saveDocumentFields
    }
  }
}
    ${SaveDocumentFieldsFragmentDoc}`;

/**
 * __useDocumentTableQuery__
 *
 * To run a query within a React component, call `useDocumentTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentTableQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDocumentTableQuery(baseOptions: Apollo.QueryHookOptions<DocumentTableQuery, DocumentTableQueryVariables> & ({ variables: DocumentTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentTableQuery, DocumentTableQueryVariables>(DocumentTableDocument, options);
      }
export function useDocumentTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentTableQuery, DocumentTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentTableQuery, DocumentTableQueryVariables>(DocumentTableDocument, options);
        }
export function useDocumentTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DocumentTableQuery, DocumentTableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocumentTableQuery, DocumentTableQueryVariables>(DocumentTableDocument, options);
        }
export type DocumentTableQueryHookResult = ReturnType<typeof useDocumentTableQuery>;
export type DocumentTableLazyQueryHookResult = ReturnType<typeof useDocumentTableLazyQuery>;
export type DocumentTableSuspenseQueryHookResult = ReturnType<typeof useDocumentTableSuspenseQuery>;
export type DocumentTableQueryResult = Apollo.QueryResult<DocumentTableQuery, DocumentTableQueryVariables>;
export const ExternalFolderDetailTableDocument = gql`
    query ExternalFolderDetailTable($folderId: ID!) {
  folder(id: $folderId) {
    id
    name
    project {
      id
      name
    }
    documents {
      id
      title
      apiFile {
        ...apiFileFields
      }
    }
  }
}
    ${ApiFileFieldsFragmentDoc}`;

/**
 * __useExternalFolderDetailTableQuery__
 *
 * To run a query within a React component, call `useExternalFolderDetailTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalFolderDetailTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalFolderDetailTableQuery({
 *   variables: {
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useExternalFolderDetailTableQuery(baseOptions: Apollo.QueryHookOptions<ExternalFolderDetailTableQuery, ExternalFolderDetailTableQueryVariables> & ({ variables: ExternalFolderDetailTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExternalFolderDetailTableQuery, ExternalFolderDetailTableQueryVariables>(ExternalFolderDetailTableDocument, options);
      }
export function useExternalFolderDetailTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExternalFolderDetailTableQuery, ExternalFolderDetailTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExternalFolderDetailTableQuery, ExternalFolderDetailTableQueryVariables>(ExternalFolderDetailTableDocument, options);
        }
export function useExternalFolderDetailTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExternalFolderDetailTableQuery, ExternalFolderDetailTableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExternalFolderDetailTableQuery, ExternalFolderDetailTableQueryVariables>(ExternalFolderDetailTableDocument, options);
        }
export type ExternalFolderDetailTableQueryHookResult = ReturnType<typeof useExternalFolderDetailTableQuery>;
export type ExternalFolderDetailTableLazyQueryHookResult = ReturnType<typeof useExternalFolderDetailTableLazyQuery>;
export type ExternalFolderDetailTableSuspenseQueryHookResult = ReturnType<typeof useExternalFolderDetailTableSuspenseQuery>;
export type ExternalFolderDetailTableQueryResult = Apollo.QueryResult<ExternalFolderDetailTableQuery, ExternalFolderDetailTableQueryVariables>;
export const MilestoneTableDocument = gql`
    query MilestoneTable($id: ID!) {
  project(id: $id) {
    id
    milestones {
      id
      title
      description
      startDate
      durationInDays
      endDate
      installations {
        id
        name
        roomName
      }
      status {
        id
        name
        displayName
      }
    }
  }
}
    `;

/**
 * __useMilestoneTableQuery__
 *
 * To run a query within a React component, call `useMilestoneTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useMilestoneTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMilestoneTableQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMilestoneTableQuery(baseOptions: Apollo.QueryHookOptions<MilestoneTableQuery, MilestoneTableQueryVariables> & ({ variables: MilestoneTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MilestoneTableQuery, MilestoneTableQueryVariables>(MilestoneTableDocument, options);
      }
export function useMilestoneTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MilestoneTableQuery, MilestoneTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MilestoneTableQuery, MilestoneTableQueryVariables>(MilestoneTableDocument, options);
        }
export function useMilestoneTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MilestoneTableQuery, MilestoneTableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MilestoneTableQuery, MilestoneTableQueryVariables>(MilestoneTableDocument, options);
        }
export type MilestoneTableQueryHookResult = ReturnType<typeof useMilestoneTableQuery>;
export type MilestoneTableLazyQueryHookResult = ReturnType<typeof useMilestoneTableLazyQuery>;
export type MilestoneTableSuspenseQueryHookResult = ReturnType<typeof useMilestoneTableSuspenseQuery>;
export type MilestoneTableQueryResult = Apollo.QueryResult<MilestoneTableQuery, MilestoneTableQueryVariables>;
export const PersonTableDocument = gql`
    query PersonTable($options: Query_Persons_OptionsInput!) {
  persons(options: $options) {
    id
    profilePicture {
      ...apiFileFields
    }
    firstName
    lastName
    createdTimestamp
    phoneNumber
    preferredEmail
    isActive
    memberships {
      id
    }
    fullName @client
  }
}
    ${ApiFileFieldsFragmentDoc}`;

/**
 * __usePersonTableQuery__
 *
 * To run a query within a React component, call `usePersonTableQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonTableQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function usePersonTableQuery(baseOptions: Apollo.QueryHookOptions<PersonTableQuery, PersonTableQueryVariables> & ({ variables: PersonTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonTableQuery, PersonTableQueryVariables>(PersonTableDocument, options);
      }
export function usePersonTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonTableQuery, PersonTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonTableQuery, PersonTableQueryVariables>(PersonTableDocument, options);
        }
export function usePersonTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PersonTableQuery, PersonTableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PersonTableQuery, PersonTableQueryVariables>(PersonTableDocument, options);
        }
export type PersonTableQueryHookResult = ReturnType<typeof usePersonTableQuery>;
export type PersonTableLazyQueryHookResult = ReturnType<typeof usePersonTableLazyQuery>;
export type PersonTableSuspenseQueryHookResult = ReturnType<typeof usePersonTableSuspenseQuery>;
export type PersonTableQueryResult = Apollo.QueryResult<PersonTableQuery, PersonTableQueryVariables>;
export const PlanSetTableDocument = gql`
    query PlanSetTable($options: Query_PlanSets_OptionsInput!) {
  planSets(options: $options) {
    id
    name
    displayName
    createdAt
    updatedAt
    planCount
  }
}
    `;

/**
 * __usePlanSetTableQuery__
 *
 * To run a query within a React component, call `usePlanSetTableQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanSetTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanSetTableQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function usePlanSetTableQuery(baseOptions: Apollo.QueryHookOptions<PlanSetTableQuery, PlanSetTableQueryVariables> & ({ variables: PlanSetTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanSetTableQuery, PlanSetTableQueryVariables>(PlanSetTableDocument, options);
      }
export function usePlanSetTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanSetTableQuery, PlanSetTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanSetTableQuery, PlanSetTableQueryVariables>(PlanSetTableDocument, options);
        }
export function usePlanSetTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlanSetTableQuery, PlanSetTableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlanSetTableQuery, PlanSetTableQueryVariables>(PlanSetTableDocument, options);
        }
export type PlanSetTableQueryHookResult = ReturnType<typeof usePlanSetTableQuery>;
export type PlanSetTableLazyQueryHookResult = ReturnType<typeof usePlanSetTableLazyQuery>;
export type PlanSetTableSuspenseQueryHookResult = ReturnType<typeof usePlanSetTableSuspenseQuery>;
export type PlanSetTableQueryResult = Apollo.QueryResult<PlanSetTableQuery, PlanSetTableQueryVariables>;
export const PlanTableDocument = gql`
    query PlanTable($options: Query_Plans_OptionsInput!) {
  plans(options: $options) {
    id
    createdDate
    name
    planSet {
      id
      name
      displayName
    }
    versions {
      ...planVersionFields
    }
    updatedDate
  }
}
    ${PlanVersionFieldsFragmentDoc}`;

/**
 * __usePlanTableQuery__
 *
 * To run a query within a React component, call `usePlanTableQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanTableQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function usePlanTableQuery(baseOptions: Apollo.QueryHookOptions<PlanTableQuery, PlanTableQueryVariables> & ({ variables: PlanTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanTableQuery, PlanTableQueryVariables>(PlanTableDocument, options);
      }
export function usePlanTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanTableQuery, PlanTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanTableQuery, PlanTableQueryVariables>(PlanTableDocument, options);
        }
export function usePlanTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlanTableQuery, PlanTableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlanTableQuery, PlanTableQueryVariables>(PlanTableDocument, options);
        }
export type PlanTableQueryHookResult = ReturnType<typeof usePlanTableQuery>;
export type PlanTableLazyQueryHookResult = ReturnType<typeof usePlanTableLazyQuery>;
export type PlanTableSuspenseQueryHookResult = ReturnType<typeof usePlanTableSuspenseQuery>;
export type PlanTableQueryResult = Apollo.QueryResult<PlanTableQuery, PlanTableQueryVariables>;
export const GetProjectInstallationsDocument = gql`
    query GetProjectInstallations($projectId: ID!) {
  project(id: $projectId) {
    id
    rooms @client {
      name
    }
    installations {
      id
      name
      roomName
      area {
        id
        name
        displayName
      }
      installationType {
        id
        name
        displayName
      }
      subArea {
        id
        name
        displayName
      }
      status {
        id
        name
        displayName
      }
      milestone {
        id
      }
      decisions {
        id
        title
        dueDate
        approved
      }
      estimatedStartDate
      startDate
      isComplete @client
    }
  }
}
    `;

/**
 * __useGetProjectInstallationsQuery__
 *
 * To run a query within a React component, call `useGetProjectInstallationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectInstallationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectInstallationsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectInstallationsQuery(baseOptions: Apollo.QueryHookOptions<GetProjectInstallationsQuery, GetProjectInstallationsQueryVariables> & ({ variables: GetProjectInstallationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectInstallationsQuery, GetProjectInstallationsQueryVariables>(GetProjectInstallationsDocument, options);
      }
export function useGetProjectInstallationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectInstallationsQuery, GetProjectInstallationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectInstallationsQuery, GetProjectInstallationsQueryVariables>(GetProjectInstallationsDocument, options);
        }
export function useGetProjectInstallationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectInstallationsQuery, GetProjectInstallationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectInstallationsQuery, GetProjectInstallationsQueryVariables>(GetProjectInstallationsDocument, options);
        }
export type GetProjectInstallationsQueryHookResult = ReturnType<typeof useGetProjectInstallationsQuery>;
export type GetProjectInstallationsLazyQueryHookResult = ReturnType<typeof useGetProjectInstallationsLazyQuery>;
export type GetProjectInstallationsSuspenseQueryHookResult = ReturnType<typeof useGetProjectInstallationsSuspenseQuery>;
export type GetProjectInstallationsQueryResult = Apollo.QueryResult<GetProjectInstallationsQuery, GetProjectInstallationsQueryVariables>;
export const GetAllProjectsDocument = gql`
    query GetAllProjects {
  projects {
    id
    name
    startDate
    estimatedStartDate
    estimatedCompletionDate
    locationAddress {
      ...addressFields
    }
  }
}
    ${AddressFieldsFragmentDoc}`;

/**
 * __useGetAllProjectsQuery__
 *
 * To run a query within a React component, call `useGetAllProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllProjectsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProjectsQuery, GetAllProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProjectsQuery, GetAllProjectsQueryVariables>(GetAllProjectsDocument, options);
      }
export function useGetAllProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProjectsQuery, GetAllProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProjectsQuery, GetAllProjectsQueryVariables>(GetAllProjectsDocument, options);
        }
export function useGetAllProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllProjectsQuery, GetAllProjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllProjectsQuery, GetAllProjectsQueryVariables>(GetAllProjectsDocument, options);
        }
export type GetAllProjectsQueryHookResult = ReturnType<typeof useGetAllProjectsQuery>;
export type GetAllProjectsLazyQueryHookResult = ReturnType<typeof useGetAllProjectsLazyQuery>;
export type GetAllProjectsSuspenseQueryHookResult = ReturnType<typeof useGetAllProjectsSuspenseQuery>;
export type GetAllProjectsQueryResult = Apollo.QueryResult<GetAllProjectsQuery, GetAllProjectsQueryVariables>;
export const StandardAreaInstallationTableDocument = gql`
    query StandardAreaInstallationTable {
  standardAreaInstallations {
    id
    area {
      id
      name
      displayName
    }
    subArea {
      id
      name
      displayName
    }
    type {
      id
      name
      displayName
    }
    name
    displayName
    milestone {
      id
      title
    }
  }
}
    `;

/**
 * __useStandardAreaInstallationTableQuery__
 *
 * To run a query within a React component, call `useStandardAreaInstallationTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useStandardAreaInstallationTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStandardAreaInstallationTableQuery({
 *   variables: {
 *   },
 * });
 */
export function useStandardAreaInstallationTableQuery(baseOptions?: Apollo.QueryHookOptions<StandardAreaInstallationTableQuery, StandardAreaInstallationTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StandardAreaInstallationTableQuery, StandardAreaInstallationTableQueryVariables>(StandardAreaInstallationTableDocument, options);
      }
export function useStandardAreaInstallationTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StandardAreaInstallationTableQuery, StandardAreaInstallationTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StandardAreaInstallationTableQuery, StandardAreaInstallationTableQueryVariables>(StandardAreaInstallationTableDocument, options);
        }
export function useStandardAreaInstallationTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StandardAreaInstallationTableQuery, StandardAreaInstallationTableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StandardAreaInstallationTableQuery, StandardAreaInstallationTableQueryVariables>(StandardAreaInstallationTableDocument, options);
        }
export type StandardAreaInstallationTableQueryHookResult = ReturnType<typeof useStandardAreaInstallationTableQuery>;
export type StandardAreaInstallationTableLazyQueryHookResult = ReturnType<typeof useStandardAreaInstallationTableLazyQuery>;
export type StandardAreaInstallationTableSuspenseQueryHookResult = ReturnType<typeof useStandardAreaInstallationTableSuspenseQuery>;
export type StandardAreaInstallationTableQueryResult = Apollo.QueryResult<StandardAreaInstallationTableQuery, StandardAreaInstallationTableQueryVariables>;
export const SuperAdminTableDocument = gql`
    query SuperAdminTable($options: Query_Persons_OptionsInput!) {
  persons(options: $options) {
    id
    profilePicture {
      ...apiFileFields
    }
    firstName
    lastName
    createdTimestamp
    phoneNumber
    isActive
    preferredEmail
    fullName @client
  }
}
    ${ApiFileFieldsFragmentDoc}`;

/**
 * __useSuperAdminTableQuery__
 *
 * To run a query within a React component, call `useSuperAdminTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperAdminTableQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useSuperAdminTableQuery(baseOptions: Apollo.QueryHookOptions<SuperAdminTableQuery, SuperAdminTableQueryVariables> & ({ variables: SuperAdminTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperAdminTableQuery, SuperAdminTableQueryVariables>(SuperAdminTableDocument, options);
      }
export function useSuperAdminTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperAdminTableQuery, SuperAdminTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperAdminTableQuery, SuperAdminTableQueryVariables>(SuperAdminTableDocument, options);
        }
export function useSuperAdminTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuperAdminTableQuery, SuperAdminTableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuperAdminTableQuery, SuperAdminTableQueryVariables>(SuperAdminTableDocument, options);
        }
export type SuperAdminTableQueryHookResult = ReturnType<typeof useSuperAdminTableQuery>;
export type SuperAdminTableLazyQueryHookResult = ReturnType<typeof useSuperAdminTableLazyQuery>;
export type SuperAdminTableSuspenseQueryHookResult = ReturnType<typeof useSuperAdminTableSuspenseQuery>;
export type SuperAdminTableQueryResult = Apollo.QueryResult<SuperAdminTableQuery, SuperAdminTableQueryVariables>;
export const TaskTableDocument = gql`
    query TaskTable($id: ID!) {
  project(id: $id) {
    id
    overdueTasks @client {
      id
      dueDate
    }
    completedTasks @client {
      id
      dueDate
    }
    dueTasks @client {
      id
      dueDate
    }
    tasks {
      ...taskTableQueryFields
    }
  }
}
    ${TaskTableQueryFieldsFragmentDoc}`;

/**
 * __useTaskTableQuery__
 *
 * To run a query within a React component, call `useTaskTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskTableQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskTableQuery(baseOptions: Apollo.QueryHookOptions<TaskTableQuery, TaskTableQueryVariables> & ({ variables: TaskTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskTableQuery, TaskTableQueryVariables>(TaskTableDocument, options);
      }
export function useTaskTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskTableQuery, TaskTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskTableQuery, TaskTableQueryVariables>(TaskTableDocument, options);
        }
export function useTaskTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskTableQuery, TaskTableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaskTableQuery, TaskTableQueryVariables>(TaskTableDocument, options);
        }
export type TaskTableQueryHookResult = ReturnType<typeof useTaskTableQuery>;
export type TaskTableLazyQueryHookResult = ReturnType<typeof useTaskTableLazyQuery>;
export type TaskTableSuspenseQueryHookResult = ReturnType<typeof useTaskTableSuspenseQuery>;
export type TaskTableQueryResult = Apollo.QueryResult<TaskTableQuery, TaskTableQueryVariables>;
export const FolderListSectionDocument = gql`
    query FolderListSection($options: Query_Folders_OptionsInput!) {
  folders(options: $options) {
    id
    name
    fileCount
    createdTimestamp
    updatedTimestamp
    parent {
      id
    }
    documents {
      ...saveDocumentFields
    }
  }
}
    ${SaveDocumentFieldsFragmentDoc}`;

/**
 * __useFolderListSectionQuery__
 *
 * To run a query within a React component, call `useFolderListSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFolderListSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFolderListSectionQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useFolderListSectionQuery(baseOptions: Apollo.QueryHookOptions<FolderListSectionQuery, FolderListSectionQueryVariables> & ({ variables: FolderListSectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FolderListSectionQuery, FolderListSectionQueryVariables>(FolderListSectionDocument, options);
      }
export function useFolderListSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FolderListSectionQuery, FolderListSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FolderListSectionQuery, FolderListSectionQueryVariables>(FolderListSectionDocument, options);
        }
export function useFolderListSectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FolderListSectionQuery, FolderListSectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FolderListSectionQuery, FolderListSectionQueryVariables>(FolderListSectionDocument, options);
        }
export type FolderListSectionQueryHookResult = ReturnType<typeof useFolderListSectionQuery>;
export type FolderListSectionLazyQueryHookResult = ReturnType<typeof useFolderListSectionLazyQuery>;
export type FolderListSectionSuspenseQueryHookResult = ReturnType<typeof useFolderListSectionSuspenseQuery>;
export type FolderListSectionQueryResult = Apollo.QueryResult<FolderListSectionQuery, FolderListSectionQueryVariables>;
export const InstallationsSummaryMetricsSectionDocument = gql`
    query InstallationsSummaryMetricsSection($projectId: ID!) {
  project(id: $projectId) {
    id
    installations {
      id
      decisions {
        id
        dueDate
        approved
      }
    }
    installationsWithUpcomingDecisions @client {
      id
    }
    installationsWithOverDueDecisions @client {
      id
    }
    installationsWithAllDecisionsComplete @client {
      id
    }
    installationsWithDecisionsRemaining @client {
      id
    }
  }
}
    `;

/**
 * __useInstallationsSummaryMetricsSectionQuery__
 *
 * To run a query within a React component, call `useInstallationsSummaryMetricsSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstallationsSummaryMetricsSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstallationsSummaryMetricsSectionQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useInstallationsSummaryMetricsSectionQuery(baseOptions: Apollo.QueryHookOptions<InstallationsSummaryMetricsSectionQuery, InstallationsSummaryMetricsSectionQueryVariables> & ({ variables: InstallationsSummaryMetricsSectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InstallationsSummaryMetricsSectionQuery, InstallationsSummaryMetricsSectionQueryVariables>(InstallationsSummaryMetricsSectionDocument, options);
      }
export function useInstallationsSummaryMetricsSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InstallationsSummaryMetricsSectionQuery, InstallationsSummaryMetricsSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InstallationsSummaryMetricsSectionQuery, InstallationsSummaryMetricsSectionQueryVariables>(InstallationsSummaryMetricsSectionDocument, options);
        }
export function useInstallationsSummaryMetricsSectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InstallationsSummaryMetricsSectionQuery, InstallationsSummaryMetricsSectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InstallationsSummaryMetricsSectionQuery, InstallationsSummaryMetricsSectionQueryVariables>(InstallationsSummaryMetricsSectionDocument, options);
        }
export type InstallationsSummaryMetricsSectionQueryHookResult = ReturnType<typeof useInstallationsSummaryMetricsSectionQuery>;
export type InstallationsSummaryMetricsSectionLazyQueryHookResult = ReturnType<typeof useInstallationsSummaryMetricsSectionLazyQuery>;
export type InstallationsSummaryMetricsSectionSuspenseQueryHookResult = ReturnType<typeof useInstallationsSummaryMetricsSectionSuspenseQuery>;
export type InstallationsSummaryMetricsSectionQueryResult = Apollo.QueryResult<InstallationsSummaryMetricsSectionQuery, InstallationsSummaryMetricsSectionQueryVariables>;
export const TaskSummaryMetricsSectionDocument = gql`
    query TaskSummaryMetricsSection($id: ID!) {
  project(id: $id) {
    id
    overdueTasks @client {
      id
      dueDate
    }
    completedTasks @client {
      id
      dueDate
    }
    dueTasks @client {
      id
      dueDate
    }
    tasks {
      id
      dueDate
      createdAt
      isOverdue @client
      isComplete @client
      status {
        id
        name
        displayName
      }
    }
  }
}
    `;

/**
 * __useTaskSummaryMetricsSectionQuery__
 *
 * To run a query within a React component, call `useTaskSummaryMetricsSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskSummaryMetricsSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskSummaryMetricsSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskSummaryMetricsSectionQuery(baseOptions: Apollo.QueryHookOptions<TaskSummaryMetricsSectionQuery, TaskSummaryMetricsSectionQueryVariables> & ({ variables: TaskSummaryMetricsSectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskSummaryMetricsSectionQuery, TaskSummaryMetricsSectionQueryVariables>(TaskSummaryMetricsSectionDocument, options);
      }
export function useTaskSummaryMetricsSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskSummaryMetricsSectionQuery, TaskSummaryMetricsSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskSummaryMetricsSectionQuery, TaskSummaryMetricsSectionQueryVariables>(TaskSummaryMetricsSectionDocument, options);
        }
export function useTaskSummaryMetricsSectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskSummaryMetricsSectionQuery, TaskSummaryMetricsSectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaskSummaryMetricsSectionQuery, TaskSummaryMetricsSectionQueryVariables>(TaskSummaryMetricsSectionDocument, options);
        }
export type TaskSummaryMetricsSectionQueryHookResult = ReturnType<typeof useTaskSummaryMetricsSectionQuery>;
export type TaskSummaryMetricsSectionLazyQueryHookResult = ReturnType<typeof useTaskSummaryMetricsSectionLazyQuery>;
export type TaskSummaryMetricsSectionSuspenseQueryHookResult = ReturnType<typeof useTaskSummaryMetricsSectionSuspenseQuery>;
export type TaskSummaryMetricsSectionQueryResult = Apollo.QueryResult<TaskSummaryMetricsSectionQuery, TaskSummaryMetricsSectionQueryVariables>;
export const ClientReportDetailSectionDocument = gql`
    query ClientReportDetailSection($id: ID!) {
  clientReport(id: $id) {
    id
    deliveries {
      id
      notesForClient
      createdAt
      included
      receivedDate
      deliveryName
      attachments {
        ...apiFileFields
      }
    }
    inspections {
      id
      inspectionName
      inspectionResult {
        id
        name
        displayName
      }
      notesForClient
      createdAt
      inspector {
        id
        firstName
        lastName
        fullName @client
      }
      notesForClient
      included
    }
    photos {
      id
      attachment {
        ...apiFileFields
      }
      included
      notesForClient
    }
    milestones {
      id
      createdAt
      milestoneUpdated
      milestoneName
      notesForClient
      milestoneStatus {
        id
        name
        displayName
      }
      included
    }
    links {
      id
      createdAt
      notesForClient
      url
    }
    attachments {
      id
      createdAt
      attachment {
        ...apiFileFields
      }
    }
    createdAt
    updatedAt
    description
    startDate
    endDate
    approvedBy {
      id
      firstName
      lastName
      fullName @client
    }
    approvedAt
  }
}
    ${ApiFileFieldsFragmentDoc}`;

/**
 * __useClientReportDetailSectionQuery__
 *
 * To run a query within a React component, call `useClientReportDetailSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientReportDetailSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientReportDetailSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientReportDetailSectionQuery(baseOptions: Apollo.QueryHookOptions<ClientReportDetailSectionQuery, ClientReportDetailSectionQueryVariables> & ({ variables: ClientReportDetailSectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientReportDetailSectionQuery, ClientReportDetailSectionQueryVariables>(ClientReportDetailSectionDocument, options);
      }
export function useClientReportDetailSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientReportDetailSectionQuery, ClientReportDetailSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientReportDetailSectionQuery, ClientReportDetailSectionQueryVariables>(ClientReportDetailSectionDocument, options);
        }
export function useClientReportDetailSectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClientReportDetailSectionQuery, ClientReportDetailSectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientReportDetailSectionQuery, ClientReportDetailSectionQueryVariables>(ClientReportDetailSectionDocument, options);
        }
export type ClientReportDetailSectionQueryHookResult = ReturnType<typeof useClientReportDetailSectionQuery>;
export type ClientReportDetailSectionLazyQueryHookResult = ReturnType<typeof useClientReportDetailSectionLazyQuery>;
export type ClientReportDetailSectionSuspenseQueryHookResult = ReturnType<typeof useClientReportDetailSectionSuspenseQuery>;
export type ClientReportDetailSectionQueryResult = Apollo.QueryResult<ClientReportDetailSectionQuery, ClientReportDetailSectionQueryVariables>;
export const ClientReportHeaderSectionDocument = gql`
    query ClientReportHeaderSection($id: ID!) {
  clientReport(id: $id) @client {
    id
    approvedAt
    startDate
    endDate
  }
}
    `;

/**
 * __useClientReportHeaderSectionQuery__
 *
 * To run a query within a React component, call `useClientReportHeaderSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientReportHeaderSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientReportHeaderSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientReportHeaderSectionQuery(baseOptions: Apollo.QueryHookOptions<ClientReportHeaderSectionQuery, ClientReportHeaderSectionQueryVariables> & ({ variables: ClientReportHeaderSectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientReportHeaderSectionQuery, ClientReportHeaderSectionQueryVariables>(ClientReportHeaderSectionDocument, options);
      }
export function useClientReportHeaderSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientReportHeaderSectionQuery, ClientReportHeaderSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientReportHeaderSectionQuery, ClientReportHeaderSectionQueryVariables>(ClientReportHeaderSectionDocument, options);
        }
export function useClientReportHeaderSectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClientReportHeaderSectionQuery, ClientReportHeaderSectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientReportHeaderSectionQuery, ClientReportHeaderSectionQueryVariables>(ClientReportHeaderSectionDocument, options);
        }
export type ClientReportHeaderSectionQueryHookResult = ReturnType<typeof useClientReportHeaderSectionQuery>;
export type ClientReportHeaderSectionLazyQueryHookResult = ReturnType<typeof useClientReportHeaderSectionLazyQuery>;
export type ClientReportHeaderSectionSuspenseQueryHookResult = ReturnType<typeof useClientReportHeaderSectionSuspenseQuery>;
export type ClientReportHeaderSectionQueryResult = Apollo.QueryResult<ClientReportHeaderSectionQuery, ClientReportHeaderSectionQueryVariables>;
export const DailyReportDetailSectionDocument = gql`
    query DailyReportDetailSection($id: ID!) {
  dailyReport(id: $id) {
    id
    description
    reportDate
    approvedAt
    approvedBy {
      id
      firstName
      lastName
      fullName @client
    }
    inspections {
      id
      createdAt
      inspectedSystem
      dateInspected
      inspectedBy {
        id
        firstName
        lastName
        fullName @client
      }
      description
      inspectionResult {
        id
        name
        displayName
      }
    }
    incidents {
      id
      createdOn
      issueDate
      personsInvolved {
        id
        firstName
        lastName
        profilePicture {
          ...apiFileFields
        }
        fullName @client
      }
      description
    }
    photos {
      id
      apiFile {
        ...apiFileFields
      }
    }
    deliveries {
      id
      attachments {
        ...apiFileFields
      }
      createdTimestamp
      receivedDate
      name
      description
      quantity
      damageDescription
      issueDescription
      otherDescription
    }
    workLog {
      id
      dateWorked
      onSiteSubContractors
      trade {
        id
        name
        displayName
      }
      description
      person {
        id
        firstName
        lastName
        fullName @client
      }
      hoursWorked
    }
  }
}
    ${ApiFileFieldsFragmentDoc}`;

/**
 * __useDailyReportDetailSectionQuery__
 *
 * To run a query within a React component, call `useDailyReportDetailSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyReportDetailSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyReportDetailSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDailyReportDetailSectionQuery(baseOptions: Apollo.QueryHookOptions<DailyReportDetailSectionQuery, DailyReportDetailSectionQueryVariables> & ({ variables: DailyReportDetailSectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DailyReportDetailSectionQuery, DailyReportDetailSectionQueryVariables>(DailyReportDetailSectionDocument, options);
      }
export function useDailyReportDetailSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DailyReportDetailSectionQuery, DailyReportDetailSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DailyReportDetailSectionQuery, DailyReportDetailSectionQueryVariables>(DailyReportDetailSectionDocument, options);
        }
export function useDailyReportDetailSectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DailyReportDetailSectionQuery, DailyReportDetailSectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DailyReportDetailSectionQuery, DailyReportDetailSectionQueryVariables>(DailyReportDetailSectionDocument, options);
        }
export type DailyReportDetailSectionQueryHookResult = ReturnType<typeof useDailyReportDetailSectionQuery>;
export type DailyReportDetailSectionLazyQueryHookResult = ReturnType<typeof useDailyReportDetailSectionLazyQuery>;
export type DailyReportDetailSectionSuspenseQueryHookResult = ReturnType<typeof useDailyReportDetailSectionSuspenseQuery>;
export type DailyReportDetailSectionQueryResult = Apollo.QueryResult<DailyReportDetailSectionQuery, DailyReportDetailSectionQueryVariables>;
export const DailyReportHeaderSectionDocument = gql`
    query DailyReportHeaderSection($options: Query_DailyReports_OptionsInput!) {
  dailyReports(options: $options) {
    id
    reportDate
    approvedAt
    project {
      id
      name
      locationAddress {
        ...addressFields
      }
    }
    weather {
      id
      condition {
        id
        name
        displayName
      }
      precipitationType {
        id
        name
        displayName
      }
      precipitationAmount
      temperatureMax
      temperatureMin
    }
    numberOfInspections @client
    numberOfIncidents @client
  }
}
    ${AddressFieldsFragmentDoc}`;

/**
 * __useDailyReportHeaderSectionQuery__
 *
 * To run a query within a React component, call `useDailyReportHeaderSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyReportHeaderSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyReportHeaderSectionQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useDailyReportHeaderSectionQuery(baseOptions: Apollo.QueryHookOptions<DailyReportHeaderSectionQuery, DailyReportHeaderSectionQueryVariables> & ({ variables: DailyReportHeaderSectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DailyReportHeaderSectionQuery, DailyReportHeaderSectionQueryVariables>(DailyReportHeaderSectionDocument, options);
      }
export function useDailyReportHeaderSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DailyReportHeaderSectionQuery, DailyReportHeaderSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DailyReportHeaderSectionQuery, DailyReportHeaderSectionQueryVariables>(DailyReportHeaderSectionDocument, options);
        }
export function useDailyReportHeaderSectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DailyReportHeaderSectionQuery, DailyReportHeaderSectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DailyReportHeaderSectionQuery, DailyReportHeaderSectionQueryVariables>(DailyReportHeaderSectionDocument, options);
        }
export type DailyReportHeaderSectionQueryHookResult = ReturnType<typeof useDailyReportHeaderSectionQuery>;
export type DailyReportHeaderSectionLazyQueryHookResult = ReturnType<typeof useDailyReportHeaderSectionLazyQuery>;
export type DailyReportHeaderSectionSuspenseQueryHookResult = ReturnType<typeof useDailyReportHeaderSectionSuspenseQuery>;
export type DailyReportHeaderSectionQueryResult = Apollo.QueryResult<DailyReportHeaderSectionQuery, DailyReportHeaderSectionQueryVariables>;
export const DailyReportsHeaderSectionDocument = gql`
    query DailyReportsHeaderSection($options: Query_DailyReports_OptionsInput!) {
  dailyReports(options: $options) {
    id
    numberOfIncidents @client
    numberOfDeliveries @client
    numberOfInspections @client
    numberOfWorkEvents @client
  }
}
    `;

/**
 * __useDailyReportsHeaderSectionQuery__
 *
 * To run a query within a React component, call `useDailyReportsHeaderSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyReportsHeaderSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyReportsHeaderSectionQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useDailyReportsHeaderSectionQuery(baseOptions: Apollo.QueryHookOptions<DailyReportsHeaderSectionQuery, DailyReportsHeaderSectionQueryVariables> & ({ variables: DailyReportsHeaderSectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DailyReportsHeaderSectionQuery, DailyReportsHeaderSectionQueryVariables>(DailyReportsHeaderSectionDocument, options);
      }
export function useDailyReportsHeaderSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DailyReportsHeaderSectionQuery, DailyReportsHeaderSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DailyReportsHeaderSectionQuery, DailyReportsHeaderSectionQueryVariables>(DailyReportsHeaderSectionDocument, options);
        }
export function useDailyReportsHeaderSectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DailyReportsHeaderSectionQuery, DailyReportsHeaderSectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DailyReportsHeaderSectionQuery, DailyReportsHeaderSectionQueryVariables>(DailyReportsHeaderSectionDocument, options);
        }
export type DailyReportsHeaderSectionQueryHookResult = ReturnType<typeof useDailyReportsHeaderSectionQuery>;
export type DailyReportsHeaderSectionLazyQueryHookResult = ReturnType<typeof useDailyReportsHeaderSectionLazyQuery>;
export type DailyReportsHeaderSectionSuspenseQueryHookResult = ReturnType<typeof useDailyReportsHeaderSectionSuspenseQuery>;
export type DailyReportsHeaderSectionQueryResult = Apollo.QueryResult<DailyReportsHeaderSectionQuery, DailyReportsHeaderSectionQueryVariables>;
export const ExternalFolderHeaderSectionDocument = gql`
    query ExternalFolderHeaderSection($folderId: ID!) {
  folder(id: $folderId) {
    id
    name
    project {
      id
      locationAddress {
        ...addressFields
      }
    }
  }
}
    ${AddressFieldsFragmentDoc}`;

/**
 * __useExternalFolderHeaderSectionQuery__
 *
 * To run a query within a React component, call `useExternalFolderHeaderSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalFolderHeaderSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalFolderHeaderSectionQuery({
 *   variables: {
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useExternalFolderHeaderSectionQuery(baseOptions: Apollo.QueryHookOptions<ExternalFolderHeaderSectionQuery, ExternalFolderHeaderSectionQueryVariables> & ({ variables: ExternalFolderHeaderSectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExternalFolderHeaderSectionQuery, ExternalFolderHeaderSectionQueryVariables>(ExternalFolderHeaderSectionDocument, options);
      }
export function useExternalFolderHeaderSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExternalFolderHeaderSectionQuery, ExternalFolderHeaderSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExternalFolderHeaderSectionQuery, ExternalFolderHeaderSectionQueryVariables>(ExternalFolderHeaderSectionDocument, options);
        }
export function useExternalFolderHeaderSectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExternalFolderHeaderSectionQuery, ExternalFolderHeaderSectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExternalFolderHeaderSectionQuery, ExternalFolderHeaderSectionQueryVariables>(ExternalFolderHeaderSectionDocument, options);
        }
export type ExternalFolderHeaderSectionQueryHookResult = ReturnType<typeof useExternalFolderHeaderSectionQuery>;
export type ExternalFolderHeaderSectionLazyQueryHookResult = ReturnType<typeof useExternalFolderHeaderSectionLazyQuery>;
export type ExternalFolderHeaderSectionSuspenseQueryHookResult = ReturnType<typeof useExternalFolderHeaderSectionSuspenseQuery>;
export type ExternalFolderHeaderSectionQueryResult = Apollo.QueryResult<ExternalFolderHeaderSectionQuery, ExternalFolderHeaderSectionQueryVariables>;
export const FileDetailSectionDocument = gql`
    query FileDetailSection($id: ID!) {
  document(id: $id) {
    ...saveDocumentFields
  }
}
    ${SaveDocumentFieldsFragmentDoc}`;

/**
 * __useFileDetailSectionQuery__
 *
 * To run a query within a React component, call `useFileDetailSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileDetailSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileDetailSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFileDetailSectionQuery(baseOptions: Apollo.QueryHookOptions<FileDetailSectionQuery, FileDetailSectionQueryVariables> & ({ variables: FileDetailSectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FileDetailSectionQuery, FileDetailSectionQueryVariables>(FileDetailSectionDocument, options);
      }
export function useFileDetailSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FileDetailSectionQuery, FileDetailSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FileDetailSectionQuery, FileDetailSectionQueryVariables>(FileDetailSectionDocument, options);
        }
export function useFileDetailSectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FileDetailSectionQuery, FileDetailSectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FileDetailSectionQuery, FileDetailSectionQueryVariables>(FileDetailSectionDocument, options);
        }
export type FileDetailSectionQueryHookResult = ReturnType<typeof useFileDetailSectionQuery>;
export type FileDetailSectionLazyQueryHookResult = ReturnType<typeof useFileDetailSectionLazyQuery>;
export type FileDetailSectionSuspenseQueryHookResult = ReturnType<typeof useFileDetailSectionSuspenseQuery>;
export type FileDetailSectionQueryResult = Apollo.QueryResult<FileDetailSectionQuery, FileDetailSectionQueryVariables>;
export const FolderHeaderSectionDocument = gql`
    query FolderHeaderSection($id: ID!) {
  folder(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useFolderHeaderSectionQuery__
 *
 * To run a query within a React component, call `useFolderHeaderSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFolderHeaderSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFolderHeaderSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFolderHeaderSectionQuery(baseOptions: Apollo.QueryHookOptions<FolderHeaderSectionQuery, FolderHeaderSectionQueryVariables> & ({ variables: FolderHeaderSectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FolderHeaderSectionQuery, FolderHeaderSectionQueryVariables>(FolderHeaderSectionDocument, options);
      }
export function useFolderHeaderSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FolderHeaderSectionQuery, FolderHeaderSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FolderHeaderSectionQuery, FolderHeaderSectionQueryVariables>(FolderHeaderSectionDocument, options);
        }
export function useFolderHeaderSectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FolderHeaderSectionQuery, FolderHeaderSectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FolderHeaderSectionQuery, FolderHeaderSectionQueryVariables>(FolderHeaderSectionDocument, options);
        }
export type FolderHeaderSectionQueryHookResult = ReturnType<typeof useFolderHeaderSectionQuery>;
export type FolderHeaderSectionLazyQueryHookResult = ReturnType<typeof useFolderHeaderSectionLazyQuery>;
export type FolderHeaderSectionSuspenseQueryHookResult = ReturnType<typeof useFolderHeaderSectionSuspenseQuery>;
export type FolderHeaderSectionQueryResult = Apollo.QueryResult<FolderHeaderSectionQuery, FolderHeaderSectionQueryVariables>;
export const PlanDetailSectionDocument = gql`
    query PlanDetailSection($id: ID!) {
  plan(id: $id) {
    id
    createdDate
    updatedDate
    name
    versions {
      ...planVersionFields
      id
      createdTimestamp
      updatedTimestamp
      uploadedBy {
        id
        firstName
        lastName
        fullName @client
      }
      file {
        ...apiFileFields
      }
    }
    annotations {
      id
      type {
        id
        name
        displayName
      }
      color
      page {
        pageNumber
        height
        width
      }
      relatedId
      points {
        id
        x
        y
      }
      width
    }
    documents {
      id
      title
      createdTimestamp
      updatedTimestamp
      uploadedBy {
        id
        firstName
        lastName
        fullName @client
      }
    }
    tasks {
      id
      area {
        id
        name
        displayName
      }
      category {
        id
        name
        displayName
      }
      dueDate
      description
      name
    }
  }
}
    ${PlanVersionFieldsFragmentDoc}
${ApiFileFieldsFragmentDoc}`;

/**
 * __usePlanDetailSectionQuery__
 *
 * To run a query within a React component, call `usePlanDetailSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanDetailSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanDetailSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlanDetailSectionQuery(baseOptions: Apollo.QueryHookOptions<PlanDetailSectionQuery, PlanDetailSectionQueryVariables> & ({ variables: PlanDetailSectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanDetailSectionQuery, PlanDetailSectionQueryVariables>(PlanDetailSectionDocument, options);
      }
export function usePlanDetailSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanDetailSectionQuery, PlanDetailSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanDetailSectionQuery, PlanDetailSectionQueryVariables>(PlanDetailSectionDocument, options);
        }
export function usePlanDetailSectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlanDetailSectionQuery, PlanDetailSectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlanDetailSectionQuery, PlanDetailSectionQueryVariables>(PlanDetailSectionDocument, options);
        }
export type PlanDetailSectionQueryHookResult = ReturnType<typeof usePlanDetailSectionQuery>;
export type PlanDetailSectionLazyQueryHookResult = ReturnType<typeof usePlanDetailSectionLazyQuery>;
export type PlanDetailSectionSuspenseQueryHookResult = ReturnType<typeof usePlanDetailSectionSuspenseQuery>;
export type PlanDetailSectionQueryResult = Apollo.QueryResult<PlanDetailSectionQuery, PlanDetailSectionQueryVariables>;
export const PlanSetHeaderSectionDocument = gql`
    query PlanSetHeaderSection($id: ID!) {
  planSet(id: $id) {
    id
    name
    displayName
  }
}
    `;

/**
 * __usePlanSetHeaderSectionQuery__
 *
 * To run a query within a React component, call `usePlanSetHeaderSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanSetHeaderSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanSetHeaderSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlanSetHeaderSectionQuery(baseOptions: Apollo.QueryHookOptions<PlanSetHeaderSectionQuery, PlanSetHeaderSectionQueryVariables> & ({ variables: PlanSetHeaderSectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanSetHeaderSectionQuery, PlanSetHeaderSectionQueryVariables>(PlanSetHeaderSectionDocument, options);
      }
export function usePlanSetHeaderSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanSetHeaderSectionQuery, PlanSetHeaderSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanSetHeaderSectionQuery, PlanSetHeaderSectionQueryVariables>(PlanSetHeaderSectionDocument, options);
        }
export function usePlanSetHeaderSectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlanSetHeaderSectionQuery, PlanSetHeaderSectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlanSetHeaderSectionQuery, PlanSetHeaderSectionQueryVariables>(PlanSetHeaderSectionDocument, options);
        }
export type PlanSetHeaderSectionQueryHookResult = ReturnType<typeof usePlanSetHeaderSectionQuery>;
export type PlanSetHeaderSectionLazyQueryHookResult = ReturnType<typeof usePlanSetHeaderSectionLazyQuery>;
export type PlanSetHeaderSectionSuspenseQueryHookResult = ReturnType<typeof usePlanSetHeaderSectionSuspenseQuery>;
export type PlanSetHeaderSectionQueryResult = Apollo.QueryResult<PlanSetHeaderSectionQuery, PlanSetHeaderSectionQueryVariables>;
export const SendTestNotificationToSelfDocument = gql`
    mutation SendTestNotificationToSelf {
  notification_createTestForSelf {
    id
    isRead
    title
    content
    createdTimestamp
  }
}
    `;
export type SendTestNotificationToSelfMutationFn = Apollo.MutationFunction<SendTestNotificationToSelfMutation, SendTestNotificationToSelfMutationVariables>;

/**
 * __useSendTestNotificationToSelfMutation__
 *
 * To run a mutation, you first call `useSendTestNotificationToSelfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestNotificationToSelfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestNotificationToSelfMutation, { data, loading, error }] = useSendTestNotificationToSelfMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendTestNotificationToSelfMutation(baseOptions?: Apollo.MutationHookOptions<SendTestNotificationToSelfMutation, SendTestNotificationToSelfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTestNotificationToSelfMutation, SendTestNotificationToSelfMutationVariables>(SendTestNotificationToSelfDocument, options);
      }
export type SendTestNotificationToSelfMutationHookResult = ReturnType<typeof useSendTestNotificationToSelfMutation>;
export type SendTestNotificationToSelfMutationResult = Apollo.MutationResult<SendTestNotificationToSelfMutation>;
export type SendTestNotificationToSelfMutationOptions = Apollo.BaseMutationOptions<SendTestNotificationToSelfMutation, SendTestNotificationToSelfMutationVariables>;
export const GetInstallationHeaderMetricsDocument = gql`
    query GetInstallationHeaderMetrics($projectId: ID!) {
  project(id: $projectId) {
    id
    installations {
      id
      name
      roomName
      decisions {
        id
        dueDate
        approved
      }
    }
    installationsWithUpcomingDecisions @client {
      id
    }
    installationsWithOverDueDecisions @client {
      id
    }
    installationsWithAllDecisionsComplete @client {
      id
    }
    installationsWithDecisionsRemaining @client {
      id
    }
  }
}
    `;

/**
 * __useGetInstallationHeaderMetricsQuery__
 *
 * To run a query within a React component, call `useGetInstallationHeaderMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstallationHeaderMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstallationHeaderMetricsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetInstallationHeaderMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetInstallationHeaderMetricsQuery, GetInstallationHeaderMetricsQueryVariables> & ({ variables: GetInstallationHeaderMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstallationHeaderMetricsQuery, GetInstallationHeaderMetricsQueryVariables>(GetInstallationHeaderMetricsDocument, options);
      }
export function useGetInstallationHeaderMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstallationHeaderMetricsQuery, GetInstallationHeaderMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstallationHeaderMetricsQuery, GetInstallationHeaderMetricsQueryVariables>(GetInstallationHeaderMetricsDocument, options);
        }
export function useGetInstallationHeaderMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInstallationHeaderMetricsQuery, GetInstallationHeaderMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInstallationHeaderMetricsQuery, GetInstallationHeaderMetricsQueryVariables>(GetInstallationHeaderMetricsDocument, options);
        }
export type GetInstallationHeaderMetricsQueryHookResult = ReturnType<typeof useGetInstallationHeaderMetricsQuery>;
export type GetInstallationHeaderMetricsLazyQueryHookResult = ReturnType<typeof useGetInstallationHeaderMetricsLazyQuery>;
export type GetInstallationHeaderMetricsSuspenseQueryHookResult = ReturnType<typeof useGetInstallationHeaderMetricsSuspenseQuery>;
export type GetInstallationHeaderMetricsQueryResult = Apollo.QueryResult<GetInstallationHeaderMetricsQuery, GetInstallationHeaderMetricsQueryVariables>;
export const MilestoneDetailSectionDocument = gql`
    query MilestoneDetailSection($id: ID!) {
  milestone(id: $id) {
    id
    title
    description
    startDate
    endDate
    durationInDays
    auditLog {
      id
      createdTimestamp
      title
      description
      createdBy {
        id
        firstName
        lastName
        fullName @client
      }
    }
    status {
      id
      name
      displayName
    }
  }
}
    `;

/**
 * __useMilestoneDetailSectionQuery__
 *
 * To run a query within a React component, call `useMilestoneDetailSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useMilestoneDetailSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMilestoneDetailSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMilestoneDetailSectionQuery(baseOptions: Apollo.QueryHookOptions<MilestoneDetailSectionQuery, MilestoneDetailSectionQueryVariables> & ({ variables: MilestoneDetailSectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MilestoneDetailSectionQuery, MilestoneDetailSectionQueryVariables>(MilestoneDetailSectionDocument, options);
      }
export function useMilestoneDetailSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MilestoneDetailSectionQuery, MilestoneDetailSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MilestoneDetailSectionQuery, MilestoneDetailSectionQueryVariables>(MilestoneDetailSectionDocument, options);
        }
export function useMilestoneDetailSectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MilestoneDetailSectionQuery, MilestoneDetailSectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MilestoneDetailSectionQuery, MilestoneDetailSectionQueryVariables>(MilestoneDetailSectionDocument, options);
        }
export type MilestoneDetailSectionQueryHookResult = ReturnType<typeof useMilestoneDetailSectionQuery>;
export type MilestoneDetailSectionLazyQueryHookResult = ReturnType<typeof useMilestoneDetailSectionLazyQuery>;
export type MilestoneDetailSectionSuspenseQueryHookResult = ReturnType<typeof useMilestoneDetailSectionSuspenseQuery>;
export type MilestoneDetailSectionQueryResult = Apollo.QueryResult<MilestoneDetailSectionQuery, MilestoneDetailSectionQueryVariables>;
export const MileStoneHeaderSectionDocument = gql`
    query MileStoneHeaderSection($id: ID!) {
  milestone(id: $id) @client {
    id
    title
    description
  }
}
    `;

/**
 * __useMileStoneHeaderSectionQuery__
 *
 * To run a query within a React component, call `useMileStoneHeaderSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useMileStoneHeaderSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMileStoneHeaderSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMileStoneHeaderSectionQuery(baseOptions: Apollo.QueryHookOptions<MileStoneHeaderSectionQuery, MileStoneHeaderSectionQueryVariables> & ({ variables: MileStoneHeaderSectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MileStoneHeaderSectionQuery, MileStoneHeaderSectionQueryVariables>(MileStoneHeaderSectionDocument, options);
      }
export function useMileStoneHeaderSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MileStoneHeaderSectionQuery, MileStoneHeaderSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MileStoneHeaderSectionQuery, MileStoneHeaderSectionQueryVariables>(MileStoneHeaderSectionDocument, options);
        }
export function useMileStoneHeaderSectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MileStoneHeaderSectionQuery, MileStoneHeaderSectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MileStoneHeaderSectionQuery, MileStoneHeaderSectionQueryVariables>(MileStoneHeaderSectionDocument, options);
        }
export type MileStoneHeaderSectionQueryHookResult = ReturnType<typeof useMileStoneHeaderSectionQuery>;
export type MileStoneHeaderSectionLazyQueryHookResult = ReturnType<typeof useMileStoneHeaderSectionLazyQuery>;
export type MileStoneHeaderSectionSuspenseQueryHookResult = ReturnType<typeof useMileStoneHeaderSectionSuspenseQuery>;
export type MileStoneHeaderSectionQueryResult = Apollo.QueryResult<MileStoneHeaderSectionQuery, MileStoneHeaderSectionQueryVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Node": [
      "Folder"
    ],
    "Page": []
  }
};
      export default result;
    